export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Action = {
  __typename?: "Action";
  code: Scalars["String"];
  name: Scalars["String"];
};

export type AffectedRowsOutput = {
  __typename?: "AffectedRowsOutput";
  count: Scalars["Int"];
};

export type AggregateCaveat = {
  __typename?: "AggregateCaveat";
  _count?: Maybe<CaveatCountAggregate>;
  _min?: Maybe<CaveatMinAggregate>;
  _max?: Maybe<CaveatMaxAggregate>;
};

export type AggregateCompany = {
  __typename?: "AggregateCompany";
  _count?: Maybe<CompanyCountAggregate>;
  _min?: Maybe<CompanyMinAggregate>;
  _max?: Maybe<CompanyMaxAggregate>;
};

export type AggregateCompanyDefaultValue = {
  __typename?: "AggregateCompanyDefaultValue";
  _count?: Maybe<CompanyDefaultValueCountAggregate>;
  _min?: Maybe<CompanyDefaultValueMinAggregate>;
  _max?: Maybe<CompanyDefaultValueMaxAggregate>;
};

export type AggregateDeliveryNote = {
  __typename?: "AggregateDeliveryNote";
  _count?: Maybe<DeliveryNoteCountAggregate>;
  _avg?: Maybe<DeliveryNoteAvgAggregate>;
  _sum?: Maybe<DeliveryNoteSumAggregate>;
  _min?: Maybe<DeliveryNoteMinAggregate>;
  _max?: Maybe<DeliveryNoteMaxAggregate>;
};

export type AggregateDeliveryNoteDocument = {
  __typename?: "AggregateDeliveryNoteDocument";
  _count?: Maybe<DeliveryNoteDocumentCountAggregate>;
  _min?: Maybe<DeliveryNoteDocumentMinAggregate>;
  _max?: Maybe<DeliveryNoteDocumentMaxAggregate>;
};

export type AggregateDeliveryNoteLoadingUnit = {
  __typename?: "AggregateDeliveryNoteLoadingUnit";
  _count?: Maybe<DeliveryNoteLoadingUnitCountAggregate>;
  _avg?: Maybe<DeliveryNoteLoadingUnitAvgAggregate>;
  _sum?: Maybe<DeliveryNoteLoadingUnitSumAggregate>;
  _min?: Maybe<DeliveryNoteLoadingUnitMinAggregate>;
  _max?: Maybe<DeliveryNoteLoadingUnitMaxAggregate>;
};

export type AggregateLoadingUnit = {
  __typename?: "AggregateLoadingUnit";
  _count?: Maybe<LoadingUnitCountAggregate>;
  _min?: Maybe<LoadingUnitMinAggregate>;
  _max?: Maybe<LoadingUnitMaxAggregate>;
};

export type AggregateLocation = {
  __typename?: "AggregateLocation";
  _count?: Maybe<LocationCountAggregate>;
  _avg?: Maybe<LocationAvgAggregate>;
  _sum?: Maybe<LocationSumAggregate>;
  _min?: Maybe<LocationMinAggregate>;
  _max?: Maybe<LocationMaxAggregate>;
};

export type AggregateOrder = {
  __typename?: "AggregateOrder";
  _count?: Maybe<OrderCountAggregate>;
  _avg?: Maybe<OrderAvgAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
};

export type AggregateOrderTrip = {
  __typename?: "AggregateOrderTrip";
  _count?: Maybe<OrderTripCountAggregate>;
  _avg?: Maybe<OrderTripAvgAggregate>;
  _sum?: Maybe<OrderTripSumAggregate>;
  _min?: Maybe<OrderTripMinAggregate>;
  _max?: Maybe<OrderTripMaxAggregate>;
};

export type AggregateSscc = {
  __typename?: "AggregateSscc";
  _count?: Maybe<SsccCountAggregate>;
  _min?: Maybe<SsccMinAggregate>;
  _max?: Maybe<SsccMaxAggregate>;
};

export type AggregateUser = {
  __typename?: "AggregateUser";
  _count?: Maybe<UserCountAggregate>;
  _min?: Maybe<UserMinAggregate>;
  _max?: Maybe<UserMaxAggregate>;
};

export type AggregateUserDefaultValue = {
  __typename?: "AggregateUserDefaultValue";
  _count?: Maybe<UserDefaultValueCountAggregate>;
  _min?: Maybe<UserDefaultValueMinAggregate>;
  _max?: Maybe<UserDefaultValueMaxAggregate>;
};

export type AggregateUserRelCompany = {
  __typename?: "AggregateUserRelCompany";
  _count?: Maybe<UserRelCompanyCountAggregate>;
  _min?: Maybe<UserRelCompanyMinAggregate>;
  _max?: Maybe<UserRelCompanyMaxAggregate>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: Maybe<Scalars["Boolean"]>;
};

export type BoolFilter = {
  equals?: Maybe<Scalars["Boolean"]>;
  not?: Maybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: Maybe<Scalars["Boolean"]>;
  not?: Maybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  equals?: Maybe<Scalars["Boolean"]>;
  not?: Maybe<NestedBoolNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedBoolNullableFilter>;
  _max?: Maybe<NestedBoolNullableFilter>;
};

export type BoolWithAggregatesFilter = {
  equals?: Maybe<Scalars["Boolean"]>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedBoolFilter>;
  _max?: Maybe<NestedBoolFilter>;
};

export type Caveat = {
  __typename?: "Caveat";
  id: Scalars["String"];
  orderId: Scalars["String"];
  name: Scalars["String"];
  note?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  createdBy?: Maybe<Scalars["String"]>;
  order: Order;
};

export type CaveatCountAggregate = {
  __typename?: "CaveatCountAggregate";
  id: Scalars["Int"];
  orderId: Scalars["Int"];
  name: Scalars["Int"];
  note: Scalars["Int"];
  createdAt: Scalars["Int"];
  createdBy: Scalars["Int"];
  _all: Scalars["Int"];
};

export type CaveatCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdBy?: Maybe<SortOrder>;
};

export type CaveatCreateInput = {
  id?: Maybe<Scalars["String"]>;
  order: OrderCreateNestedOneWithoutCaveatsInput;
  name: Scalars["String"];
  note?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
};

export type CaveatCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  orderId: Scalars["String"];
  name: Scalars["String"];
  note?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
};

export type CaveatCreateManyOrderInput = {
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  note?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
};

export type CaveatCreateManyOrderInputEnvelope = {
  data: Array<CaveatCreateManyOrderInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type CaveatCreateNestedManyWithoutOrderInput = {
  create?: Maybe<Array<CaveatCreateWithoutOrderInput>>;
  connectOrCreate?: Maybe<Array<CaveatCreateOrConnectWithoutOrderInput>>;
  createMany?: Maybe<CaveatCreateManyOrderInputEnvelope>;
  connect?: Maybe<Array<CaveatWhereUniqueInput>>;
};

export type CaveatCreateOrConnectWithoutOrderInput = {
  where: CaveatWhereUniqueInput;
  create: CaveatCreateWithoutOrderInput;
};

export type CaveatCreateWithoutOrderInput = {
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  note?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
};

export type CaveatGroupBy = {
  __typename?: "CaveatGroupBy";
  id: Scalars["String"];
  orderId: Scalars["String"];
  name: Scalars["String"];
  note?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  createdBy?: Maybe<Scalars["String"]>;
  _count?: Maybe<CaveatCountAggregate>;
  _min?: Maybe<CaveatMinAggregate>;
  _max?: Maybe<CaveatMaxAggregate>;
};

export type CaveatListRelationFilter = {
  every?: Maybe<CaveatWhereInput>;
  some?: Maybe<CaveatWhereInput>;
  none?: Maybe<CaveatWhereInput>;
};

export type CaveatMaxAggregate = {
  __typename?: "CaveatMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
};

export type CaveatMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdBy?: Maybe<SortOrder>;
};

export type CaveatMinAggregate = {
  __typename?: "CaveatMinAggregate";
  id?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
};

export type CaveatMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdBy?: Maybe<SortOrder>;
};

export type CaveatOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CaveatOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdBy?: Maybe<SortOrder>;
  _count?: Maybe<CaveatCountOrderByAggregateInput>;
  _max?: Maybe<CaveatMaxOrderByAggregateInput>;
  _min?: Maybe<CaveatMinOrderByAggregateInput>;
};

export type CaveatOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  order?: Maybe<OrderOrderByWithRelationInput>;
  orderId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  createdBy?: Maybe<SortOrder>;
};

export enum CaveatScalarFieldEnum {
  Id = "id",
  OrderId = "orderId",
  Name = "name",
  Note = "note",
  CreatedAt = "createdAt",
  CreatedBy = "createdBy",
}

export type CaveatScalarWhereInput = {
  AND?: Maybe<Array<CaveatScalarWhereInput>>;
  OR?: Maybe<Array<CaveatScalarWhereInput>>;
  NOT?: Maybe<Array<CaveatScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  orderId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  note?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdBy?: Maybe<StringNullableFilter>;
};

export type CaveatScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CaveatScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CaveatScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CaveatScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  orderId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  note?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  createdBy?: Maybe<StringNullableWithAggregatesFilter>;
};

export type CaveatUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  order?: Maybe<OrderUpdateOneRequiredWithoutCaveatsNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type CaveatUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type CaveatUpdateManyWithWhereWithoutOrderInput = {
  where: CaveatScalarWhereInput;
  data: CaveatUpdateManyMutationInput;
};

export type CaveatUpdateManyWithoutOrderNestedInput = {
  create?: Maybe<Array<CaveatCreateWithoutOrderInput>>;
  connectOrCreate?: Maybe<Array<CaveatCreateOrConnectWithoutOrderInput>>;
  upsert?: Maybe<Array<CaveatUpsertWithWhereUniqueWithoutOrderInput>>;
  createMany?: Maybe<CaveatCreateManyOrderInputEnvelope>;
  set?: Maybe<Array<CaveatWhereUniqueInput>>;
  disconnect?: Maybe<Array<CaveatWhereUniqueInput>>;
  delete?: Maybe<Array<CaveatWhereUniqueInput>>;
  connect?: Maybe<Array<CaveatWhereUniqueInput>>;
  update?: Maybe<Array<CaveatUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: Maybe<Array<CaveatUpdateManyWithWhereWithoutOrderInput>>;
  deleteMany?: Maybe<Array<CaveatScalarWhereInput>>;
};

export type CaveatUpdateWithWhereUniqueWithoutOrderInput = {
  where: CaveatWhereUniqueInput;
  data: CaveatUpdateWithoutOrderInput;
};

export type CaveatUpdateWithoutOrderInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type CaveatUpsertWithWhereUniqueWithoutOrderInput = {
  where: CaveatWhereUniqueInput;
  update: CaveatUpdateWithoutOrderInput;
  create: CaveatCreateWithoutOrderInput;
};

export type CaveatWhereInput = {
  AND?: Maybe<Array<CaveatWhereInput>>;
  OR?: Maybe<Array<CaveatWhereInput>>;
  NOT?: Maybe<Array<CaveatWhereInput>>;
  id?: Maybe<StringFilter>;
  order?: Maybe<OrderRelationFilter>;
  orderId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  note?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdBy?: Maybe<StringNullableFilter>;
};

export type CaveatWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type Company = {
  __typename?: "Company";
  id: Scalars["String"];
  name: Scalars["String"];
  isBlocked: Scalars["Boolean"];
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType: CompanyIngresType;
  logo?: Maybe<Scalars["String"]>;
  _count?: Maybe<CompanyCount>;
  orders: Array<Order>;
  companyDefaultValues: Array<CompanyDefaultValue>;
  selectedCompanies: Array<User>;
  users: Array<UserRelCompany>;
};

export type CompanyOrdersArgs = {
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<Array<OrderOrderByWithRelationInput>>;
  cursor?: Maybe<OrderWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<OrderScalarFieldEnum>>;
};

export type CompanyCompanyDefaultValuesArgs = {
  where?: Maybe<CompanyDefaultValueWhereInput>;
  orderBy?: Maybe<Array<CompanyDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<CompanyDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CompanyDefaultValueScalarFieldEnum>>;
};

export type CompanySelectedCompaniesArgs = {
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  cursor?: Maybe<UserWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserScalarFieldEnum>>;
};

export type CompanyUsersArgs = {
  where?: Maybe<UserRelCompanyWhereInput>;
  orderBy?: Maybe<Array<UserRelCompanyOrderByWithRelationInput>>;
  cursor?: Maybe<UserRelCompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserRelCompanyScalarFieldEnum>>;
};

export type CompanyCount = {
  __typename?: "CompanyCount";
  orders: Scalars["Int"];
  companyDefaultValues: Scalars["Int"];
  selectedCompanies: Scalars["Int"];
  users: Scalars["Int"];
};

export type CompanyCountAggregate = {
  __typename?: "CompanyCountAggregate";
  id: Scalars["Int"];
  name: Scalars["Int"];
  isBlocked: Scalars["Int"];
  carloExternalId: Scalars["Int"];
  carloPartnerId: Scalars["Int"];
  ingresId: Scalars["Int"];
  ingresType: Scalars["Int"];
  logo: Scalars["Int"];
  _all: Scalars["Int"];
};

export type CompanyCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  isBlocked?: Maybe<SortOrder>;
  carloExternalId?: Maybe<SortOrder>;
  carloPartnerId?: Maybe<SortOrder>;
  ingresId?: Maybe<SortOrder>;
  ingresType?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
};

export type CompanyCreateInput = {
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  isBlocked?: Maybe<Scalars["Boolean"]>;
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType?: Maybe<CompanyIngresType>;
  logo?: Maybe<Scalars["String"]>;
  orders?: Maybe<OrderCreateNestedManyWithoutCompanyInput>;
  companyDefaultValues?: Maybe<CompanyDefaultValueCreateNestedManyWithoutCompanyInput>;
  selectedCompanies?: Maybe<UserCreateNestedManyWithoutSelectedCompanyInput>;
  users?: Maybe<UserRelCompanyCreateNestedManyWithoutCompanyInput>;
};

export type CompanyCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  isBlocked?: Maybe<Scalars["Boolean"]>;
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType?: Maybe<CompanyIngresType>;
  logo?: Maybe<Scalars["String"]>;
};

export type CompanyCreateNestedOneWithoutCompanyDefaultValuesInput = {
  create?: Maybe<CompanyCreateWithoutCompanyDefaultValuesInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutCompanyDefaultValuesInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateNestedOneWithoutOrdersInput = {
  create?: Maybe<CompanyCreateWithoutOrdersInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutOrdersInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateNestedOneWithoutSelectedCompaniesInput = {
  create?: Maybe<CompanyCreateWithoutSelectedCompaniesInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutSelectedCompaniesInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateNestedOneWithoutUsersInput = {
  create?: Maybe<CompanyCreateWithoutUsersInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutUsersInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateOrConnectWithoutCompanyDefaultValuesInput = {
  where: CompanyWhereUniqueInput;
  create: CompanyCreateWithoutCompanyDefaultValuesInput;
};

export type CompanyCreateOrConnectWithoutOrdersInput = {
  where: CompanyWhereUniqueInput;
  create: CompanyCreateWithoutOrdersInput;
};

export type CompanyCreateOrConnectWithoutSelectedCompaniesInput = {
  where: CompanyWhereUniqueInput;
  create: CompanyCreateWithoutSelectedCompaniesInput;
};

export type CompanyCreateOrConnectWithoutUsersInput = {
  where: CompanyWhereUniqueInput;
  create: CompanyCreateWithoutUsersInput;
};

export type CompanyCreateWithoutCompanyDefaultValuesInput = {
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  isBlocked?: Maybe<Scalars["Boolean"]>;
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType?: Maybe<CompanyIngresType>;
  logo?: Maybe<Scalars["String"]>;
  orders?: Maybe<OrderCreateNestedManyWithoutCompanyInput>;
  selectedCompanies?: Maybe<UserCreateNestedManyWithoutSelectedCompanyInput>;
  users?: Maybe<UserRelCompanyCreateNestedManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutOrdersInput = {
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  isBlocked?: Maybe<Scalars["Boolean"]>;
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType?: Maybe<CompanyIngresType>;
  logo?: Maybe<Scalars["String"]>;
  companyDefaultValues?: Maybe<CompanyDefaultValueCreateNestedManyWithoutCompanyInput>;
  selectedCompanies?: Maybe<UserCreateNestedManyWithoutSelectedCompanyInput>;
  users?: Maybe<UserRelCompanyCreateNestedManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutSelectedCompaniesInput = {
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  isBlocked?: Maybe<Scalars["Boolean"]>;
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType?: Maybe<CompanyIngresType>;
  logo?: Maybe<Scalars["String"]>;
  orders?: Maybe<OrderCreateNestedManyWithoutCompanyInput>;
  companyDefaultValues?: Maybe<CompanyDefaultValueCreateNestedManyWithoutCompanyInput>;
  users?: Maybe<UserRelCompanyCreateNestedManyWithoutCompanyInput>;
};

export type CompanyCreateWithoutUsersInput = {
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  isBlocked?: Maybe<Scalars["Boolean"]>;
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType?: Maybe<CompanyIngresType>;
  logo?: Maybe<Scalars["String"]>;
  orders?: Maybe<OrderCreateNestedManyWithoutCompanyInput>;
  companyDefaultValues?: Maybe<CompanyDefaultValueCreateNestedManyWithoutCompanyInput>;
  selectedCompanies?: Maybe<UserCreateNestedManyWithoutSelectedCompanyInput>;
};

export type CompanyDefaultValue = {
  __typename?: "CompanyDefaultValue";
  id: Scalars["String"];
  property: Scalars["String"];
  value: Scalars["String"];
  companyId?: Maybe<Scalars["String"]>;
  company?: Maybe<Company>;
};

export type CompanyDefaultValueCountAggregate = {
  __typename?: "CompanyDefaultValueCountAggregate";
  id: Scalars["Int"];
  property: Scalars["Int"];
  value: Scalars["Int"];
  companyId: Scalars["Int"];
  _all: Scalars["Int"];
};

export type CompanyDefaultValueCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
};

export type CompanyDefaultValueCreateInput = {
  id?: Maybe<Scalars["String"]>;
  property: Scalars["String"];
  value: Scalars["String"];
  company?: Maybe<CompanyCreateNestedOneWithoutCompanyDefaultValuesInput>;
};

export type CompanyDefaultValueCreateManyCompanyInput = {
  id?: Maybe<Scalars["String"]>;
  property: Scalars["String"];
  value: Scalars["String"];
};

export type CompanyDefaultValueCreateManyCompanyInputEnvelope = {
  data: Array<CompanyDefaultValueCreateManyCompanyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type CompanyDefaultValueCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  property: Scalars["String"];
  value: Scalars["String"];
  companyId?: Maybe<Scalars["String"]>;
};

export type CompanyDefaultValueCreateNestedManyWithoutCompanyInput = {
  create?: Maybe<Array<CompanyDefaultValueCreateWithoutCompanyInput>>;
  connectOrCreate?: Maybe<
    Array<CompanyDefaultValueCreateOrConnectWithoutCompanyInput>
  >;
  createMany?: Maybe<CompanyDefaultValueCreateManyCompanyInputEnvelope>;
  connect?: Maybe<Array<CompanyDefaultValueWhereUniqueInput>>;
};

export type CompanyDefaultValueCreateOrConnectWithoutCompanyInput = {
  where: CompanyDefaultValueWhereUniqueInput;
  create: CompanyDefaultValueCreateWithoutCompanyInput;
};

export type CompanyDefaultValueCreateWithoutCompanyInput = {
  id?: Maybe<Scalars["String"]>;
  property: Scalars["String"];
  value: Scalars["String"];
};

export type CompanyDefaultValueGroupBy = {
  __typename?: "CompanyDefaultValueGroupBy";
  id: Scalars["String"];
  property: Scalars["String"];
  value: Scalars["String"];
  companyId?: Maybe<Scalars["String"]>;
  _count?: Maybe<CompanyDefaultValueCountAggregate>;
  _min?: Maybe<CompanyDefaultValueMinAggregate>;
  _max?: Maybe<CompanyDefaultValueMaxAggregate>;
};

export type CompanyDefaultValueListRelationFilter = {
  every?: Maybe<CompanyDefaultValueWhereInput>;
  some?: Maybe<CompanyDefaultValueWhereInput>;
  none?: Maybe<CompanyDefaultValueWhereInput>;
};

export type CompanyDefaultValueMaxAggregate = {
  __typename?: "CompanyDefaultValueMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  property?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["String"]>;
};

export type CompanyDefaultValueMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
};

export type CompanyDefaultValueMinAggregate = {
  __typename?: "CompanyDefaultValueMinAggregate";
  id?: Maybe<Scalars["String"]>;
  property?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["String"]>;
};

export type CompanyDefaultValueMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
};

export type CompanyDefaultValueOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CompanyDefaultValueOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
  _count?: Maybe<CompanyDefaultValueCountOrderByAggregateInput>;
  _max?: Maybe<CompanyDefaultValueMaxOrderByAggregateInput>;
  _min?: Maybe<CompanyDefaultValueMinOrderByAggregateInput>;
};

export type CompanyDefaultValueOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  company?: Maybe<CompanyOrderByWithRelationInput>;
  companyId?: Maybe<SortOrder>;
};

export enum CompanyDefaultValueScalarFieldEnum {
  Id = "id",
  Property = "property",
  Value = "value",
  CompanyId = "companyId",
}

export type CompanyDefaultValueScalarWhereInput = {
  AND?: Maybe<Array<CompanyDefaultValueScalarWhereInput>>;
  OR?: Maybe<Array<CompanyDefaultValueScalarWhereInput>>;
  NOT?: Maybe<Array<CompanyDefaultValueScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  property?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
  companyId?: Maybe<StringNullableFilter>;
};

export type CompanyDefaultValueScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CompanyDefaultValueScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CompanyDefaultValueScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CompanyDefaultValueScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  property?: Maybe<StringWithAggregatesFilter>;
  value?: Maybe<StringWithAggregatesFilter>;
  companyId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type CompanyDefaultValueUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  property?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
  company?: Maybe<CompanyUpdateOneWithoutCompanyDefaultValuesNestedInput>;
};

export type CompanyDefaultValueUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  property?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CompanyDefaultValueUpdateManyWithWhereWithoutCompanyInput = {
  where: CompanyDefaultValueScalarWhereInput;
  data: CompanyDefaultValueUpdateManyMutationInput;
};

export type CompanyDefaultValueUpdateManyWithoutCompanyNestedInput = {
  create?: Maybe<Array<CompanyDefaultValueCreateWithoutCompanyInput>>;
  connectOrCreate?: Maybe<
    Array<CompanyDefaultValueCreateOrConnectWithoutCompanyInput>
  >;
  upsert?: Maybe<
    Array<CompanyDefaultValueUpsertWithWhereUniqueWithoutCompanyInput>
  >;
  createMany?: Maybe<CompanyDefaultValueCreateManyCompanyInputEnvelope>;
  set?: Maybe<Array<CompanyDefaultValueWhereUniqueInput>>;
  disconnect?: Maybe<Array<CompanyDefaultValueWhereUniqueInput>>;
  delete?: Maybe<Array<CompanyDefaultValueWhereUniqueInput>>;
  connect?: Maybe<Array<CompanyDefaultValueWhereUniqueInput>>;
  update?: Maybe<
    Array<CompanyDefaultValueUpdateWithWhereUniqueWithoutCompanyInput>
  >;
  updateMany?: Maybe<
    Array<CompanyDefaultValueUpdateManyWithWhereWithoutCompanyInput>
  >;
  deleteMany?: Maybe<Array<CompanyDefaultValueScalarWhereInput>>;
};

export type CompanyDefaultValueUpdateWithWhereUniqueWithoutCompanyInput = {
  where: CompanyDefaultValueWhereUniqueInput;
  data: CompanyDefaultValueUpdateWithoutCompanyInput;
};

export type CompanyDefaultValueUpdateWithoutCompanyInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  property?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CompanyDefaultValueUpsertWithWhereUniqueWithoutCompanyInput = {
  where: CompanyDefaultValueWhereUniqueInput;
  update: CompanyDefaultValueUpdateWithoutCompanyInput;
  create: CompanyDefaultValueCreateWithoutCompanyInput;
};

export type CompanyDefaultValueWhereInput = {
  AND?: Maybe<Array<CompanyDefaultValueWhereInput>>;
  OR?: Maybe<Array<CompanyDefaultValueWhereInput>>;
  NOT?: Maybe<Array<CompanyDefaultValueWhereInput>>;
  id?: Maybe<StringFilter>;
  property?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
  company?: Maybe<CompanyRelationFilter>;
  companyId?: Maybe<StringNullableFilter>;
};

export type CompanyDefaultValueWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type CompanyGroupBy = {
  __typename?: "CompanyGroupBy";
  id: Scalars["String"];
  name: Scalars["String"];
  isBlocked: Scalars["Boolean"];
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType: CompanyIngresType;
  logo?: Maybe<Scalars["String"]>;
  _count?: Maybe<CompanyCountAggregate>;
  _min?: Maybe<CompanyMinAggregate>;
  _max?: Maybe<CompanyMaxAggregate>;
};

export enum CompanyIngresType {
  Cz = "CZ",
  Sk = "SK",
}

export type CompanyMaxAggregate = {
  __typename?: "CompanyMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  isBlocked?: Maybe<Scalars["Boolean"]>;
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType?: Maybe<CompanyIngresType>;
  logo?: Maybe<Scalars["String"]>;
};

export type CompanyMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  isBlocked?: Maybe<SortOrder>;
  carloExternalId?: Maybe<SortOrder>;
  carloPartnerId?: Maybe<SortOrder>;
  ingresId?: Maybe<SortOrder>;
  ingresType?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
};

export type CompanyMinAggregate = {
  __typename?: "CompanyMinAggregate";
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  isBlocked?: Maybe<Scalars["Boolean"]>;
  carloExternalId?: Maybe<Scalars["String"]>;
  carloPartnerId?: Maybe<Scalars["String"]>;
  ingresId?: Maybe<Scalars["String"]>;
  ingresType?: Maybe<CompanyIngresType>;
  logo?: Maybe<Scalars["String"]>;
};

export type CompanyMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  isBlocked?: Maybe<SortOrder>;
  carloExternalId?: Maybe<SortOrder>;
  carloPartnerId?: Maybe<SortOrder>;
  ingresId?: Maybe<SortOrder>;
  ingresType?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
};

export type CompanyOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  isBlocked?: Maybe<SortOrder>;
  carloExternalId?: Maybe<SortOrder>;
  carloPartnerId?: Maybe<SortOrder>;
  ingresId?: Maybe<SortOrder>;
  ingresType?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
  _count?: Maybe<CompanyCountOrderByAggregateInput>;
  _max?: Maybe<CompanyMaxOrderByAggregateInput>;
  _min?: Maybe<CompanyMinOrderByAggregateInput>;
};

export type CompanyOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  isBlocked?: Maybe<SortOrder>;
  carloExternalId?: Maybe<SortOrder>;
  carloPartnerId?: Maybe<SortOrder>;
  ingresId?: Maybe<SortOrder>;
  ingresType?: Maybe<SortOrder>;
  logo?: Maybe<SortOrder>;
  orders?: Maybe<OrderOrderByRelationAggregateInput>;
  companyDefaultValues?: Maybe<CompanyDefaultValueOrderByRelationAggregateInput>;
  selectedCompanies?: Maybe<UserOrderByRelationAggregateInput>;
  users?: Maybe<UserRelCompanyOrderByRelationAggregateInput>;
};

export type CompanyRelationFilter = {
  is?: Maybe<CompanyWhereInput>;
  isNot?: Maybe<CompanyWhereInput>;
};

export enum CompanyScalarFieldEnum {
  Id = "id",
  Name = "name",
  IsBlocked = "isBlocked",
  CarloExternalId = "carloExternalId",
  CarloPartnerId = "carloPartnerId",
  IngresId = "ingresId",
  IngresType = "ingresType",
  Logo = "logo",
}

export type CompanyScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CompanyScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CompanyScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CompanyScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  isBlocked?: Maybe<BoolWithAggregatesFilter>;
  carloExternalId?: Maybe<StringNullableWithAggregatesFilter>;
  carloPartnerId?: Maybe<StringNullableWithAggregatesFilter>;
  ingresId?: Maybe<StringNullableWithAggregatesFilter>;
  ingresType?: Maybe<EnumCompanyIngresTypeWithAggregatesFilter>;
  logo?: Maybe<StringNullableWithAggregatesFilter>;
};

export type CompanyUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  isBlocked?: Maybe<BoolFieldUpdateOperationsInput>;
  carloExternalId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  carloPartnerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresType?: Maybe<EnumCompanyIngresTypeFieldUpdateOperationsInput>;
  logo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orders?: Maybe<OrderUpdateManyWithoutCompanyNestedInput>;
  companyDefaultValues?: Maybe<CompanyDefaultValueUpdateManyWithoutCompanyNestedInput>;
  selectedCompanies?: Maybe<UserUpdateManyWithoutSelectedCompanyNestedInput>;
  users?: Maybe<UserRelCompanyUpdateManyWithoutCompanyNestedInput>;
};

export type CompanyUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  isBlocked?: Maybe<BoolFieldUpdateOperationsInput>;
  carloExternalId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  carloPartnerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresType?: Maybe<EnumCompanyIngresTypeFieldUpdateOperationsInput>;
  logo?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type CompanyUpdateOneRequiredWithoutOrdersNestedInput = {
  create?: Maybe<CompanyCreateWithoutOrdersInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutOrdersInput>;
  upsert?: Maybe<CompanyUpsertWithoutOrdersInput>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  update?: Maybe<CompanyUpdateWithoutOrdersInput>;
};

export type CompanyUpdateOneWithoutCompanyDefaultValuesNestedInput = {
  create?: Maybe<CompanyCreateWithoutCompanyDefaultValuesInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutCompanyDefaultValuesInput>;
  upsert?: Maybe<CompanyUpsertWithoutCompanyDefaultValuesInput>;
  disconnect?: Maybe<Scalars["Boolean"]>;
  delete?: Maybe<Scalars["Boolean"]>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  update?: Maybe<CompanyUpdateWithoutCompanyDefaultValuesInput>;
};

export type CompanyUpdateOneWithoutSelectedCompaniesNestedInput = {
  create?: Maybe<CompanyCreateWithoutSelectedCompaniesInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutSelectedCompaniesInput>;
  upsert?: Maybe<CompanyUpsertWithoutSelectedCompaniesInput>;
  disconnect?: Maybe<Scalars["Boolean"]>;
  delete?: Maybe<Scalars["Boolean"]>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  update?: Maybe<CompanyUpdateWithoutSelectedCompaniesInput>;
};

export type CompanyUpdateOneWithoutUsersNestedInput = {
  create?: Maybe<CompanyCreateWithoutUsersInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutUsersInput>;
  upsert?: Maybe<CompanyUpsertWithoutUsersInput>;
  disconnect?: Maybe<Scalars["Boolean"]>;
  delete?: Maybe<Scalars["Boolean"]>;
  connect?: Maybe<CompanyWhereUniqueInput>;
  update?: Maybe<CompanyUpdateWithoutUsersInput>;
};

export type CompanyUpdateWithoutCompanyDefaultValuesInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  isBlocked?: Maybe<BoolFieldUpdateOperationsInput>;
  carloExternalId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  carloPartnerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresType?: Maybe<EnumCompanyIngresTypeFieldUpdateOperationsInput>;
  logo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orders?: Maybe<OrderUpdateManyWithoutCompanyNestedInput>;
  selectedCompanies?: Maybe<UserUpdateManyWithoutSelectedCompanyNestedInput>;
  users?: Maybe<UserRelCompanyUpdateManyWithoutCompanyNestedInput>;
};

export type CompanyUpdateWithoutOrdersInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  isBlocked?: Maybe<BoolFieldUpdateOperationsInput>;
  carloExternalId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  carloPartnerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresType?: Maybe<EnumCompanyIngresTypeFieldUpdateOperationsInput>;
  logo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  companyDefaultValues?: Maybe<CompanyDefaultValueUpdateManyWithoutCompanyNestedInput>;
  selectedCompanies?: Maybe<UserUpdateManyWithoutSelectedCompanyNestedInput>;
  users?: Maybe<UserRelCompanyUpdateManyWithoutCompanyNestedInput>;
};

export type CompanyUpdateWithoutSelectedCompaniesInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  isBlocked?: Maybe<BoolFieldUpdateOperationsInput>;
  carloExternalId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  carloPartnerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresType?: Maybe<EnumCompanyIngresTypeFieldUpdateOperationsInput>;
  logo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orders?: Maybe<OrderUpdateManyWithoutCompanyNestedInput>;
  companyDefaultValues?: Maybe<CompanyDefaultValueUpdateManyWithoutCompanyNestedInput>;
  users?: Maybe<UserRelCompanyUpdateManyWithoutCompanyNestedInput>;
};

export type CompanyUpdateWithoutUsersInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  isBlocked?: Maybe<BoolFieldUpdateOperationsInput>;
  carloExternalId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  carloPartnerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresType?: Maybe<EnumCompanyIngresTypeFieldUpdateOperationsInput>;
  logo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orders?: Maybe<OrderUpdateManyWithoutCompanyNestedInput>;
  companyDefaultValues?: Maybe<CompanyDefaultValueUpdateManyWithoutCompanyNestedInput>;
  selectedCompanies?: Maybe<UserUpdateManyWithoutSelectedCompanyNestedInput>;
};

export type CompanyUpsertWithoutCompanyDefaultValuesInput = {
  update: CompanyUpdateWithoutCompanyDefaultValuesInput;
  create: CompanyCreateWithoutCompanyDefaultValuesInput;
};

export type CompanyUpsertWithoutOrdersInput = {
  update: CompanyUpdateWithoutOrdersInput;
  create: CompanyCreateWithoutOrdersInput;
};

export type CompanyUpsertWithoutSelectedCompaniesInput = {
  update: CompanyUpdateWithoutSelectedCompaniesInput;
  create: CompanyCreateWithoutSelectedCompaniesInput;
};

export type CompanyUpsertWithoutUsersInput = {
  update: CompanyUpdateWithoutUsersInput;
  create: CompanyCreateWithoutUsersInput;
};

export type CompanyWhereInput = {
  AND?: Maybe<Array<CompanyWhereInput>>;
  OR?: Maybe<Array<CompanyWhereInput>>;
  NOT?: Maybe<Array<CompanyWhereInput>>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  isBlocked?: Maybe<BoolFilter>;
  carloExternalId?: Maybe<StringNullableFilter>;
  carloPartnerId?: Maybe<StringNullableFilter>;
  ingresId?: Maybe<StringNullableFilter>;
  ingresType?: Maybe<EnumCompanyIngresTypeFilter>;
  logo?: Maybe<StringNullableFilter>;
  orders?: Maybe<OrderListRelationFilter>;
  companyDefaultValues?: Maybe<CompanyDefaultValueListRelationFilter>;
  selectedCompanies?: Maybe<UserListRelationFilter>;
  users?: Maybe<UserRelCompanyListRelationFilter>;
};

export type CompanyWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: Maybe<Scalars["DateTime"]>;
};

export type DateTimeFilter = {
  equals?: Maybe<Scalars["DateTime"]>;
  in?: Maybe<Array<Scalars["DateTime"]>>;
  notIn?: Maybe<Array<Scalars["DateTime"]>>;
  lt?: Maybe<Scalars["DateTime"]>;
  lte?: Maybe<Scalars["DateTime"]>;
  gt?: Maybe<Scalars["DateTime"]>;
  gte?: Maybe<Scalars["DateTime"]>;
  not?: Maybe<NestedDateTimeFilter>;
};

export type DateTimeNullableFilter = {
  equals?: Maybe<Scalars["DateTime"]>;
  in?: Maybe<Array<Scalars["DateTime"]>>;
  notIn?: Maybe<Array<Scalars["DateTime"]>>;
  lt?: Maybe<Scalars["DateTime"]>;
  lte?: Maybe<Scalars["DateTime"]>;
  gt?: Maybe<Scalars["DateTime"]>;
  gte?: Maybe<Scalars["DateTime"]>;
  not?: Maybe<NestedDateTimeNullableFilter>;
};

export type DateTimeNullableWithAggregatesFilter = {
  equals?: Maybe<Scalars["DateTime"]>;
  in?: Maybe<Array<Scalars["DateTime"]>>;
  notIn?: Maybe<Array<Scalars["DateTime"]>>;
  lt?: Maybe<Scalars["DateTime"]>;
  lte?: Maybe<Scalars["DateTime"]>;
  gt?: Maybe<Scalars["DateTime"]>;
  gte?: Maybe<Scalars["DateTime"]>;
  not?: Maybe<NestedDateTimeNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedDateTimeNullableFilter>;
  _max?: Maybe<NestedDateTimeNullableFilter>;
};

export type DateTimeWithAggregatesFilter = {
  equals?: Maybe<Scalars["DateTime"]>;
  in?: Maybe<Array<Scalars["DateTime"]>>;
  notIn?: Maybe<Array<Scalars["DateTime"]>>;
  lt?: Maybe<Scalars["DateTime"]>;
  lte?: Maybe<Scalars["DateTime"]>;
  gt?: Maybe<Scalars["DateTime"]>;
  gte?: Maybe<Scalars["DateTime"]>;
  not?: Maybe<NestedDateTimeWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedDateTimeFilter>;
  _max?: Maybe<NestedDateTimeFilter>;
};

export type DeliveryNote = {
  __typename?: "DeliveryNote";
  id: Scalars["String"];
  deliveryNoteNumber: Scalars["String"];
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  orderId: Scalars["String"];
  _count?: Maybe<DeliveryNoteCount>;
  documents: Array<DeliveryNoteDocument>;
  order: Order;
  sscc: Array<Sscc>;
  loadingUnits: Array<DeliveryNoteLoadingUnit>;
  links: Array<DeliveryNoteLink>;
};

export type DeliveryNoteDocumentsArgs = {
  where?: Maybe<DeliveryNoteDocumentWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteDocumentOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteDocumentWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteDocumentScalarFieldEnum>>;
};

export type DeliveryNoteSsccArgs = {
  where?: Maybe<SsccWhereInput>;
  orderBy?: Maybe<Array<SsccOrderByWithRelationInput>>;
  cursor?: Maybe<SsccWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<SsccScalarFieldEnum>>;
};

export type DeliveryNoteLoadingUnitsArgs = {
  where?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteLoadingUnitOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteLoadingUnitWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteLoadingUnitScalarFieldEnum>>;
};

export type DeliveryNoteAvgAggregate = {
  __typename?: "DeliveryNoteAvgAggregate";
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
};

export type DeliveryNoteAvgOrderByAggregateInput = {
  cash?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  numberOfHalfPallets?: Maybe<SortOrder>;
  numberOfPackages?: Maybe<SortOrder>;
  numberOfOversizedPackages?: Maybe<SortOrder>;
  numberOfRequiredSscc?: Maybe<SortOrder>;
};

export type DeliveryNoteCount = {
  __typename?: "DeliveryNoteCount";
  documents: Scalars["Int"];
  sscc: Scalars["Int"];
  loadingUnits: Scalars["Int"];
};

export type DeliveryNoteCountAggregate = {
  __typename?: "DeliveryNoteCountAggregate";
  id: Scalars["Int"];
  deliveryNoteNumber: Scalars["Int"];
  confirmedAt: Scalars["Int"];
  currency: Scalars["Int"];
  cash: Scalars["Int"];
  numberOfItems: Scalars["Int"];
  numberOfHalfPallets: Scalars["Int"];
  numberOfPackages: Scalars["Int"];
  numberOfOversizedPackages: Scalars["Int"];
  numberOfRequiredSscc: Scalars["Int"];
  note: Scalars["Int"];
  locationId: Scalars["Int"];
  orderId: Scalars["Int"];
  _all: Scalars["Int"];
};

export type DeliveryNoteCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  deliveryNoteNumber?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  cash?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  numberOfHalfPallets?: Maybe<SortOrder>;
  numberOfPackages?: Maybe<SortOrder>;
  numberOfOversizedPackages?: Maybe<SortOrder>;
  numberOfRequiredSscc?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
};

export type DeliveryNoteCreateInput = {
  id?: Maybe<Scalars["String"]>;
  deliveryNoteNumber: Scalars["String"];
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  documents?: Maybe<DeliveryNoteDocumentCreateNestedManyWithoutDeliveryNoteInput>;
  note?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  order: OrderCreateNestedOneWithoutDeliveryNotesInput;
  sscc?: Maybe<SsccCreateNestedManyWithoutDeliveryNoteInput>;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitCreateNestedManyWithoutDeliveryNoteInput>;
};

export type DeliveryNoteCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  deliveryNoteNumber: Scalars["String"];
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  orderId: Scalars["String"];
};

export type DeliveryNoteCreateManyOrderInput = {
  id?: Maybe<Scalars["String"]>;
  deliveryNoteNumber: Scalars["String"];
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
};

export type DeliveryNoteCreateManyOrderInputEnvelope = {
  data: Array<DeliveryNoteCreateManyOrderInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type DeliveryNoteCreateNestedManyWithoutOrderInput = {
  create?: Maybe<Array<DeliveryNoteCreateWithoutOrderInput>>;
  connectOrCreate?: Maybe<Array<DeliveryNoteCreateOrConnectWithoutOrderInput>>;
  createMany?: Maybe<DeliveryNoteCreateManyOrderInputEnvelope>;
  connect?: Maybe<Array<DeliveryNoteWhereUniqueInput>>;
};

export type DeliveryNoteCreateNestedOneWithoutDocumentsInput = {
  create?: Maybe<DeliveryNoteCreateWithoutDocumentsInput>;
  connectOrCreate?: Maybe<DeliveryNoteCreateOrConnectWithoutDocumentsInput>;
  connect?: Maybe<DeliveryNoteWhereUniqueInput>;
};

export type DeliveryNoteCreateNestedOneWithoutLoadingUnitsInput = {
  create?: Maybe<DeliveryNoteCreateWithoutLoadingUnitsInput>;
  connectOrCreate?: Maybe<DeliveryNoteCreateOrConnectWithoutLoadingUnitsInput>;
  connect?: Maybe<DeliveryNoteWhereUniqueInput>;
};

export type DeliveryNoteCreateNestedOneWithoutSsccInput = {
  create?: Maybe<DeliveryNoteCreateWithoutSsccInput>;
  connectOrCreate?: Maybe<DeliveryNoteCreateOrConnectWithoutSsccInput>;
  connect?: Maybe<DeliveryNoteWhereUniqueInput>;
};

export type DeliveryNoteCreateOrConnectWithoutDocumentsInput = {
  where: DeliveryNoteWhereUniqueInput;
  create: DeliveryNoteCreateWithoutDocumentsInput;
};

export type DeliveryNoteCreateOrConnectWithoutLoadingUnitsInput = {
  where: DeliveryNoteWhereUniqueInput;
  create: DeliveryNoteCreateWithoutLoadingUnitsInput;
};

export type DeliveryNoteCreateOrConnectWithoutOrderInput = {
  where: DeliveryNoteWhereUniqueInput;
  create: DeliveryNoteCreateWithoutOrderInput;
};

export type DeliveryNoteCreateOrConnectWithoutSsccInput = {
  where: DeliveryNoteWhereUniqueInput;
  create: DeliveryNoteCreateWithoutSsccInput;
};

export type DeliveryNoteCreateWithoutDocumentsInput = {
  id?: Maybe<Scalars["String"]>;
  deliveryNoteNumber: Scalars["String"];
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  order: OrderCreateNestedOneWithoutDeliveryNotesInput;
  sscc?: Maybe<SsccCreateNestedManyWithoutDeliveryNoteInput>;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitCreateNestedManyWithoutDeliveryNoteInput>;
};

export type DeliveryNoteCreateWithoutLoadingUnitsInput = {
  id?: Maybe<Scalars["String"]>;
  deliveryNoteNumber: Scalars["String"];
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  documents?: Maybe<DeliveryNoteDocumentCreateNestedManyWithoutDeliveryNoteInput>;
  note?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  order: OrderCreateNestedOneWithoutDeliveryNotesInput;
  sscc?: Maybe<SsccCreateNestedManyWithoutDeliveryNoteInput>;
};

export type DeliveryNoteCreateWithoutOrderInput = {
  id?: Maybe<Scalars["String"]>;
  deliveryNoteNumber: Scalars["String"];
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  documents?: Maybe<DeliveryNoteDocumentCreateNestedManyWithoutDeliveryNoteInput>;
  note?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  sscc?: Maybe<SsccCreateNestedManyWithoutDeliveryNoteInput>;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitCreateNestedManyWithoutDeliveryNoteInput>;
};

export type DeliveryNoteCreateWithoutSsccInput = {
  id?: Maybe<Scalars["String"]>;
  deliveryNoteNumber: Scalars["String"];
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  documents?: Maybe<DeliveryNoteDocumentCreateNestedManyWithoutDeliveryNoteInput>;
  note?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  order: OrderCreateNestedOneWithoutDeliveryNotesInput;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitCreateNestedManyWithoutDeliveryNoteInput>;
};

export type DeliveryNoteDocument = {
  __typename?: "DeliveryNoteDocument";
  id: Scalars["String"];
  type: DeliveryNoteDocumentType;
  path: Scalars["String"];
  deliveryNoteId: Scalars["String"];
  deliveryNote: DeliveryNote;
};

export type DeliveryNoteDocumentCountAggregate = {
  __typename?: "DeliveryNoteDocumentCountAggregate";
  id: Scalars["Int"];
  type: Scalars["Int"];
  path: Scalars["Int"];
  deliveryNoteId: Scalars["Int"];
  _all: Scalars["Int"];
};

export type DeliveryNoteDocumentCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export type DeliveryNoteDocumentCreateInput = {
  id?: Maybe<Scalars["String"]>;
  type: DeliveryNoteDocumentType;
  path: Scalars["String"];
  deliveryNote: DeliveryNoteCreateNestedOneWithoutDocumentsInput;
};

export type DeliveryNoteDocumentCreateManyDeliveryNoteInput = {
  id?: Maybe<Scalars["String"]>;
  type: DeliveryNoteDocumentType;
  path: Scalars["String"];
};

export type DeliveryNoteDocumentCreateManyDeliveryNoteInputEnvelope = {
  data: Array<DeliveryNoteDocumentCreateManyDeliveryNoteInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type DeliveryNoteDocumentCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  type: DeliveryNoteDocumentType;
  path: Scalars["String"];
  deliveryNoteId: Scalars["String"];
};

export type DeliveryNoteDocumentCreateNestedManyWithoutDeliveryNoteInput = {
  create?: Maybe<Array<DeliveryNoteDocumentCreateWithoutDeliveryNoteInput>>;
  connectOrCreate?: Maybe<
    Array<DeliveryNoteDocumentCreateOrConnectWithoutDeliveryNoteInput>
  >;
  createMany?: Maybe<DeliveryNoteDocumentCreateManyDeliveryNoteInputEnvelope>;
  connect?: Maybe<Array<DeliveryNoteDocumentWhereUniqueInput>>;
};

export type DeliveryNoteDocumentCreateOrConnectWithoutDeliveryNoteInput = {
  where: DeliveryNoteDocumentWhereUniqueInput;
  create: DeliveryNoteDocumentCreateWithoutDeliveryNoteInput;
};

export type DeliveryNoteDocumentCreateWithoutDeliveryNoteInput = {
  id?: Maybe<Scalars["String"]>;
  type: DeliveryNoteDocumentType;
  path: Scalars["String"];
};

export type DeliveryNoteDocumentGroupBy = {
  __typename?: "DeliveryNoteDocumentGroupBy";
  id: Scalars["String"];
  type: DeliveryNoteDocumentType;
  path: Scalars["String"];
  deliveryNoteId: Scalars["String"];
  _count?: Maybe<DeliveryNoteDocumentCountAggregate>;
  _min?: Maybe<DeliveryNoteDocumentMinAggregate>;
  _max?: Maybe<DeliveryNoteDocumentMaxAggregate>;
};

export type DeliveryNoteDocumentListRelationFilter = {
  every?: Maybe<DeliveryNoteDocumentWhereInput>;
  some?: Maybe<DeliveryNoteDocumentWhereInput>;
  none?: Maybe<DeliveryNoteDocumentWhereInput>;
};

export type DeliveryNoteDocumentMaxAggregate = {
  __typename?: "DeliveryNoteDocumentMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  type?: Maybe<DeliveryNoteDocumentType>;
  path?: Maybe<Scalars["String"]>;
  deliveryNoteId?: Maybe<Scalars["String"]>;
};

export type DeliveryNoteDocumentMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export type DeliveryNoteDocumentMinAggregate = {
  __typename?: "DeliveryNoteDocumentMinAggregate";
  id?: Maybe<Scalars["String"]>;
  type?: Maybe<DeliveryNoteDocumentType>;
  path?: Maybe<Scalars["String"]>;
  deliveryNoteId?: Maybe<Scalars["String"]>;
};

export type DeliveryNoteDocumentMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export type DeliveryNoteDocumentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DeliveryNoteDocumentOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
  _count?: Maybe<DeliveryNoteDocumentCountOrderByAggregateInput>;
  _max?: Maybe<DeliveryNoteDocumentMaxOrderByAggregateInput>;
  _min?: Maybe<DeliveryNoteDocumentMinOrderByAggregateInput>;
};

export type DeliveryNoteDocumentOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
  deliveryNote?: Maybe<DeliveryNoteOrderByWithRelationInput>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export enum DeliveryNoteDocumentScalarFieldEnum {
  Id = "id",
  Type = "type",
  Path = "path",
  DeliveryNoteId = "deliveryNoteId",
}

export type DeliveryNoteDocumentScalarWhereInput = {
  AND?: Maybe<Array<DeliveryNoteDocumentScalarWhereInput>>;
  OR?: Maybe<Array<DeliveryNoteDocumentScalarWhereInput>>;
  NOT?: Maybe<Array<DeliveryNoteDocumentScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  type?: Maybe<EnumDeliveryNoteDocumentTypeFilter>;
  path?: Maybe<StringFilter>;
  deliveryNoteId?: Maybe<StringFilter>;
};

export type DeliveryNoteDocumentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DeliveryNoteDocumentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DeliveryNoteDocumentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DeliveryNoteDocumentScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  type?: Maybe<EnumDeliveryNoteDocumentTypeWithAggregatesFilter>;
  path?: Maybe<StringWithAggregatesFilter>;
  deliveryNoteId?: Maybe<StringWithAggregatesFilter>;
};

export enum DeliveryNoteDocumentType {
  Complaint = "COMPLAINT",
  Order = "ORDER",
  Photo = "PHOTO",
}

export type DeliveryNoteDocumentUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDeliveryNoteDocumentTypeFieldUpdateOperationsInput>;
  path?: Maybe<StringFieldUpdateOperationsInput>;
  deliveryNote?: Maybe<DeliveryNoteUpdateOneRequiredWithoutDocumentsNestedInput>;
};

export type DeliveryNoteDocumentUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDeliveryNoteDocumentTypeFieldUpdateOperationsInput>;
  path?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DeliveryNoteDocumentUpdateManyWithWhereWithoutDeliveryNoteInput = {
  where: DeliveryNoteDocumentScalarWhereInput;
  data: DeliveryNoteDocumentUpdateManyMutationInput;
};

export type DeliveryNoteDocumentUpdateManyWithoutDeliveryNoteNestedInput = {
  create?: Maybe<Array<DeliveryNoteDocumentCreateWithoutDeliveryNoteInput>>;
  connectOrCreate?: Maybe<
    Array<DeliveryNoteDocumentCreateOrConnectWithoutDeliveryNoteInput>
  >;
  upsert?: Maybe<
    Array<DeliveryNoteDocumentUpsertWithWhereUniqueWithoutDeliveryNoteInput>
  >;
  createMany?: Maybe<DeliveryNoteDocumentCreateManyDeliveryNoteInputEnvelope>;
  set?: Maybe<Array<DeliveryNoteDocumentWhereUniqueInput>>;
  disconnect?: Maybe<Array<DeliveryNoteDocumentWhereUniqueInput>>;
  delete?: Maybe<Array<DeliveryNoteDocumentWhereUniqueInput>>;
  connect?: Maybe<Array<DeliveryNoteDocumentWhereUniqueInput>>;
  update?: Maybe<
    Array<DeliveryNoteDocumentUpdateWithWhereUniqueWithoutDeliveryNoteInput>
  >;
  updateMany?: Maybe<
    Array<DeliveryNoteDocumentUpdateManyWithWhereWithoutDeliveryNoteInput>
  >;
  deleteMany?: Maybe<Array<DeliveryNoteDocumentScalarWhereInput>>;
};

export type DeliveryNoteDocumentUpdateWithWhereUniqueWithoutDeliveryNoteInput =
  {
    where: DeliveryNoteDocumentWhereUniqueInput;
    data: DeliveryNoteDocumentUpdateWithoutDeliveryNoteInput;
  };

export type DeliveryNoteDocumentUpdateWithoutDeliveryNoteInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDeliveryNoteDocumentTypeFieldUpdateOperationsInput>;
  path?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DeliveryNoteDocumentUpsertWithWhereUniqueWithoutDeliveryNoteInput =
  {
    where: DeliveryNoteDocumentWhereUniqueInput;
    update: DeliveryNoteDocumentUpdateWithoutDeliveryNoteInput;
    create: DeliveryNoteDocumentCreateWithoutDeliveryNoteInput;
  };

export type DeliveryNoteDocumentWhereInput = {
  AND?: Maybe<Array<DeliveryNoteDocumentWhereInput>>;
  OR?: Maybe<Array<DeliveryNoteDocumentWhereInput>>;
  NOT?: Maybe<Array<DeliveryNoteDocumentWhereInput>>;
  id?: Maybe<StringFilter>;
  type?: Maybe<EnumDeliveryNoteDocumentTypeFilter>;
  path?: Maybe<StringFilter>;
  deliveryNote?: Maybe<DeliveryNoteRelationFilter>;
  deliveryNoteId?: Maybe<StringFilter>;
};

export type DeliveryNoteDocumentWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type DeliveryNoteGroupBy = {
  __typename?: "DeliveryNoteGroupBy";
  id: Scalars["String"];
  deliveryNoteNumber: Scalars["String"];
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  orderId: Scalars["String"];
  _count?: Maybe<DeliveryNoteCountAggregate>;
  _avg?: Maybe<DeliveryNoteAvgAggregate>;
  _sum?: Maybe<DeliveryNoteSumAggregate>;
  _min?: Maybe<DeliveryNoteMinAggregate>;
  _max?: Maybe<DeliveryNoteMaxAggregate>;
};

export type DeliveryNoteLink = {
  __typename?: "DeliveryNoteLink";
  id?: Maybe<Scalars["String"]>;
  path?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["String"]>;
};

export type DeliveryNoteListRelationFilter = {
  every?: Maybe<DeliveryNoteWhereInput>;
  some?: Maybe<DeliveryNoteWhereInput>;
  none?: Maybe<DeliveryNoteWhereInput>;
};

export type DeliveryNoteLoadingUnit = {
  __typename?: "DeliveryNoteLoadingUnit";
  id: Scalars["String"];
  typeId: Scalars["String"];
  amount: Scalars["Float"];
  deliveryNoteId: Scalars["String"];
  deliveryNote: DeliveryNote;
};

export type DeliveryNoteLoadingUnitAvgAggregate = {
  __typename?: "DeliveryNoteLoadingUnitAvgAggregate";
  amount?: Maybe<Scalars["Float"]>;
};

export type DeliveryNoteLoadingUnitAvgOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type DeliveryNoteLoadingUnitCountAggregate = {
  __typename?: "DeliveryNoteLoadingUnitCountAggregate";
  id: Scalars["Int"];
  typeId: Scalars["Int"];
  amount: Scalars["Int"];
  deliveryNoteId: Scalars["Int"];
  _all: Scalars["Int"];
};

export type DeliveryNoteLoadingUnitCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  typeId?: Maybe<SortOrder>;
  amount?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export type DeliveryNoteLoadingUnitCreateInput = {
  id?: Maybe<Scalars["String"]>;
  typeId: Scalars["String"];
  amount: Scalars["Float"];
  deliveryNote: DeliveryNoteCreateNestedOneWithoutLoadingUnitsInput;
};

export type DeliveryNoteLoadingUnitCreateManyDeliveryNoteInput = {
  id?: Maybe<Scalars["String"]>;
  typeId: Scalars["String"];
  amount: Scalars["Float"];
};

export type DeliveryNoteLoadingUnitCreateManyDeliveryNoteInputEnvelope = {
  data: Array<DeliveryNoteLoadingUnitCreateManyDeliveryNoteInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type DeliveryNoteLoadingUnitCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  typeId: Scalars["String"];
  amount: Scalars["Float"];
  deliveryNoteId: Scalars["String"];
};

export type DeliveryNoteLoadingUnitCreateNestedManyWithoutDeliveryNoteInput = {
  create?: Maybe<Array<DeliveryNoteLoadingUnitCreateWithoutDeliveryNoteInput>>;
  connectOrCreate?: Maybe<
    Array<DeliveryNoteLoadingUnitCreateOrConnectWithoutDeliveryNoteInput>
  >;
  createMany?: Maybe<DeliveryNoteLoadingUnitCreateManyDeliveryNoteInputEnvelope>;
  connect?: Maybe<Array<DeliveryNoteLoadingUnitWhereUniqueInput>>;
};

export type DeliveryNoteLoadingUnitCreateOrConnectWithoutDeliveryNoteInput = {
  where: DeliveryNoteLoadingUnitWhereUniqueInput;
  create: DeliveryNoteLoadingUnitCreateWithoutDeliveryNoteInput;
};

export type DeliveryNoteLoadingUnitCreateWithoutDeliveryNoteInput = {
  id?: Maybe<Scalars["String"]>;
  typeId: Scalars["String"];
  amount: Scalars["Float"];
};

export type DeliveryNoteLoadingUnitGroupBy = {
  __typename?: "DeliveryNoteLoadingUnitGroupBy";
  id: Scalars["String"];
  typeId: Scalars["String"];
  amount: Scalars["Float"];
  deliveryNoteId: Scalars["String"];
  _count?: Maybe<DeliveryNoteLoadingUnitCountAggregate>;
  _avg?: Maybe<DeliveryNoteLoadingUnitAvgAggregate>;
  _sum?: Maybe<DeliveryNoteLoadingUnitSumAggregate>;
  _min?: Maybe<DeliveryNoteLoadingUnitMinAggregate>;
  _max?: Maybe<DeliveryNoteLoadingUnitMaxAggregate>;
};

export type DeliveryNoteLoadingUnitListRelationFilter = {
  every?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
  some?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
  none?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
};

export type DeliveryNoteLoadingUnitMaxAggregate = {
  __typename?: "DeliveryNoteLoadingUnitMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  typeId?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
  deliveryNoteId?: Maybe<Scalars["String"]>;
};

export type DeliveryNoteLoadingUnitMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  typeId?: Maybe<SortOrder>;
  amount?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export type DeliveryNoteLoadingUnitMinAggregate = {
  __typename?: "DeliveryNoteLoadingUnitMinAggregate";
  id?: Maybe<Scalars["String"]>;
  typeId?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
  deliveryNoteId?: Maybe<Scalars["String"]>;
};

export type DeliveryNoteLoadingUnitMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  typeId?: Maybe<SortOrder>;
  amount?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export type DeliveryNoteLoadingUnitOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DeliveryNoteLoadingUnitOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  typeId?: Maybe<SortOrder>;
  amount?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
  _count?: Maybe<DeliveryNoteLoadingUnitCountOrderByAggregateInput>;
  _avg?: Maybe<DeliveryNoteLoadingUnitAvgOrderByAggregateInput>;
  _max?: Maybe<DeliveryNoteLoadingUnitMaxOrderByAggregateInput>;
  _min?: Maybe<DeliveryNoteLoadingUnitMinOrderByAggregateInput>;
  _sum?: Maybe<DeliveryNoteLoadingUnitSumOrderByAggregateInput>;
};

export type DeliveryNoteLoadingUnitOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  typeId?: Maybe<SortOrder>;
  amount?: Maybe<SortOrder>;
  deliveryNote?: Maybe<DeliveryNoteOrderByWithRelationInput>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export enum DeliveryNoteLoadingUnitScalarFieldEnum {
  Id = "id",
  TypeId = "typeId",
  Amount = "amount",
  DeliveryNoteId = "deliveryNoteId",
}

export type DeliveryNoteLoadingUnitScalarWhereInput = {
  AND?: Maybe<Array<DeliveryNoteLoadingUnitScalarWhereInput>>;
  OR?: Maybe<Array<DeliveryNoteLoadingUnitScalarWhereInput>>;
  NOT?: Maybe<Array<DeliveryNoteLoadingUnitScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  typeId?: Maybe<StringFilter>;
  amount?: Maybe<FloatFilter>;
  deliveryNoteId?: Maybe<StringFilter>;
};

export type DeliveryNoteLoadingUnitScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DeliveryNoteLoadingUnitScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DeliveryNoteLoadingUnitScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DeliveryNoteLoadingUnitScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  typeId?: Maybe<StringWithAggregatesFilter>;
  amount?: Maybe<FloatWithAggregatesFilter>;
  deliveryNoteId?: Maybe<StringWithAggregatesFilter>;
};

export type DeliveryNoteLoadingUnitSumAggregate = {
  __typename?: "DeliveryNoteLoadingUnitSumAggregate";
  amount?: Maybe<Scalars["Float"]>;
};

export type DeliveryNoteLoadingUnitSumOrderByAggregateInput = {
  amount?: Maybe<SortOrder>;
};

export type DeliveryNoteLoadingUnitUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  typeId?: Maybe<StringFieldUpdateOperationsInput>;
  amount?: Maybe<FloatFieldUpdateOperationsInput>;
  deliveryNote?: Maybe<DeliveryNoteUpdateOneRequiredWithoutLoadingUnitsNestedInput>;
};

export type DeliveryNoteLoadingUnitUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  typeId?: Maybe<StringFieldUpdateOperationsInput>;
  amount?: Maybe<FloatFieldUpdateOperationsInput>;
};

export type DeliveryNoteLoadingUnitUpdateManyWithWhereWithoutDeliveryNoteInput =
  {
    where: DeliveryNoteLoadingUnitScalarWhereInput;
    data: DeliveryNoteLoadingUnitUpdateManyMutationInput;
  };

export type DeliveryNoteLoadingUnitUpdateManyWithoutDeliveryNoteNestedInput = {
  create?: Maybe<Array<DeliveryNoteLoadingUnitCreateWithoutDeliveryNoteInput>>;
  connectOrCreate?: Maybe<
    Array<DeliveryNoteLoadingUnitCreateOrConnectWithoutDeliveryNoteInput>
  >;
  upsert?: Maybe<
    Array<DeliveryNoteLoadingUnitUpsertWithWhereUniqueWithoutDeliveryNoteInput>
  >;
  createMany?: Maybe<DeliveryNoteLoadingUnitCreateManyDeliveryNoteInputEnvelope>;
  set?: Maybe<Array<DeliveryNoteLoadingUnitWhereUniqueInput>>;
  disconnect?: Maybe<Array<DeliveryNoteLoadingUnitWhereUniqueInput>>;
  delete?: Maybe<Array<DeliveryNoteLoadingUnitWhereUniqueInput>>;
  connect?: Maybe<Array<DeliveryNoteLoadingUnitWhereUniqueInput>>;
  update?: Maybe<
    Array<DeliveryNoteLoadingUnitUpdateWithWhereUniqueWithoutDeliveryNoteInput>
  >;
  updateMany?: Maybe<
    Array<DeliveryNoteLoadingUnitUpdateManyWithWhereWithoutDeliveryNoteInput>
  >;
  deleteMany?: Maybe<Array<DeliveryNoteLoadingUnitScalarWhereInput>>;
};

export type DeliveryNoteLoadingUnitUpdateWithWhereUniqueWithoutDeliveryNoteInput =
  {
    where: DeliveryNoteLoadingUnitWhereUniqueInput;
    data: DeliveryNoteLoadingUnitUpdateWithoutDeliveryNoteInput;
  };

export type DeliveryNoteLoadingUnitUpdateWithoutDeliveryNoteInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  typeId?: Maybe<StringFieldUpdateOperationsInput>;
  amount?: Maybe<FloatFieldUpdateOperationsInput>;
};

export type DeliveryNoteLoadingUnitUpsertWithWhereUniqueWithoutDeliveryNoteInput =
  {
    where: DeliveryNoteLoadingUnitWhereUniqueInput;
    update: DeliveryNoteLoadingUnitUpdateWithoutDeliveryNoteInput;
    create: DeliveryNoteLoadingUnitCreateWithoutDeliveryNoteInput;
  };

export type DeliveryNoteLoadingUnitWhereInput = {
  AND?: Maybe<Array<DeliveryNoteLoadingUnitWhereInput>>;
  OR?: Maybe<Array<DeliveryNoteLoadingUnitWhereInput>>;
  NOT?: Maybe<Array<DeliveryNoteLoadingUnitWhereInput>>;
  id?: Maybe<StringFilter>;
  typeId?: Maybe<StringFilter>;
  amount?: Maybe<FloatFilter>;
  deliveryNote?: Maybe<DeliveryNoteRelationFilter>;
  deliveryNoteId?: Maybe<StringFilter>;
};

export type DeliveryNoteLoadingUnitWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type DeliveryNoteMaxAggregate = {
  __typename?: "DeliveryNoteMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  deliveryNoteNumber?: Maybe<Scalars["String"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
  locationId?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["String"]>;
};

export type DeliveryNoteMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  deliveryNoteNumber?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  cash?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  numberOfHalfPallets?: Maybe<SortOrder>;
  numberOfPackages?: Maybe<SortOrder>;
  numberOfOversizedPackages?: Maybe<SortOrder>;
  numberOfRequiredSscc?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
};

export type DeliveryNoteMinAggregate = {
  __typename?: "DeliveryNoteMinAggregate";
  id?: Maybe<Scalars["String"]>;
  deliveryNoteNumber?: Maybe<Scalars["String"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  currency?: Maybe<Scalars["String"]>;
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
  locationId?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["String"]>;
};

export type DeliveryNoteMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  deliveryNoteNumber?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  cash?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  numberOfHalfPallets?: Maybe<SortOrder>;
  numberOfPackages?: Maybe<SortOrder>;
  numberOfOversizedPackages?: Maybe<SortOrder>;
  numberOfRequiredSscc?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
};

export type DeliveryNoteOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DeliveryNoteOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  deliveryNoteNumber?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  cash?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  numberOfHalfPallets?: Maybe<SortOrder>;
  numberOfPackages?: Maybe<SortOrder>;
  numberOfOversizedPackages?: Maybe<SortOrder>;
  numberOfRequiredSscc?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
  _count?: Maybe<DeliveryNoteCountOrderByAggregateInput>;
  _avg?: Maybe<DeliveryNoteAvgOrderByAggregateInput>;
  _max?: Maybe<DeliveryNoteMaxOrderByAggregateInput>;
  _min?: Maybe<DeliveryNoteMinOrderByAggregateInput>;
  _sum?: Maybe<DeliveryNoteSumOrderByAggregateInput>;
};

export type DeliveryNoteOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  deliveryNoteNumber?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  cash?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  numberOfHalfPallets?: Maybe<SortOrder>;
  numberOfPackages?: Maybe<SortOrder>;
  numberOfOversizedPackages?: Maybe<SortOrder>;
  numberOfRequiredSscc?: Maybe<SortOrder>;
  documents?: Maybe<DeliveryNoteDocumentOrderByRelationAggregateInput>;
  note?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  order?: Maybe<OrderOrderByWithRelationInput>;
  orderId?: Maybe<SortOrder>;
  sscc?: Maybe<SsccOrderByRelationAggregateInput>;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitOrderByRelationAggregateInput>;
};

export type DeliveryNoteRelationFilter = {
  is?: Maybe<DeliveryNoteWhereInput>;
  isNot?: Maybe<DeliveryNoteWhereInput>;
};

export enum DeliveryNoteScalarFieldEnum {
  Id = "id",
  DeliveryNoteNumber = "deliveryNoteNumber",
  ConfirmedAt = "confirmedAt",
  Currency = "currency",
  Cash = "cash",
  NumberOfItems = "numberOfItems",
  NumberOfHalfPallets = "numberOfHalfPallets",
  NumberOfPackages = "numberOfPackages",
  NumberOfOversizedPackages = "numberOfOversizedPackages",
  NumberOfRequiredSscc = "numberOfRequiredSscc",
  Note = "note",
  LocationId = "locationId",
  OrderId = "orderId",
}

export type DeliveryNoteScalarWhereInput = {
  AND?: Maybe<Array<DeliveryNoteScalarWhereInput>>;
  OR?: Maybe<Array<DeliveryNoteScalarWhereInput>>;
  NOT?: Maybe<Array<DeliveryNoteScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  deliveryNoteNumber?: Maybe<StringFilter>;
  confirmedAt?: Maybe<DateTimeNullableFilter>;
  currency?: Maybe<StringNullableFilter>;
  cash?: Maybe<FloatNullableFilter>;
  numberOfItems?: Maybe<FloatNullableFilter>;
  numberOfHalfPallets?: Maybe<FloatNullableFilter>;
  numberOfPackages?: Maybe<FloatNullableFilter>;
  numberOfOversizedPackages?: Maybe<FloatNullableFilter>;
  numberOfRequiredSscc?: Maybe<FloatNullableFilter>;
  note?: Maybe<StringNullableFilter>;
  locationId?: Maybe<StringFilter>;
  orderId?: Maybe<StringFilter>;
};

export type DeliveryNoteScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DeliveryNoteScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DeliveryNoteScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DeliveryNoteScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  deliveryNoteNumber?: Maybe<StringWithAggregatesFilter>;
  confirmedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  currency?: Maybe<StringNullableWithAggregatesFilter>;
  cash?: Maybe<FloatNullableWithAggregatesFilter>;
  numberOfItems?: Maybe<FloatNullableWithAggregatesFilter>;
  numberOfHalfPallets?: Maybe<FloatNullableWithAggregatesFilter>;
  numberOfPackages?: Maybe<FloatNullableWithAggregatesFilter>;
  numberOfOversizedPackages?: Maybe<FloatNullableWithAggregatesFilter>;
  numberOfRequiredSscc?: Maybe<FloatNullableWithAggregatesFilter>;
  note?: Maybe<StringNullableWithAggregatesFilter>;
  locationId?: Maybe<StringWithAggregatesFilter>;
  orderId?: Maybe<StringWithAggregatesFilter>;
};

export type DeliveryNoteSumAggregate = {
  __typename?: "DeliveryNoteSumAggregate";
  cash?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  numberOfHalfPallets?: Maybe<Scalars["Float"]>;
  numberOfPackages?: Maybe<Scalars["Float"]>;
  numberOfOversizedPackages?: Maybe<Scalars["Float"]>;
  numberOfRequiredSscc?: Maybe<Scalars["Float"]>;
};

export type DeliveryNoteSumOrderByAggregateInput = {
  cash?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  numberOfHalfPallets?: Maybe<SortOrder>;
  numberOfPackages?: Maybe<SortOrder>;
  numberOfOversizedPackages?: Maybe<SortOrder>;
  numberOfRequiredSscc?: Maybe<SortOrder>;
};

export type DeliveryNoteUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  deliveryNoteNumber?: Maybe<StringFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cash?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfHalfPallets?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfOversizedPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfRequiredSscc?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  documents?: Maybe<DeliveryNoteDocumentUpdateManyWithoutDeliveryNoteNestedInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: Maybe<StringFieldUpdateOperationsInput>;
  order?: Maybe<OrderUpdateOneRequiredWithoutDeliveryNotesNestedInput>;
  sscc?: Maybe<SsccUpdateManyWithoutDeliveryNoteNestedInput>;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitUpdateManyWithoutDeliveryNoteNestedInput>;
};

export type DeliveryNoteUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  deliveryNoteNumber?: Maybe<StringFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cash?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfHalfPallets?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfOversizedPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfRequiredSscc?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DeliveryNoteUpdateManyWithWhereWithoutOrderInput = {
  where: DeliveryNoteScalarWhereInput;
  data: DeliveryNoteUpdateManyMutationInput;
};

export type DeliveryNoteUpdateManyWithoutOrderNestedInput = {
  create?: Maybe<Array<DeliveryNoteCreateWithoutOrderInput>>;
  connectOrCreate?: Maybe<Array<DeliveryNoteCreateOrConnectWithoutOrderInput>>;
  upsert?: Maybe<Array<DeliveryNoteUpsertWithWhereUniqueWithoutOrderInput>>;
  createMany?: Maybe<DeliveryNoteCreateManyOrderInputEnvelope>;
  set?: Maybe<Array<DeliveryNoteWhereUniqueInput>>;
  disconnect?: Maybe<Array<DeliveryNoteWhereUniqueInput>>;
  delete?: Maybe<Array<DeliveryNoteWhereUniqueInput>>;
  connect?: Maybe<Array<DeliveryNoteWhereUniqueInput>>;
  update?: Maybe<Array<DeliveryNoteUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: Maybe<Array<DeliveryNoteUpdateManyWithWhereWithoutOrderInput>>;
  deleteMany?: Maybe<Array<DeliveryNoteScalarWhereInput>>;
};

export type DeliveryNoteUpdateOneRequiredWithoutDocumentsNestedInput = {
  create?: Maybe<DeliveryNoteCreateWithoutDocumentsInput>;
  connectOrCreate?: Maybe<DeliveryNoteCreateOrConnectWithoutDocumentsInput>;
  upsert?: Maybe<DeliveryNoteUpsertWithoutDocumentsInput>;
  connect?: Maybe<DeliveryNoteWhereUniqueInput>;
  update?: Maybe<DeliveryNoteUpdateWithoutDocumentsInput>;
};

export type DeliveryNoteUpdateOneRequiredWithoutLoadingUnitsNestedInput = {
  create?: Maybe<DeliveryNoteCreateWithoutLoadingUnitsInput>;
  connectOrCreate?: Maybe<DeliveryNoteCreateOrConnectWithoutLoadingUnitsInput>;
  upsert?: Maybe<DeliveryNoteUpsertWithoutLoadingUnitsInput>;
  connect?: Maybe<DeliveryNoteWhereUniqueInput>;
  update?: Maybe<DeliveryNoteUpdateWithoutLoadingUnitsInput>;
};

export type DeliveryNoteUpdateOneRequiredWithoutSsccNestedInput = {
  create?: Maybe<DeliveryNoteCreateWithoutSsccInput>;
  connectOrCreate?: Maybe<DeliveryNoteCreateOrConnectWithoutSsccInput>;
  upsert?: Maybe<DeliveryNoteUpsertWithoutSsccInput>;
  connect?: Maybe<DeliveryNoteWhereUniqueInput>;
  update?: Maybe<DeliveryNoteUpdateWithoutSsccInput>;
};

export type DeliveryNoteUpdateWithWhereUniqueWithoutOrderInput = {
  where: DeliveryNoteWhereUniqueInput;
  data: DeliveryNoteUpdateWithoutOrderInput;
};

export type DeliveryNoteUpdateWithoutDocumentsInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  deliveryNoteNumber?: Maybe<StringFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cash?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfHalfPallets?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfOversizedPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfRequiredSscc?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: Maybe<StringFieldUpdateOperationsInput>;
  order?: Maybe<OrderUpdateOneRequiredWithoutDeliveryNotesNestedInput>;
  sscc?: Maybe<SsccUpdateManyWithoutDeliveryNoteNestedInput>;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitUpdateManyWithoutDeliveryNoteNestedInput>;
};

export type DeliveryNoteUpdateWithoutLoadingUnitsInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  deliveryNoteNumber?: Maybe<StringFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cash?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfHalfPallets?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfOversizedPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfRequiredSscc?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  documents?: Maybe<DeliveryNoteDocumentUpdateManyWithoutDeliveryNoteNestedInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: Maybe<StringFieldUpdateOperationsInput>;
  order?: Maybe<OrderUpdateOneRequiredWithoutDeliveryNotesNestedInput>;
  sscc?: Maybe<SsccUpdateManyWithoutDeliveryNoteNestedInput>;
};

export type DeliveryNoteUpdateWithoutOrderInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  deliveryNoteNumber?: Maybe<StringFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cash?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfHalfPallets?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfOversizedPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfRequiredSscc?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  documents?: Maybe<DeliveryNoteDocumentUpdateManyWithoutDeliveryNoteNestedInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: Maybe<StringFieldUpdateOperationsInput>;
  sscc?: Maybe<SsccUpdateManyWithoutDeliveryNoteNestedInput>;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitUpdateManyWithoutDeliveryNoteNestedInput>;
};

export type DeliveryNoteUpdateWithoutSsccInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  deliveryNoteNumber?: Maybe<StringFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cash?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfHalfPallets?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfOversizedPackages?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  numberOfRequiredSscc?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  documents?: Maybe<DeliveryNoteDocumentUpdateManyWithoutDeliveryNoteNestedInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: Maybe<StringFieldUpdateOperationsInput>;
  order?: Maybe<OrderUpdateOneRequiredWithoutDeliveryNotesNestedInput>;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitUpdateManyWithoutDeliveryNoteNestedInput>;
};

export type DeliveryNoteUpsertWithWhereUniqueWithoutOrderInput = {
  where: DeliveryNoteWhereUniqueInput;
  update: DeliveryNoteUpdateWithoutOrderInput;
  create: DeliveryNoteCreateWithoutOrderInput;
};

export type DeliveryNoteUpsertWithoutDocumentsInput = {
  update: DeliveryNoteUpdateWithoutDocumentsInput;
  create: DeliveryNoteCreateWithoutDocumentsInput;
};

export type DeliveryNoteUpsertWithoutLoadingUnitsInput = {
  update: DeliveryNoteUpdateWithoutLoadingUnitsInput;
  create: DeliveryNoteCreateWithoutLoadingUnitsInput;
};

export type DeliveryNoteUpsertWithoutSsccInput = {
  update: DeliveryNoteUpdateWithoutSsccInput;
  create: DeliveryNoteCreateWithoutSsccInput;
};

export type DeliveryNoteWhereInput = {
  AND?: Maybe<Array<DeliveryNoteWhereInput>>;
  OR?: Maybe<Array<DeliveryNoteWhereInput>>;
  NOT?: Maybe<Array<DeliveryNoteWhereInput>>;
  id?: Maybe<StringFilter>;
  deliveryNoteNumber?: Maybe<StringFilter>;
  confirmedAt?: Maybe<DateTimeNullableFilter>;
  currency?: Maybe<StringNullableFilter>;
  cash?: Maybe<FloatNullableFilter>;
  numberOfItems?: Maybe<FloatNullableFilter>;
  numberOfHalfPallets?: Maybe<FloatNullableFilter>;
  numberOfPackages?: Maybe<FloatNullableFilter>;
  numberOfOversizedPackages?: Maybe<FloatNullableFilter>;
  numberOfRequiredSscc?: Maybe<FloatNullableFilter>;
  documents?: Maybe<DeliveryNoteDocumentListRelationFilter>;
  note?: Maybe<StringNullableFilter>;
  locationId?: Maybe<StringFilter>;
  order?: Maybe<OrderRelationFilter>;
  orderId?: Maybe<StringFilter>;
  sscc?: Maybe<SsccListRelationFilter>;
  loadingUnits?: Maybe<DeliveryNoteLoadingUnitListRelationFilter>;
};

export type DeliveryNoteWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type EnumCompanyIngresTypeFieldUpdateOperationsInput = {
  set?: Maybe<CompanyIngresType>;
};

export type EnumCompanyIngresTypeFilter = {
  equals?: Maybe<CompanyIngresType>;
  in?: Maybe<Array<CompanyIngresType>>;
  notIn?: Maybe<Array<CompanyIngresType>>;
  not?: Maybe<NestedEnumCompanyIngresTypeFilter>;
};

export type EnumCompanyIngresTypeWithAggregatesFilter = {
  equals?: Maybe<CompanyIngresType>;
  in?: Maybe<Array<CompanyIngresType>>;
  notIn?: Maybe<Array<CompanyIngresType>>;
  not?: Maybe<NestedEnumCompanyIngresTypeWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedEnumCompanyIngresTypeFilter>;
  _max?: Maybe<NestedEnumCompanyIngresTypeFilter>;
};

export type EnumDeliveryNoteDocumentTypeFieldUpdateOperationsInput = {
  set?: Maybe<DeliveryNoteDocumentType>;
};

export type EnumDeliveryNoteDocumentTypeFilter = {
  equals?: Maybe<DeliveryNoteDocumentType>;
  in?: Maybe<Array<DeliveryNoteDocumentType>>;
  notIn?: Maybe<Array<DeliveryNoteDocumentType>>;
  not?: Maybe<NestedEnumDeliveryNoteDocumentTypeFilter>;
};

export type EnumDeliveryNoteDocumentTypeWithAggregatesFilter = {
  equals?: Maybe<DeliveryNoteDocumentType>;
  in?: Maybe<Array<DeliveryNoteDocumentType>>;
  notIn?: Maybe<Array<DeliveryNoteDocumentType>>;
  not?: Maybe<NestedEnumDeliveryNoteDocumentTypeWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedEnumDeliveryNoteDocumentTypeFilter>;
  _max?: Maybe<NestedEnumDeliveryNoteDocumentTypeFilter>;
};

export type EnumIntegrationTypeNullableFilter = {
  equals?: Maybe<IntegrationType>;
  in?: Maybe<Array<IntegrationType>>;
  notIn?: Maybe<Array<IntegrationType>>;
  not?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
};

export type EnumIntegrationTypeNullableWithAggregatesFilter = {
  equals?: Maybe<IntegrationType>;
  in?: Maybe<Array<IntegrationType>>;
  notIn?: Maybe<Array<IntegrationType>>;
  not?: Maybe<NestedEnumIntegrationTypeNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
  _max?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
};

export type EnumOrderStatusNullableFilter = {
  equals?: Maybe<OrderStatus>;
  in?: Maybe<Array<OrderStatus>>;
  notIn?: Maybe<Array<OrderStatus>>;
  not?: Maybe<NestedEnumOrderStatusNullableFilter>;
};

export type EnumOrderStatusNullableWithAggregatesFilter = {
  equals?: Maybe<OrderStatus>;
  in?: Maybe<Array<OrderStatus>>;
  notIn?: Maybe<Array<OrderStatus>>;
  not?: Maybe<NestedEnumOrderStatusNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedEnumOrderStatusNullableFilter>;
  _max?: Maybe<NestedEnumOrderStatusNullableFilter>;
};

export type EnumOrderTripTypeFieldUpdateOperationsInput = {
  set?: Maybe<OrderTripType>;
};

export type EnumOrderTripTypeFilter = {
  equals?: Maybe<OrderTripType>;
  in?: Maybe<Array<OrderTripType>>;
  notIn?: Maybe<Array<OrderTripType>>;
  not?: Maybe<NestedEnumOrderTripTypeFilter>;
};

export type EnumOrderTripTypeWithAggregatesFilter = {
  equals?: Maybe<OrderTripType>;
  in?: Maybe<Array<OrderTripType>>;
  notIn?: Maybe<Array<OrderTripType>>;
  not?: Maybe<NestedEnumOrderTripTypeWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedEnumOrderTripTypeFilter>;
  _max?: Maybe<NestedEnumOrderTripTypeFilter>;
};

export type FloatFieldUpdateOperationsInput = {
  set?: Maybe<Scalars["Float"]>;
  increment?: Maybe<Scalars["Float"]>;
  decrement?: Maybe<Scalars["Float"]>;
  multiply?: Maybe<Scalars["Float"]>;
  divide?: Maybe<Scalars["Float"]>;
};

export type FloatFilter = {
  equals?: Maybe<Scalars["Float"]>;
  in?: Maybe<Array<Scalars["Float"]>>;
  notIn?: Maybe<Array<Scalars["Float"]>>;
  lt?: Maybe<Scalars["Float"]>;
  lte?: Maybe<Scalars["Float"]>;
  gt?: Maybe<Scalars["Float"]>;
  gte?: Maybe<Scalars["Float"]>;
  not?: Maybe<NestedFloatFilter>;
};

export type FloatNullableFilter = {
  equals?: Maybe<Scalars["Float"]>;
  in?: Maybe<Array<Scalars["Float"]>>;
  notIn?: Maybe<Array<Scalars["Float"]>>;
  lt?: Maybe<Scalars["Float"]>;
  lte?: Maybe<Scalars["Float"]>;
  gt?: Maybe<Scalars["Float"]>;
  gte?: Maybe<Scalars["Float"]>;
  not?: Maybe<NestedFloatNullableFilter>;
};

export type FloatNullableWithAggregatesFilter = {
  equals?: Maybe<Scalars["Float"]>;
  in?: Maybe<Array<Scalars["Float"]>>;
  notIn?: Maybe<Array<Scalars["Float"]>>;
  lt?: Maybe<Scalars["Float"]>;
  lte?: Maybe<Scalars["Float"]>;
  gt?: Maybe<Scalars["Float"]>;
  gte?: Maybe<Scalars["Float"]>;
  not?: Maybe<NestedFloatNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _avg?: Maybe<NestedFloatNullableFilter>;
  _sum?: Maybe<NestedFloatNullableFilter>;
  _min?: Maybe<NestedFloatNullableFilter>;
  _max?: Maybe<NestedFloatNullableFilter>;
};

export type FloatWithAggregatesFilter = {
  equals?: Maybe<Scalars["Float"]>;
  in?: Maybe<Array<Scalars["Float"]>>;
  notIn?: Maybe<Array<Scalars["Float"]>>;
  lt?: Maybe<Scalars["Float"]>;
  lte?: Maybe<Scalars["Float"]>;
  gt?: Maybe<Scalars["Float"]>;
  gte?: Maybe<Scalars["Float"]>;
  not?: Maybe<NestedFloatWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _avg?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedFloatFilter>;
  _min?: Maybe<NestedFloatFilter>;
  _max?: Maybe<NestedFloatFilter>;
};

export type IntFieldUpdateOperationsInput = {
  set?: Maybe<Scalars["Int"]>;
  increment?: Maybe<Scalars["Int"]>;
  decrement?: Maybe<Scalars["Int"]>;
  multiply?: Maybe<Scalars["Int"]>;
  divide?: Maybe<Scalars["Int"]>;
};

export type IntFilter = {
  equals?: Maybe<Scalars["Int"]>;
  in?: Maybe<Array<Scalars["Int"]>>;
  notIn?: Maybe<Array<Scalars["Int"]>>;
  lt?: Maybe<Scalars["Int"]>;
  lte?: Maybe<Scalars["Int"]>;
  gt?: Maybe<Scalars["Int"]>;
  gte?: Maybe<Scalars["Int"]>;
  not?: Maybe<NestedIntFilter>;
};

export type IntWithAggregatesFilter = {
  equals?: Maybe<Scalars["Int"]>;
  in?: Maybe<Array<Scalars["Int"]>>;
  notIn?: Maybe<Array<Scalars["Int"]>>;
  lt?: Maybe<Scalars["Int"]>;
  lte?: Maybe<Scalars["Int"]>;
  gt?: Maybe<Scalars["Int"]>;
  gte?: Maybe<Scalars["Int"]>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _avg?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
};

export enum IntegrationType {
  Ingres = "INGRES",
  Carlo = "CARLO",
}

export type LoadingUnit = {
  __typename?: "LoadingUnit";
  id: Scalars["String"];
  matchcode: Scalars["String"];
  name: Scalars["String"];
};

export type LoadingUnitCountAggregate = {
  __typename?: "LoadingUnitCountAggregate";
  id: Scalars["Int"];
  matchcode: Scalars["Int"];
  name: Scalars["Int"];
  _all: Scalars["Int"];
};

export type LoadingUnitCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  matchcode?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type LoadingUnitCreateInput = {
  id?: Maybe<Scalars["String"]>;
  matchcode: Scalars["String"];
  name: Scalars["String"];
};

export type LoadingUnitCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  matchcode: Scalars["String"];
  name: Scalars["String"];
};

export type LoadingUnitGroupBy = {
  __typename?: "LoadingUnitGroupBy";
  id: Scalars["String"];
  matchcode: Scalars["String"];
  name: Scalars["String"];
  _count?: Maybe<LoadingUnitCountAggregate>;
  _min?: Maybe<LoadingUnitMinAggregate>;
  _max?: Maybe<LoadingUnitMaxAggregate>;
};

export type LoadingUnitMaxAggregate = {
  __typename?: "LoadingUnitMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  matchcode?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type LoadingUnitMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  matchcode?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type LoadingUnitMinAggregate = {
  __typename?: "LoadingUnitMinAggregate";
  id?: Maybe<Scalars["String"]>;
  matchcode?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type LoadingUnitMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  matchcode?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type LoadingUnitOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  matchcode?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  _count?: Maybe<LoadingUnitCountOrderByAggregateInput>;
  _max?: Maybe<LoadingUnitMaxOrderByAggregateInput>;
  _min?: Maybe<LoadingUnitMinOrderByAggregateInput>;
};

export type LoadingUnitOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  matchcode?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export enum LoadingUnitScalarFieldEnum {
  Id = "id",
  Matchcode = "matchcode",
  Name = "name",
}

export type LoadingUnitScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LoadingUnitScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LoadingUnitScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LoadingUnitScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  matchcode?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
};

export type LoadingUnitUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  matchcode?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type LoadingUnitUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  matchcode?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type LoadingUnitWhereInput = {
  AND?: Maybe<Array<LoadingUnitWhereInput>>;
  OR?: Maybe<Array<LoadingUnitWhereInput>>;
  NOT?: Maybe<Array<LoadingUnitWhereInput>>;
  id?: Maybe<StringFilter>;
  matchcode?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
};

export type LoadingUnitWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type Location = {
  __typename?: "Location";
  id: Scalars["String"];
  externalNumber?: Maybe<Scalars["String"]>;
  customerNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  street?: Maybe<Scalars["String"]>;
  houseNumber?: Maybe<Scalars["String"]>;
  town?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  geoCoordLat?: Maybe<Scalars["Float"]>;
  geoCoordLng?: Maybe<Scalars["Float"]>;
  integrationType?: Maybe<IntegrationType>;
};

export type LocationAvgAggregate = {
  __typename?: "LocationAvgAggregate";
  geoCoordLat?: Maybe<Scalars["Float"]>;
  geoCoordLng?: Maybe<Scalars["Float"]>;
};

export type LocationAvgOrderByAggregateInput = {
  geoCoordLat?: Maybe<SortOrder>;
  geoCoordLng?: Maybe<SortOrder>;
};

export type LocationCountAggregate = {
  __typename?: "LocationCountAggregate";
  id: Scalars["Int"];
  externalNumber: Scalars["Int"];
  customerNumber: Scalars["Int"];
  name: Scalars["Int"];
  street: Scalars["Int"];
  houseNumber: Scalars["Int"];
  town: Scalars["Int"];
  zip: Scalars["Int"];
  country: Scalars["Int"];
  firstName: Scalars["Int"];
  lastName: Scalars["Int"];
  phone: Scalars["Int"];
  email: Scalars["Int"];
  note: Scalars["Int"];
  profitCenter: Scalars["Int"];
  geoCoordLat: Scalars["Int"];
  geoCoordLng: Scalars["Int"];
  integrationType: Scalars["Int"];
  _all: Scalars["Int"];
};

export type LocationCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  externalNumber?: Maybe<SortOrder>;
  customerNumber?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
  houseNumber?: Maybe<SortOrder>;
  town?: Maybe<SortOrder>;
  zip?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  geoCoordLat?: Maybe<SortOrder>;
  geoCoordLng?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
};

export type LocationCreateInput = {
  id?: Maybe<Scalars["String"]>;
  externalNumber?: Maybe<Scalars["String"]>;
  customerNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  street?: Maybe<Scalars["String"]>;
  houseNumber?: Maybe<Scalars["String"]>;
  town?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  geoCoordLat?: Maybe<Scalars["Float"]>;
  geoCoordLng?: Maybe<Scalars["Float"]>;
  integrationType?: Maybe<IntegrationType>;
};

export type LocationCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  externalNumber?: Maybe<Scalars["String"]>;
  customerNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  street?: Maybe<Scalars["String"]>;
  houseNumber?: Maybe<Scalars["String"]>;
  town?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  geoCoordLat?: Maybe<Scalars["Float"]>;
  geoCoordLng?: Maybe<Scalars["Float"]>;
  integrationType?: Maybe<IntegrationType>;
};

export type LocationGroupBy = {
  __typename?: "LocationGroupBy";
  id: Scalars["String"];
  externalNumber?: Maybe<Scalars["String"]>;
  customerNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  street?: Maybe<Scalars["String"]>;
  houseNumber?: Maybe<Scalars["String"]>;
  town?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  geoCoordLat?: Maybe<Scalars["Float"]>;
  geoCoordLng?: Maybe<Scalars["Float"]>;
  integrationType?: Maybe<IntegrationType>;
  _count?: Maybe<LocationCountAggregate>;
  _avg?: Maybe<LocationAvgAggregate>;
  _sum?: Maybe<LocationSumAggregate>;
  _min?: Maybe<LocationMinAggregate>;
  _max?: Maybe<LocationMaxAggregate>;
};

export type LocationMaxAggregate = {
  __typename?: "LocationMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  externalNumber?: Maybe<Scalars["String"]>;
  customerNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  street?: Maybe<Scalars["String"]>;
  houseNumber?: Maybe<Scalars["String"]>;
  town?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  geoCoordLat?: Maybe<Scalars["Float"]>;
  geoCoordLng?: Maybe<Scalars["Float"]>;
  integrationType?: Maybe<IntegrationType>;
};

export type LocationMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  externalNumber?: Maybe<SortOrder>;
  customerNumber?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
  houseNumber?: Maybe<SortOrder>;
  town?: Maybe<SortOrder>;
  zip?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  geoCoordLat?: Maybe<SortOrder>;
  geoCoordLng?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
};

export type LocationMinAggregate = {
  __typename?: "LocationMinAggregate";
  id?: Maybe<Scalars["String"]>;
  externalNumber?: Maybe<Scalars["String"]>;
  customerNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  street?: Maybe<Scalars["String"]>;
  houseNumber?: Maybe<Scalars["String"]>;
  town?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  geoCoordLat?: Maybe<Scalars["Float"]>;
  geoCoordLng?: Maybe<Scalars["Float"]>;
  integrationType?: Maybe<IntegrationType>;
};

export type LocationMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  externalNumber?: Maybe<SortOrder>;
  customerNumber?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
  houseNumber?: Maybe<SortOrder>;
  town?: Maybe<SortOrder>;
  zip?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  geoCoordLat?: Maybe<SortOrder>;
  geoCoordLng?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
};

export type LocationOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  externalNumber?: Maybe<SortOrder>;
  customerNumber?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
  houseNumber?: Maybe<SortOrder>;
  town?: Maybe<SortOrder>;
  zip?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  geoCoordLat?: Maybe<SortOrder>;
  geoCoordLng?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  _count?: Maybe<LocationCountOrderByAggregateInput>;
  _avg?: Maybe<LocationAvgOrderByAggregateInput>;
  _max?: Maybe<LocationMaxOrderByAggregateInput>;
  _min?: Maybe<LocationMinOrderByAggregateInput>;
  _sum?: Maybe<LocationSumOrderByAggregateInput>;
};

export type LocationOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  externalNumber?: Maybe<SortOrder>;
  customerNumber?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
  houseNumber?: Maybe<SortOrder>;
  town?: Maybe<SortOrder>;
  zip?: Maybe<SortOrder>;
  country?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  phone?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  geoCoordLat?: Maybe<SortOrder>;
  geoCoordLng?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
};

export enum LocationScalarFieldEnum {
  Id = "id",
  ExternalNumber = "externalNumber",
  CustomerNumber = "customerNumber",
  Name = "name",
  Street = "street",
  HouseNumber = "houseNumber",
  Town = "town",
  Zip = "zip",
  Country = "country",
  FirstName = "firstName",
  LastName = "lastName",
  Phone = "phone",
  Email = "email",
  Note = "note",
  ProfitCenter = "profitCenter",
  GeoCoordLat = "geoCoordLat",
  GeoCoordLng = "geoCoordLng",
  IntegrationType = "integrationType",
}

export type LocationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<LocationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<LocationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<LocationScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  externalNumber?: Maybe<StringNullableWithAggregatesFilter>;
  customerNumber?: Maybe<StringNullableWithAggregatesFilter>;
  name?: Maybe<StringNullableWithAggregatesFilter>;
  street?: Maybe<StringNullableWithAggregatesFilter>;
  houseNumber?: Maybe<StringNullableWithAggregatesFilter>;
  town?: Maybe<StringNullableWithAggregatesFilter>;
  zip?: Maybe<StringNullableWithAggregatesFilter>;
  country?: Maybe<StringNullableWithAggregatesFilter>;
  firstName?: Maybe<StringNullableWithAggregatesFilter>;
  lastName?: Maybe<StringNullableWithAggregatesFilter>;
  phone?: Maybe<StringNullableWithAggregatesFilter>;
  email?: Maybe<StringNullableWithAggregatesFilter>;
  note?: Maybe<StringNullableWithAggregatesFilter>;
  profitCenter?: Maybe<StringNullableWithAggregatesFilter>;
  geoCoordLat?: Maybe<FloatNullableWithAggregatesFilter>;
  geoCoordLng?: Maybe<FloatNullableWithAggregatesFilter>;
  integrationType?: Maybe<EnumIntegrationTypeNullableWithAggregatesFilter>;
};

export type LocationSumAggregate = {
  __typename?: "LocationSumAggregate";
  geoCoordLat?: Maybe<Scalars["Float"]>;
  geoCoordLng?: Maybe<Scalars["Float"]>;
};

export type LocationSumOrderByAggregateInput = {
  geoCoordLat?: Maybe<SortOrder>;
  geoCoordLng?: Maybe<SortOrder>;
};

export type LocationUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  externalNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  customerNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  houseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  town?: Maybe<NullableStringFieldUpdateOperationsInput>;
  zip?: Maybe<NullableStringFieldUpdateOperationsInput>;
  country?: Maybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  phone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  profitCenter?: Maybe<NullableStringFieldUpdateOperationsInput>;
  geoCoordLat?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  geoCoordLng?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  integrationType?: Maybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
};

export type LocationUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  externalNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  customerNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  houseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  town?: Maybe<NullableStringFieldUpdateOperationsInput>;
  zip?: Maybe<NullableStringFieldUpdateOperationsInput>;
  country?: Maybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  phone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  profitCenter?: Maybe<NullableStringFieldUpdateOperationsInput>;
  geoCoordLat?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  geoCoordLng?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  integrationType?: Maybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
};

export type LocationWhereInput = {
  AND?: Maybe<Array<LocationWhereInput>>;
  OR?: Maybe<Array<LocationWhereInput>>;
  NOT?: Maybe<Array<LocationWhereInput>>;
  id?: Maybe<StringFilter>;
  externalNumber?: Maybe<StringNullableFilter>;
  customerNumber?: Maybe<StringNullableFilter>;
  name?: Maybe<StringNullableFilter>;
  street?: Maybe<StringNullableFilter>;
  houseNumber?: Maybe<StringNullableFilter>;
  town?: Maybe<StringNullableFilter>;
  zip?: Maybe<StringNullableFilter>;
  country?: Maybe<StringNullableFilter>;
  firstName?: Maybe<StringNullableFilter>;
  lastName?: Maybe<StringNullableFilter>;
  phone?: Maybe<StringNullableFilter>;
  email?: Maybe<StringNullableFilter>;
  note?: Maybe<StringNullableFilter>;
  profitCenter?: Maybe<StringNullableFilter>;
  geoCoordLat?: Maybe<FloatNullableFilter>;
  geoCoordLng?: Maybe<FloatNullableFilter>;
  integrationType?: Maybe<EnumIntegrationTypeNullableFilter>;
};

export type LocationWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type LoginResponse = {
  __typename?: "LoginResponse";
  user: User;
  access_token: Scalars["String"];
};

export type Mutation = {
  __typename?: "Mutation";
  createManyCaveat: AffectedRowsOutput;
  createOneCaveat: Caveat;
  deleteManyCaveat: AffectedRowsOutput;
  deleteOneCaveat?: Maybe<Caveat>;
  updateManyCaveat: AffectedRowsOutput;
  updateOneCaveat?: Maybe<Caveat>;
  upsertOneCaveat: Caveat;
  createManyCompany: AffectedRowsOutput;
  createOneCompany: Company;
  deleteManyCompany: AffectedRowsOutput;
  deleteOneCompany?: Maybe<Company>;
  updateManyCompany: AffectedRowsOutput;
  updateOneCompany?: Maybe<Company>;
  upsertOneCompany: Company;
  createManyCompanyDefaultValue: AffectedRowsOutput;
  createOneCompanyDefaultValue: CompanyDefaultValue;
  deleteManyCompanyDefaultValue: AffectedRowsOutput;
  deleteOneCompanyDefaultValue?: Maybe<CompanyDefaultValue>;
  updateManyCompanyDefaultValue: AffectedRowsOutput;
  updateOneCompanyDefaultValue?: Maybe<CompanyDefaultValue>;
  upsertOneCompanyDefaultValue: CompanyDefaultValue;
  createManyDeliveryNote: AffectedRowsOutput;
  createOneDeliveryNote: DeliveryNote;
  deleteManyDeliveryNote: AffectedRowsOutput;
  deleteOneDeliveryNote?: Maybe<DeliveryNote>;
  updateManyDeliveryNote: AffectedRowsOutput;
  updateOneDeliveryNote?: Maybe<DeliveryNote>;
  upsertOneDeliveryNote: DeliveryNote;
  createManyDeliveryNoteDocument: AffectedRowsOutput;
  createOneDeliveryNoteDocument: DeliveryNoteDocument;
  deleteManyDeliveryNoteDocument: AffectedRowsOutput;
  deleteOneDeliveryNoteDocument?: Maybe<DeliveryNoteDocument>;
  updateManyDeliveryNoteDocument: AffectedRowsOutput;
  updateOneDeliveryNoteDocument?: Maybe<DeliveryNoteDocument>;
  upsertOneDeliveryNoteDocument: DeliveryNoteDocument;
  createManyDeliveryNoteLoadingUnit: AffectedRowsOutput;
  createOneDeliveryNoteLoadingUnit: DeliveryNoteLoadingUnit;
  deleteManyDeliveryNoteLoadingUnit: AffectedRowsOutput;
  deleteOneDeliveryNoteLoadingUnit?: Maybe<DeliveryNoteLoadingUnit>;
  updateManyDeliveryNoteLoadingUnit: AffectedRowsOutput;
  updateOneDeliveryNoteLoadingUnit?: Maybe<DeliveryNoteLoadingUnit>;
  upsertOneDeliveryNoteLoadingUnit: DeliveryNoteLoadingUnit;
  createManyLoadingUnit: AffectedRowsOutput;
  createOneLoadingUnit: LoadingUnit;
  deleteManyLoadingUnit: AffectedRowsOutput;
  deleteOneLoadingUnit?: Maybe<LoadingUnit>;
  updateManyLoadingUnit: AffectedRowsOutput;
  updateOneLoadingUnit?: Maybe<LoadingUnit>;
  upsertOneLoadingUnit: LoadingUnit;
  createManyLocation: AffectedRowsOutput;
  /** Create a location in system. */
  createOneLocation: Location;
  deleteManyLocation: AffectedRowsOutput;
  /** Delete a location in system. */
  deleteOneLocation: Location;
  updateManyLocation: AffectedRowsOutput;
  /** Update a location in system. */
  updateOneLocation: Location;
  upsertOneLocation: Location;
  createManyOrder: AffectedRowsOutput;
  createOneOrder: Order;
  deleteManyOrder: AffectedRowsOutput;
  deleteOneOrder: Order;
  updateManyOrder: AffectedRowsOutput;
  updateOneOrder: Order;
  upsertOneOrder: Order;
  createManyOrderTrip: AffectedRowsOutput;
  createOneOrderTrip: OrderTrip;
  deleteManyOrderTrip: AffectedRowsOutput;
  deleteOneOrderTrip?: Maybe<OrderTrip>;
  updateManyOrderTrip: AffectedRowsOutput;
  updateOneOrderTrip?: Maybe<OrderTrip>;
  upsertOneOrderTrip: OrderTrip;
  createManySscc: AffectedRowsOutput;
  createOneSscc: Sscc;
  deleteManySscc: AffectedRowsOutput;
  deleteOneSscc?: Maybe<Sscc>;
  updateManySscc: AffectedRowsOutput;
  updateOneSscc?: Maybe<Sscc>;
  upsertOneSscc: Sscc;
  createManyUser: AffectedRowsOutput;
  createOneUser: User;
  deleteManyUser: AffectedRowsOutput;
  deleteOneUser?: Maybe<User>;
  updateManyUser: AffectedRowsOutput;
  updateOneUser: User;
  upsertOneUser: User;
  createManyUserDefaultValue: AffectedRowsOutput;
  createOneUserDefaultValue: UserDefaultValue;
  deleteManyUserDefaultValue: AffectedRowsOutput;
  deleteOneUserDefaultValue?: Maybe<UserDefaultValue>;
  updateManyUserDefaultValue: AffectedRowsOutput;
  updateOneUserDefaultValue?: Maybe<UserDefaultValue>;
  upsertOneUserDefaultValue: UserDefaultValue;
  createManyUserRelCompany: AffectedRowsOutput;
  createOneUserRelCompany: UserRelCompany;
  deleteManyUserRelCompany: AffectedRowsOutput;
  deleteOneUserRelCompany?: Maybe<UserRelCompany>;
  updateManyUserRelCompany: AffectedRowsOutput;
  updateOneUserRelCompany?: Maybe<UserRelCompany>;
  upsertOneUserRelCompany: UserRelCompany;
  login: LoginResponse;
  testMutation: Scalars["Boolean"];
  uploadCompanyLogo: Scalars["String"];
  confirmOrder: Scalars["Boolean"];
  uploadDeliveryNoteDocument: Scalars["String"];
  setCompany: Scalars["Boolean"];
};

export type MutationCreateManyCaveatArgs = {
  data: Array<CaveatCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneCaveatArgs = {
  data: CaveatCreateInput;
};

export type MutationDeleteManyCaveatArgs = {
  where?: Maybe<CaveatWhereInput>;
};

export type MutationDeleteOneCaveatArgs = {
  where: CaveatWhereUniqueInput;
};

export type MutationUpdateManyCaveatArgs = {
  data: CaveatUpdateManyMutationInput;
  where?: Maybe<CaveatWhereInput>;
};

export type MutationUpdateOneCaveatArgs = {
  data: CaveatUpdateInput;
  where: CaveatWhereUniqueInput;
};

export type MutationUpsertOneCaveatArgs = {
  where: CaveatWhereUniqueInput;
  create: CaveatCreateInput;
  update: CaveatUpdateInput;
};

export type MutationCreateManyCompanyArgs = {
  data: Array<CompanyCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneCompanyArgs = {
  data: CompanyCreateInput;
};

export type MutationDeleteManyCompanyArgs = {
  where?: Maybe<CompanyWhereInput>;
};

export type MutationDeleteOneCompanyArgs = {
  where: CompanyWhereUniqueInput;
};

export type MutationUpdateManyCompanyArgs = {
  data: CompanyUpdateManyMutationInput;
  where?: Maybe<CompanyWhereInput>;
};

export type MutationUpdateOneCompanyArgs = {
  data: CompanyUpdateInput;
  where: CompanyWhereUniqueInput;
};

export type MutationUpsertOneCompanyArgs = {
  where: CompanyWhereUniqueInput;
  create: CompanyCreateInput;
  update: CompanyUpdateInput;
};

export type MutationCreateManyCompanyDefaultValueArgs = {
  data: Array<CompanyDefaultValueCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneCompanyDefaultValueArgs = {
  data: CompanyDefaultValueCreateInput;
};

export type MutationDeleteManyCompanyDefaultValueArgs = {
  where?: Maybe<CompanyDefaultValueWhereInput>;
};

export type MutationDeleteOneCompanyDefaultValueArgs = {
  where: CompanyDefaultValueWhereUniqueInput;
};

export type MutationUpdateManyCompanyDefaultValueArgs = {
  data: CompanyDefaultValueUpdateManyMutationInput;
  where?: Maybe<CompanyDefaultValueWhereInput>;
};

export type MutationUpdateOneCompanyDefaultValueArgs = {
  data: CompanyDefaultValueUpdateInput;
  where: CompanyDefaultValueWhereUniqueInput;
};

export type MutationUpsertOneCompanyDefaultValueArgs = {
  where: CompanyDefaultValueWhereUniqueInput;
  create: CompanyDefaultValueCreateInput;
  update: CompanyDefaultValueUpdateInput;
};

export type MutationCreateManyDeliveryNoteArgs = {
  data: Array<DeliveryNoteCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneDeliveryNoteArgs = {
  data: DeliveryNoteCreateInput;
};

export type MutationDeleteManyDeliveryNoteArgs = {
  where?: Maybe<DeliveryNoteWhereInput>;
};

export type MutationDeleteOneDeliveryNoteArgs = {
  where: DeliveryNoteWhereUniqueInput;
};

export type MutationUpdateManyDeliveryNoteArgs = {
  data: DeliveryNoteUpdateManyMutationInput;
  where?: Maybe<DeliveryNoteWhereInput>;
};

export type MutationUpdateOneDeliveryNoteArgs = {
  data: DeliveryNoteUpdateInput;
  where: DeliveryNoteWhereUniqueInput;
};

export type MutationUpsertOneDeliveryNoteArgs = {
  where: DeliveryNoteWhereUniqueInput;
  create: DeliveryNoteCreateInput;
  update: DeliveryNoteUpdateInput;
};

export type MutationCreateManyDeliveryNoteDocumentArgs = {
  data: Array<DeliveryNoteDocumentCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneDeliveryNoteDocumentArgs = {
  data: DeliveryNoteDocumentCreateInput;
};

export type MutationDeleteManyDeliveryNoteDocumentArgs = {
  where?: Maybe<DeliveryNoteDocumentWhereInput>;
};

export type MutationDeleteOneDeliveryNoteDocumentArgs = {
  where: DeliveryNoteDocumentWhereUniqueInput;
};

export type MutationUpdateManyDeliveryNoteDocumentArgs = {
  data: DeliveryNoteDocumentUpdateManyMutationInput;
  where?: Maybe<DeliveryNoteDocumentWhereInput>;
};

export type MutationUpdateOneDeliveryNoteDocumentArgs = {
  data: DeliveryNoteDocumentUpdateInput;
  where: DeliveryNoteDocumentWhereUniqueInput;
};

export type MutationUpsertOneDeliveryNoteDocumentArgs = {
  where: DeliveryNoteDocumentWhereUniqueInput;
  create: DeliveryNoteDocumentCreateInput;
  update: DeliveryNoteDocumentUpdateInput;
};

export type MutationCreateManyDeliveryNoteLoadingUnitArgs = {
  data: Array<DeliveryNoteLoadingUnitCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneDeliveryNoteLoadingUnitArgs = {
  data: DeliveryNoteLoadingUnitCreateInput;
};

export type MutationDeleteManyDeliveryNoteLoadingUnitArgs = {
  where?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
};

export type MutationDeleteOneDeliveryNoteLoadingUnitArgs = {
  where: DeliveryNoteLoadingUnitWhereUniqueInput;
};

export type MutationUpdateManyDeliveryNoteLoadingUnitArgs = {
  data: DeliveryNoteLoadingUnitUpdateManyMutationInput;
  where?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
};

export type MutationUpdateOneDeliveryNoteLoadingUnitArgs = {
  data: DeliveryNoteLoadingUnitUpdateInput;
  where: DeliveryNoteLoadingUnitWhereUniqueInput;
};

export type MutationUpsertOneDeliveryNoteLoadingUnitArgs = {
  where: DeliveryNoteLoadingUnitWhereUniqueInput;
  create: DeliveryNoteLoadingUnitCreateInput;
  update: DeliveryNoteLoadingUnitUpdateInput;
};

export type MutationCreateManyLoadingUnitArgs = {
  data: Array<LoadingUnitCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneLoadingUnitArgs = {
  data: LoadingUnitCreateInput;
};

export type MutationDeleteManyLoadingUnitArgs = {
  where?: Maybe<LoadingUnitWhereInput>;
};

export type MutationDeleteOneLoadingUnitArgs = {
  where: LoadingUnitWhereUniqueInput;
};

export type MutationUpdateManyLoadingUnitArgs = {
  data: LoadingUnitUpdateManyMutationInput;
  where?: Maybe<LoadingUnitWhereInput>;
};

export type MutationUpdateOneLoadingUnitArgs = {
  data: LoadingUnitUpdateInput;
  where: LoadingUnitWhereUniqueInput;
};

export type MutationUpsertOneLoadingUnitArgs = {
  where: LoadingUnitWhereUniqueInput;
  create: LoadingUnitCreateInput;
  update: LoadingUnitUpdateInput;
};

export type MutationCreateManyLocationArgs = {
  data: Array<LocationCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneLocationArgs = {
  data: LocationCreateInput;
};

export type MutationDeleteManyLocationArgs = {
  where?: Maybe<LocationWhereInput>;
};

export type MutationDeleteOneLocationArgs = {
  where: LocationWhereUniqueInput;
};

export type MutationUpdateManyLocationArgs = {
  data: LocationUpdateManyMutationInput;
  where?: Maybe<LocationWhereInput>;
};

export type MutationUpdateOneLocationArgs = {
  data: LocationUpdateInput;
  where: LocationWhereUniqueInput;
};

export type MutationUpsertOneLocationArgs = {
  where: LocationWhereUniqueInput;
  create: LocationCreateInput;
  update: LocationUpdateInput;
};

export type MutationCreateManyOrderArgs = {
  data: Array<OrderCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneOrderArgs = {
  data: OrderCreateInput;
};

export type MutationDeleteManyOrderArgs = {
  where?: Maybe<OrderWhereInput>;
};

export type MutationDeleteOneOrderArgs = {
  where: OrderWhereUniqueInput;
};

export type MutationUpdateManyOrderArgs = {
  data: OrderUpdateManyMutationInput;
  where?: Maybe<OrderWhereInput>;
};

export type MutationUpdateOneOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};

export type MutationUpsertOneOrderArgs = {
  where: OrderWhereUniqueInput;
  create: OrderCreateInput;
  update: OrderUpdateInput;
};

export type MutationCreateManyOrderTripArgs = {
  data: Array<OrderTripCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneOrderTripArgs = {
  data: OrderTripCreateInput;
};

export type MutationDeleteManyOrderTripArgs = {
  where?: Maybe<OrderTripWhereInput>;
};

export type MutationDeleteOneOrderTripArgs = {
  where: OrderTripWhereUniqueInput;
};

export type MutationUpdateManyOrderTripArgs = {
  data: OrderTripUpdateManyMutationInput;
  where?: Maybe<OrderTripWhereInput>;
};

export type MutationUpdateOneOrderTripArgs = {
  data: OrderTripUpdateInput;
  where: OrderTripWhereUniqueInput;
};

export type MutationUpsertOneOrderTripArgs = {
  where: OrderTripWhereUniqueInput;
  create: OrderTripCreateInput;
  update: OrderTripUpdateInput;
};

export type MutationCreateManySsccArgs = {
  data: Array<SsccCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneSsccArgs = {
  data: SsccCreateInput;
};

export type MutationDeleteManySsccArgs = {
  where?: Maybe<SsccWhereInput>;
};

export type MutationDeleteOneSsccArgs = {
  where: SsccWhereUniqueInput;
};

export type MutationUpdateManySsccArgs = {
  data: SsccUpdateManyMutationInput;
  where?: Maybe<SsccWhereInput>;
};

export type MutationUpdateOneSsccArgs = {
  data: SsccUpdateInput;
  where: SsccWhereUniqueInput;
};

export type MutationUpsertOneSsccArgs = {
  where: SsccWhereUniqueInput;
  create: SsccCreateInput;
  update: SsccUpdateInput;
};

export type MutationCreateManyUserArgs = {
  data: Array<UserCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneUserArgs = {
  data: UserCreateInput;
};

export type MutationDeleteManyUserArgs = {
  where?: Maybe<UserWhereInput>;
};

export type MutationDeleteOneUserArgs = {
  where: UserWhereUniqueInput;
};

export type MutationUpdateManyUserArgs = {
  data: UserUpdateManyMutationInput;
  where?: Maybe<UserWhereInput>;
};

export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type MutationUpsertOneUserArgs = {
  where: UserWhereUniqueInput;
  create: UserCreateInput;
  update: UserUpdateInput;
};

export type MutationCreateManyUserDefaultValueArgs = {
  data: Array<UserDefaultValueCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneUserDefaultValueArgs = {
  data: UserDefaultValueCreateInput;
};

export type MutationDeleteManyUserDefaultValueArgs = {
  where?: Maybe<UserDefaultValueWhereInput>;
};

export type MutationDeleteOneUserDefaultValueArgs = {
  where: UserDefaultValueWhereUniqueInput;
};

export type MutationUpdateManyUserDefaultValueArgs = {
  data: UserDefaultValueUpdateManyMutationInput;
  where?: Maybe<UserDefaultValueWhereInput>;
};

export type MutationUpdateOneUserDefaultValueArgs = {
  data: UserDefaultValueUpdateInput;
  where: UserDefaultValueWhereUniqueInput;
};

export type MutationUpsertOneUserDefaultValueArgs = {
  where: UserDefaultValueWhereUniqueInput;
  create: UserDefaultValueCreateInput;
  update: UserDefaultValueUpdateInput;
};

export type MutationCreateManyUserRelCompanyArgs = {
  data: Array<UserRelCompanyCreateManyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type MutationCreateOneUserRelCompanyArgs = {
  data: UserRelCompanyCreateInput;
};

export type MutationDeleteManyUserRelCompanyArgs = {
  where?: Maybe<UserRelCompanyWhereInput>;
};

export type MutationDeleteOneUserRelCompanyArgs = {
  where: UserRelCompanyWhereUniqueInput;
};

export type MutationUpdateManyUserRelCompanyArgs = {
  data: UserRelCompanyUpdateManyMutationInput;
  where?: Maybe<UserRelCompanyWhereInput>;
};

export type MutationUpdateOneUserRelCompanyArgs = {
  data: UserRelCompanyUpdateInput;
  where: UserRelCompanyWhereUniqueInput;
};

export type MutationUpsertOneUserRelCompanyArgs = {
  where: UserRelCompanyWhereUniqueInput;
  create: UserRelCompanyCreateInput;
  update: UserRelCompanyUpdateInput;
};

export type MutationLoginArgs = {
  password: Scalars["String"];
  email: Scalars["String"];
};

export type MutationUploadCompanyLogoArgs = {
  file: Scalars["Upload"];
  companyId: Scalars["String"];
};

export type MutationConfirmOrderArgs = {
  id: Scalars["String"];
};

export type MutationUploadDeliveryNoteDocumentArgs = {
  file: Scalars["Upload"];
  deliveryNoteId: Scalars["String"];
  type: Scalars["String"];
};

export type MutationSetCompanyArgs = {
  companyId: Scalars["String"];
};

export type NestedBoolFilter = {
  equals?: Maybe<Scalars["Boolean"]>;
  not?: Maybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: Maybe<Scalars["Boolean"]>;
  not?: Maybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  equals?: Maybe<Scalars["Boolean"]>;
  not?: Maybe<NestedBoolNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedBoolNullableFilter>;
  _max?: Maybe<NestedBoolNullableFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  equals?: Maybe<Scalars["Boolean"]>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedBoolFilter>;
  _max?: Maybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: Maybe<Scalars["DateTime"]>;
  in?: Maybe<Array<Scalars["DateTime"]>>;
  notIn?: Maybe<Array<Scalars["DateTime"]>>;
  lt?: Maybe<Scalars["DateTime"]>;
  lte?: Maybe<Scalars["DateTime"]>;
  gt?: Maybe<Scalars["DateTime"]>;
  gte?: Maybe<Scalars["DateTime"]>;
  not?: Maybe<NestedDateTimeFilter>;
};

export type NestedDateTimeNullableFilter = {
  equals?: Maybe<Scalars["DateTime"]>;
  in?: Maybe<Array<Scalars["DateTime"]>>;
  notIn?: Maybe<Array<Scalars["DateTime"]>>;
  lt?: Maybe<Scalars["DateTime"]>;
  lte?: Maybe<Scalars["DateTime"]>;
  gt?: Maybe<Scalars["DateTime"]>;
  gte?: Maybe<Scalars["DateTime"]>;
  not?: Maybe<NestedDateTimeNullableFilter>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  equals?: Maybe<Scalars["DateTime"]>;
  in?: Maybe<Array<Scalars["DateTime"]>>;
  notIn?: Maybe<Array<Scalars["DateTime"]>>;
  lt?: Maybe<Scalars["DateTime"]>;
  lte?: Maybe<Scalars["DateTime"]>;
  gt?: Maybe<Scalars["DateTime"]>;
  gte?: Maybe<Scalars["DateTime"]>;
  not?: Maybe<NestedDateTimeNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedDateTimeNullableFilter>;
  _max?: Maybe<NestedDateTimeNullableFilter>;
};

export type NestedDateTimeWithAggregatesFilter = {
  equals?: Maybe<Scalars["DateTime"]>;
  in?: Maybe<Array<Scalars["DateTime"]>>;
  notIn?: Maybe<Array<Scalars["DateTime"]>>;
  lt?: Maybe<Scalars["DateTime"]>;
  lte?: Maybe<Scalars["DateTime"]>;
  gt?: Maybe<Scalars["DateTime"]>;
  gte?: Maybe<Scalars["DateTime"]>;
  not?: Maybe<NestedDateTimeWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedDateTimeFilter>;
  _max?: Maybe<NestedDateTimeFilter>;
};

export type NestedEnumCompanyIngresTypeFilter = {
  equals?: Maybe<CompanyIngresType>;
  in?: Maybe<Array<CompanyIngresType>>;
  notIn?: Maybe<Array<CompanyIngresType>>;
  not?: Maybe<NestedEnumCompanyIngresTypeFilter>;
};

export type NestedEnumCompanyIngresTypeWithAggregatesFilter = {
  equals?: Maybe<CompanyIngresType>;
  in?: Maybe<Array<CompanyIngresType>>;
  notIn?: Maybe<Array<CompanyIngresType>>;
  not?: Maybe<NestedEnumCompanyIngresTypeWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedEnumCompanyIngresTypeFilter>;
  _max?: Maybe<NestedEnumCompanyIngresTypeFilter>;
};

export type NestedEnumDeliveryNoteDocumentTypeFilter = {
  equals?: Maybe<DeliveryNoteDocumentType>;
  in?: Maybe<Array<DeliveryNoteDocumentType>>;
  notIn?: Maybe<Array<DeliveryNoteDocumentType>>;
  not?: Maybe<NestedEnumDeliveryNoteDocumentTypeFilter>;
};

export type NestedEnumDeliveryNoteDocumentTypeWithAggregatesFilter = {
  equals?: Maybe<DeliveryNoteDocumentType>;
  in?: Maybe<Array<DeliveryNoteDocumentType>>;
  notIn?: Maybe<Array<DeliveryNoteDocumentType>>;
  not?: Maybe<NestedEnumDeliveryNoteDocumentTypeWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedEnumDeliveryNoteDocumentTypeFilter>;
  _max?: Maybe<NestedEnumDeliveryNoteDocumentTypeFilter>;
};

export type NestedEnumIntegrationTypeNullableFilter = {
  equals?: Maybe<IntegrationType>;
  in?: Maybe<Array<IntegrationType>>;
  notIn?: Maybe<Array<IntegrationType>>;
  not?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
};

export type NestedEnumIntegrationTypeNullableWithAggregatesFilter = {
  equals?: Maybe<IntegrationType>;
  in?: Maybe<Array<IntegrationType>>;
  notIn?: Maybe<Array<IntegrationType>>;
  not?: Maybe<NestedEnumIntegrationTypeNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
  _max?: Maybe<NestedEnumIntegrationTypeNullableFilter>;
};

export type NestedEnumOrderStatusNullableFilter = {
  equals?: Maybe<OrderStatus>;
  in?: Maybe<Array<OrderStatus>>;
  notIn?: Maybe<Array<OrderStatus>>;
  not?: Maybe<NestedEnumOrderStatusNullableFilter>;
};

export type NestedEnumOrderStatusNullableWithAggregatesFilter = {
  equals?: Maybe<OrderStatus>;
  in?: Maybe<Array<OrderStatus>>;
  notIn?: Maybe<Array<OrderStatus>>;
  not?: Maybe<NestedEnumOrderStatusNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedEnumOrderStatusNullableFilter>;
  _max?: Maybe<NestedEnumOrderStatusNullableFilter>;
};

export type NestedEnumOrderTripTypeFilter = {
  equals?: Maybe<OrderTripType>;
  in?: Maybe<Array<OrderTripType>>;
  notIn?: Maybe<Array<OrderTripType>>;
  not?: Maybe<NestedEnumOrderTripTypeFilter>;
};

export type NestedEnumOrderTripTypeWithAggregatesFilter = {
  equals?: Maybe<OrderTripType>;
  in?: Maybe<Array<OrderTripType>>;
  notIn?: Maybe<Array<OrderTripType>>;
  not?: Maybe<NestedEnumOrderTripTypeWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedEnumOrderTripTypeFilter>;
  _max?: Maybe<NestedEnumOrderTripTypeFilter>;
};

export type NestedFloatFilter = {
  equals?: Maybe<Scalars["Float"]>;
  in?: Maybe<Array<Scalars["Float"]>>;
  notIn?: Maybe<Array<Scalars["Float"]>>;
  lt?: Maybe<Scalars["Float"]>;
  lte?: Maybe<Scalars["Float"]>;
  gt?: Maybe<Scalars["Float"]>;
  gte?: Maybe<Scalars["Float"]>;
  not?: Maybe<NestedFloatFilter>;
};

export type NestedFloatNullableFilter = {
  equals?: Maybe<Scalars["Float"]>;
  in?: Maybe<Array<Scalars["Float"]>>;
  notIn?: Maybe<Array<Scalars["Float"]>>;
  lt?: Maybe<Scalars["Float"]>;
  lte?: Maybe<Scalars["Float"]>;
  gt?: Maybe<Scalars["Float"]>;
  gte?: Maybe<Scalars["Float"]>;
  not?: Maybe<NestedFloatNullableFilter>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  equals?: Maybe<Scalars["Float"]>;
  in?: Maybe<Array<Scalars["Float"]>>;
  notIn?: Maybe<Array<Scalars["Float"]>>;
  lt?: Maybe<Scalars["Float"]>;
  lte?: Maybe<Scalars["Float"]>;
  gt?: Maybe<Scalars["Float"]>;
  gte?: Maybe<Scalars["Float"]>;
  not?: Maybe<NestedFloatNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _avg?: Maybe<NestedFloatNullableFilter>;
  _sum?: Maybe<NestedFloatNullableFilter>;
  _min?: Maybe<NestedFloatNullableFilter>;
  _max?: Maybe<NestedFloatNullableFilter>;
};

export type NestedFloatWithAggregatesFilter = {
  equals?: Maybe<Scalars["Float"]>;
  in?: Maybe<Array<Scalars["Float"]>>;
  notIn?: Maybe<Array<Scalars["Float"]>>;
  lt?: Maybe<Scalars["Float"]>;
  lte?: Maybe<Scalars["Float"]>;
  gt?: Maybe<Scalars["Float"]>;
  gte?: Maybe<Scalars["Float"]>;
  not?: Maybe<NestedFloatWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _avg?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedFloatFilter>;
  _min?: Maybe<NestedFloatFilter>;
  _max?: Maybe<NestedFloatFilter>;
};

export type NestedIntFilter = {
  equals?: Maybe<Scalars["Int"]>;
  in?: Maybe<Array<Scalars["Int"]>>;
  notIn?: Maybe<Array<Scalars["Int"]>>;
  lt?: Maybe<Scalars["Int"]>;
  lte?: Maybe<Scalars["Int"]>;
  gt?: Maybe<Scalars["Int"]>;
  gte?: Maybe<Scalars["Int"]>;
  not?: Maybe<NestedIntFilter>;
};

export type NestedIntNullableFilter = {
  equals?: Maybe<Scalars["Int"]>;
  in?: Maybe<Array<Scalars["Int"]>>;
  notIn?: Maybe<Array<Scalars["Int"]>>;
  lt?: Maybe<Scalars["Int"]>;
  lte?: Maybe<Scalars["Int"]>;
  gt?: Maybe<Scalars["Int"]>;
  gte?: Maybe<Scalars["Int"]>;
  not?: Maybe<NestedIntNullableFilter>;
};

export type NestedIntWithAggregatesFilter = {
  equals?: Maybe<Scalars["Int"]>;
  in?: Maybe<Array<Scalars["Int"]>>;
  notIn?: Maybe<Array<Scalars["Int"]>>;
  lt?: Maybe<Scalars["Int"]>;
  lte?: Maybe<Scalars["Int"]>;
  gt?: Maybe<Scalars["Int"]>;
  gte?: Maybe<Scalars["Int"]>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _avg?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
};

export type NestedStringFilter = {
  equals?: Maybe<Scalars["String"]>;
  in?: Maybe<Array<Scalars["String"]>>;
  notIn?: Maybe<Array<Scalars["String"]>>;
  lt?: Maybe<Scalars["String"]>;
  lte?: Maybe<Scalars["String"]>;
  gt?: Maybe<Scalars["String"]>;
  gte?: Maybe<Scalars["String"]>;
  contains?: Maybe<Scalars["String"]>;
  startsWith?: Maybe<Scalars["String"]>;
  endsWith?: Maybe<Scalars["String"]>;
  not?: Maybe<NestedStringFilter>;
};

export type NestedStringNullableFilter = {
  equals?: Maybe<Scalars["String"]>;
  in?: Maybe<Array<Scalars["String"]>>;
  notIn?: Maybe<Array<Scalars["String"]>>;
  lt?: Maybe<Scalars["String"]>;
  lte?: Maybe<Scalars["String"]>;
  gt?: Maybe<Scalars["String"]>;
  gte?: Maybe<Scalars["String"]>;
  contains?: Maybe<Scalars["String"]>;
  startsWith?: Maybe<Scalars["String"]>;
  endsWith?: Maybe<Scalars["String"]>;
  not?: Maybe<NestedStringNullableFilter>;
};

export type NestedStringNullableWithAggregatesFilter = {
  equals?: Maybe<Scalars["String"]>;
  in?: Maybe<Array<Scalars["String"]>>;
  notIn?: Maybe<Array<Scalars["String"]>>;
  lt?: Maybe<Scalars["String"]>;
  lte?: Maybe<Scalars["String"]>;
  gt?: Maybe<Scalars["String"]>;
  gte?: Maybe<Scalars["String"]>;
  contains?: Maybe<Scalars["String"]>;
  startsWith?: Maybe<Scalars["String"]>;
  endsWith?: Maybe<Scalars["String"]>;
  not?: Maybe<NestedStringNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedStringNullableFilter>;
  _max?: Maybe<NestedStringNullableFilter>;
};

export type NestedStringWithAggregatesFilter = {
  equals?: Maybe<Scalars["String"]>;
  in?: Maybe<Array<Scalars["String"]>>;
  notIn?: Maybe<Array<Scalars["String"]>>;
  lt?: Maybe<Scalars["String"]>;
  lte?: Maybe<Scalars["String"]>;
  gt?: Maybe<Scalars["String"]>;
  gte?: Maybe<Scalars["String"]>;
  contains?: Maybe<Scalars["String"]>;
  startsWith?: Maybe<Scalars["String"]>;
  endsWith?: Maybe<Scalars["String"]>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedStringFilter>;
  _max?: Maybe<NestedStringFilter>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: Maybe<Scalars["Boolean"]>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: Maybe<Scalars["DateTime"]>;
};

export type NullableEnumIntegrationTypeFieldUpdateOperationsInput = {
  set?: Maybe<IntegrationType>;
};

export type NullableEnumOrderStatusFieldUpdateOperationsInput = {
  set?: Maybe<OrderStatus>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  set?: Maybe<Scalars["Float"]>;
  increment?: Maybe<Scalars["Float"]>;
  decrement?: Maybe<Scalars["Float"]>;
  multiply?: Maybe<Scalars["Float"]>;
  divide?: Maybe<Scalars["Float"]>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: Maybe<Scalars["String"]>;
};

export type Order = {
  __typename?: "Order";
  id: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  companyId: Scalars["String"];
  status?: Maybe<OrderStatus>;
  importedAt: Scalars["DateTime"];
  createdAt: Scalars["DateTime"];
  updatedAt?: Maybe<Scalars["DateTime"]>;
  _count?: Maybe<OrderCount>;
  user?: Maybe<User>;
  company: Company;
  deliveryNotes: Array<DeliveryNote>;
  orderTrips: Array<OrderTrip>;
  caveats: Array<Caveat>;
};

export type OrderDeliveryNotesArgs = {
  where?: Maybe<DeliveryNoteWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteScalarFieldEnum>>;
};

export type OrderOrderTripsArgs = {
  where?: Maybe<OrderTripWhereInput>;
  orderBy?: Maybe<Array<OrderTripOrderByWithRelationInput>>;
  cursor?: Maybe<OrderTripWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<OrderTripScalarFieldEnum>>;
};

export type OrderCaveatsArgs = {
  where?: Maybe<CaveatWhereInput>;
  orderBy?: Maybe<Array<CaveatOrderByWithRelationInput>>;
  cursor?: Maybe<CaveatWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CaveatScalarFieldEnum>>;
};

export type OrderAvgAggregate = {
  __typename?: "OrderAvgAggregate";
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
};

export type OrderAvgOrderByAggregateInput = {
  mass?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  orderCost?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
};

export type OrderCount = {
  __typename?: "OrderCount";
  deliveryNotes: Scalars["Int"];
  orderTrips: Scalars["Int"];
  caveats: Scalars["Int"];
};

export type OrderCountAggregate = {
  __typename?: "OrderCountAggregate";
  id: Scalars["Int"];
  userId: Scalars["Int"];
  integrationType: Scalars["Int"];
  orderType: Scalars["Int"];
  action: Scalars["Int"];
  profitCenter: Scalars["Int"];
  referenceOrderNumber: Scalars["Int"];
  externalSystemOrderNumberIngres: Scalars["Int"];
  externalSystemOrderNumberCarlo: Scalars["Int"];
  invoiceNumber: Scalars["Int"];
  orderNumber: Scalars["Int"];
  loadingDate: Scalars["Int"];
  loadingLocationId: Scalars["Int"];
  loadingNote: Scalars["Int"];
  loadingPostcode: Scalars["Int"];
  loadingName: Scalars["Int"];
  loadingStreet: Scalars["Int"];
  loadingHouseNumber: Scalars["Int"];
  loadingCity: Scalars["Int"];
  loadingCountry: Scalars["Int"];
  unloadingName: Scalars["Int"];
  unloadingStreet: Scalars["Int"];
  unloadingHouseNumber: Scalars["Int"];
  unloadingCountry: Scalars["Int"];
  unloadingCity: Scalars["Int"];
  unloadingPostcode: Scalars["Int"];
  unloadingDate: Scalars["Int"];
  unloadingLocationId: Scalars["Int"];
  unloadingNote: Scalars["Int"];
  downloadedSsccAt: Scalars["Int"];
  driver: Scalars["Int"];
  licensePlate: Scalars["Int"];
  mass: Scalars["Int"];
  cost: Scalars["Int"];
  currency: Scalars["Int"];
  orderCost: Scalars["Int"];
  orderCurrency: Scalars["Int"];
  numberOfItems: Scalars["Int"];
  salesType: Scalars["Int"];
  noteForInvoice: Scalars["Int"];
  noteOnInvoice: Scalars["Int"];
  noteForDispatch: Scalars["Int"];
  isMain: Scalars["Int"];
  confirmedAt: Scalars["Int"];
  companyId: Scalars["Int"];
  status: Scalars["Int"];
  importedAt: Scalars["Int"];
  createdAt: Scalars["Int"];
  updatedAt: Scalars["Int"];
  _all: Scalars["Int"];
};

export type OrderCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  orderType?: Maybe<SortOrder>;
  action?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  referenceOrderNumber?: Maybe<SortOrder>;
  externalSystemOrderNumberIngres?: Maybe<SortOrder>;
  externalSystemOrderNumberCarlo?: Maybe<SortOrder>;
  invoiceNumber?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  loadingDate?: Maybe<SortOrder>;
  loadingLocationId?: Maybe<SortOrder>;
  loadingNote?: Maybe<SortOrder>;
  loadingPostcode?: Maybe<SortOrder>;
  loadingName?: Maybe<SortOrder>;
  loadingStreet?: Maybe<SortOrder>;
  loadingHouseNumber?: Maybe<SortOrder>;
  loadingCity?: Maybe<SortOrder>;
  loadingCountry?: Maybe<SortOrder>;
  unloadingName?: Maybe<SortOrder>;
  unloadingStreet?: Maybe<SortOrder>;
  unloadingHouseNumber?: Maybe<SortOrder>;
  unloadingCountry?: Maybe<SortOrder>;
  unloadingCity?: Maybe<SortOrder>;
  unloadingPostcode?: Maybe<SortOrder>;
  unloadingDate?: Maybe<SortOrder>;
  unloadingLocationId?: Maybe<SortOrder>;
  unloadingNote?: Maybe<SortOrder>;
  downloadedSsccAt?: Maybe<SortOrder>;
  driver?: Maybe<SortOrder>;
  licensePlate?: Maybe<SortOrder>;
  mass?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  orderCost?: Maybe<SortOrder>;
  orderCurrency?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  salesType?: Maybe<SortOrder>;
  noteForInvoice?: Maybe<SortOrder>;
  noteOnInvoice?: Maybe<SortOrder>;
  noteForDispatch?: Maybe<SortOrder>;
  isMain?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrderCreateInput = {
  id?: Maybe<Scalars["String"]>;
  user?: Maybe<UserCreateNestedOneWithoutOrdersInput>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  company: CompanyCreateNestedOneWithoutOrdersInput;
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  deliveryNotes?: Maybe<DeliveryNoteCreateNestedManyWithoutOrderInput>;
  orderTrips?: Maybe<OrderTripCreateNestedManyWithoutOrderInput>;
  caveats?: Maybe<CaveatCreateNestedManyWithoutOrderInput>;
};

export type OrderCreateManyCompanyInput = {
  id?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type OrderCreateManyCompanyInputEnvelope = {
  data: Array<OrderCreateManyCompanyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type OrderCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  companyId: Scalars["String"];
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type OrderCreateManyUserInput = {
  id?: Maybe<Scalars["String"]>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  companyId: Scalars["String"];
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type OrderCreateManyUserInputEnvelope = {
  data: Array<OrderCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type OrderCreateNestedManyWithoutCompanyInput = {
  create?: Maybe<Array<OrderCreateWithoutCompanyInput>>;
  connectOrCreate?: Maybe<Array<OrderCreateOrConnectWithoutCompanyInput>>;
  createMany?: Maybe<OrderCreateManyCompanyInputEnvelope>;
  connect?: Maybe<Array<OrderWhereUniqueInput>>;
};

export type OrderCreateNestedManyWithoutUserInput = {
  create?: Maybe<Array<OrderCreateWithoutUserInput>>;
  connectOrCreate?: Maybe<Array<OrderCreateOrConnectWithoutUserInput>>;
  createMany?: Maybe<OrderCreateManyUserInputEnvelope>;
  connect?: Maybe<Array<OrderWhereUniqueInput>>;
};

export type OrderCreateNestedOneWithoutCaveatsInput = {
  create?: Maybe<OrderCreateWithoutCaveatsInput>;
  connectOrCreate?: Maybe<OrderCreateOrConnectWithoutCaveatsInput>;
  connect?: Maybe<OrderWhereUniqueInput>;
};

export type OrderCreateNestedOneWithoutDeliveryNotesInput = {
  create?: Maybe<OrderCreateWithoutDeliveryNotesInput>;
  connectOrCreate?: Maybe<OrderCreateOrConnectWithoutDeliveryNotesInput>;
  connect?: Maybe<OrderWhereUniqueInput>;
};

export type OrderCreateNestedOneWithoutOrderTripsInput = {
  create?: Maybe<OrderCreateWithoutOrderTripsInput>;
  connectOrCreate?: Maybe<OrderCreateOrConnectWithoutOrderTripsInput>;
  connect?: Maybe<OrderWhereUniqueInput>;
};

export type OrderCreateOrConnectWithoutCaveatsInput = {
  where: OrderWhereUniqueInput;
  create: OrderCreateWithoutCaveatsInput;
};

export type OrderCreateOrConnectWithoutCompanyInput = {
  where: OrderWhereUniqueInput;
  create: OrderCreateWithoutCompanyInput;
};

export type OrderCreateOrConnectWithoutDeliveryNotesInput = {
  where: OrderWhereUniqueInput;
  create: OrderCreateWithoutDeliveryNotesInput;
};

export type OrderCreateOrConnectWithoutOrderTripsInput = {
  where: OrderWhereUniqueInput;
  create: OrderCreateWithoutOrderTripsInput;
};

export type OrderCreateOrConnectWithoutUserInput = {
  where: OrderWhereUniqueInput;
  create: OrderCreateWithoutUserInput;
};

export type OrderCreateWithoutCaveatsInput = {
  id?: Maybe<Scalars["String"]>;
  user?: Maybe<UserCreateNestedOneWithoutOrdersInput>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  company: CompanyCreateNestedOneWithoutOrdersInput;
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  deliveryNotes?: Maybe<DeliveryNoteCreateNestedManyWithoutOrderInput>;
  orderTrips?: Maybe<OrderTripCreateNestedManyWithoutOrderInput>;
};

export type OrderCreateWithoutCompanyInput = {
  id?: Maybe<Scalars["String"]>;
  user?: Maybe<UserCreateNestedOneWithoutOrdersInput>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  deliveryNotes?: Maybe<DeliveryNoteCreateNestedManyWithoutOrderInput>;
  orderTrips?: Maybe<OrderTripCreateNestedManyWithoutOrderInput>;
  caveats?: Maybe<CaveatCreateNestedManyWithoutOrderInput>;
};

export type OrderCreateWithoutDeliveryNotesInput = {
  id?: Maybe<Scalars["String"]>;
  user?: Maybe<UserCreateNestedOneWithoutOrdersInput>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  company: CompanyCreateNestedOneWithoutOrdersInput;
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  orderTrips?: Maybe<OrderTripCreateNestedManyWithoutOrderInput>;
  caveats?: Maybe<CaveatCreateNestedManyWithoutOrderInput>;
};

export type OrderCreateWithoutOrderTripsInput = {
  id?: Maybe<Scalars["String"]>;
  user?: Maybe<UserCreateNestedOneWithoutOrdersInput>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  company: CompanyCreateNestedOneWithoutOrdersInput;
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  deliveryNotes?: Maybe<DeliveryNoteCreateNestedManyWithoutOrderInput>;
  caveats?: Maybe<CaveatCreateNestedManyWithoutOrderInput>;
};

export type OrderCreateWithoutUserInput = {
  id?: Maybe<Scalars["String"]>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  company: CompanyCreateNestedOneWithoutOrdersInput;
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  deliveryNotes?: Maybe<DeliveryNoteCreateNestedManyWithoutOrderInput>;
  orderTrips?: Maybe<OrderTripCreateNestedManyWithoutOrderInput>;
  caveats?: Maybe<CaveatCreateNestedManyWithoutOrderInput>;
};

export type OrderGroupBy = {
  __typename?: "OrderGroupBy";
  id: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  companyId: Scalars["String"];
  status?: Maybe<OrderStatus>;
  importedAt: Scalars["DateTime"];
  createdAt: Scalars["DateTime"];
  updatedAt?: Maybe<Scalars["DateTime"]>;
  _count?: Maybe<OrderCountAggregate>;
  _avg?: Maybe<OrderAvgAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
};

export type OrderListRelationFilter = {
  every?: Maybe<OrderWhereInput>;
  some?: Maybe<OrderWhereInput>;
  none?: Maybe<OrderWhereInput>;
};

export type OrderMaxAggregate = {
  __typename?: "OrderMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  companyId?: Maybe<Scalars["String"]>;
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type OrderMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  orderType?: Maybe<SortOrder>;
  action?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  referenceOrderNumber?: Maybe<SortOrder>;
  externalSystemOrderNumberIngres?: Maybe<SortOrder>;
  externalSystemOrderNumberCarlo?: Maybe<SortOrder>;
  invoiceNumber?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  loadingDate?: Maybe<SortOrder>;
  loadingLocationId?: Maybe<SortOrder>;
  loadingNote?: Maybe<SortOrder>;
  loadingPostcode?: Maybe<SortOrder>;
  loadingName?: Maybe<SortOrder>;
  loadingStreet?: Maybe<SortOrder>;
  loadingHouseNumber?: Maybe<SortOrder>;
  loadingCity?: Maybe<SortOrder>;
  loadingCountry?: Maybe<SortOrder>;
  unloadingName?: Maybe<SortOrder>;
  unloadingStreet?: Maybe<SortOrder>;
  unloadingHouseNumber?: Maybe<SortOrder>;
  unloadingCountry?: Maybe<SortOrder>;
  unloadingCity?: Maybe<SortOrder>;
  unloadingPostcode?: Maybe<SortOrder>;
  unloadingDate?: Maybe<SortOrder>;
  unloadingLocationId?: Maybe<SortOrder>;
  unloadingNote?: Maybe<SortOrder>;
  downloadedSsccAt?: Maybe<SortOrder>;
  driver?: Maybe<SortOrder>;
  licensePlate?: Maybe<SortOrder>;
  mass?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  orderCost?: Maybe<SortOrder>;
  orderCurrency?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  salesType?: Maybe<SortOrder>;
  noteForInvoice?: Maybe<SortOrder>;
  noteOnInvoice?: Maybe<SortOrder>;
  noteForDispatch?: Maybe<SortOrder>;
  isMain?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrderMinAggregate = {
  __typename?: "OrderMinAggregate";
  id?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  integrationType?: Maybe<IntegrationType>;
  orderType?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  profitCenter?: Maybe<Scalars["String"]>;
  referenceOrderNumber?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberIngres?: Maybe<Scalars["String"]>;
  externalSystemOrderNumberCarlo?: Maybe<Scalars["String"]>;
  invoiceNumber?: Maybe<Scalars["String"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  loadingDate?: Maybe<Scalars["DateTime"]>;
  loadingLocationId?: Maybe<Scalars["String"]>;
  loadingNote?: Maybe<Scalars["String"]>;
  loadingPostcode?: Maybe<Scalars["String"]>;
  loadingName?: Maybe<Scalars["String"]>;
  loadingStreet?: Maybe<Scalars["String"]>;
  loadingHouseNumber?: Maybe<Scalars["String"]>;
  loadingCity?: Maybe<Scalars["String"]>;
  loadingCountry?: Maybe<Scalars["String"]>;
  unloadingName?: Maybe<Scalars["String"]>;
  unloadingStreet?: Maybe<Scalars["String"]>;
  unloadingHouseNumber?: Maybe<Scalars["String"]>;
  unloadingCountry?: Maybe<Scalars["String"]>;
  unloadingCity?: Maybe<Scalars["String"]>;
  unloadingPostcode?: Maybe<Scalars["String"]>;
  unloadingDate?: Maybe<Scalars["DateTime"]>;
  unloadingLocationId?: Maybe<Scalars["String"]>;
  unloadingNote?: Maybe<Scalars["String"]>;
  downloadedSsccAt?: Maybe<Scalars["DateTime"]>;
  driver?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  orderCurrency?: Maybe<Scalars["String"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
  salesType?: Maybe<Scalars["String"]>;
  noteForInvoice?: Maybe<Scalars["String"]>;
  noteOnInvoice?: Maybe<Scalars["String"]>;
  noteForDispatch?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  confirmedAt?: Maybe<Scalars["DateTime"]>;
  companyId?: Maybe<Scalars["String"]>;
  status?: Maybe<OrderStatus>;
  importedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type OrderMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  orderType?: Maybe<SortOrder>;
  action?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  referenceOrderNumber?: Maybe<SortOrder>;
  externalSystemOrderNumberIngres?: Maybe<SortOrder>;
  externalSystemOrderNumberCarlo?: Maybe<SortOrder>;
  invoiceNumber?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  loadingDate?: Maybe<SortOrder>;
  loadingLocationId?: Maybe<SortOrder>;
  loadingNote?: Maybe<SortOrder>;
  loadingPostcode?: Maybe<SortOrder>;
  loadingName?: Maybe<SortOrder>;
  loadingStreet?: Maybe<SortOrder>;
  loadingHouseNumber?: Maybe<SortOrder>;
  loadingCity?: Maybe<SortOrder>;
  loadingCountry?: Maybe<SortOrder>;
  unloadingName?: Maybe<SortOrder>;
  unloadingStreet?: Maybe<SortOrder>;
  unloadingHouseNumber?: Maybe<SortOrder>;
  unloadingCountry?: Maybe<SortOrder>;
  unloadingCity?: Maybe<SortOrder>;
  unloadingPostcode?: Maybe<SortOrder>;
  unloadingDate?: Maybe<SortOrder>;
  unloadingLocationId?: Maybe<SortOrder>;
  unloadingNote?: Maybe<SortOrder>;
  downloadedSsccAt?: Maybe<SortOrder>;
  driver?: Maybe<SortOrder>;
  licensePlate?: Maybe<SortOrder>;
  mass?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  orderCost?: Maybe<SortOrder>;
  orderCurrency?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  salesType?: Maybe<SortOrder>;
  noteForInvoice?: Maybe<SortOrder>;
  noteOnInvoice?: Maybe<SortOrder>;
  noteForDispatch?: Maybe<SortOrder>;
  isMain?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type OrderOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type OrderOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  orderType?: Maybe<SortOrder>;
  action?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  referenceOrderNumber?: Maybe<SortOrder>;
  externalSystemOrderNumberIngres?: Maybe<SortOrder>;
  externalSystemOrderNumberCarlo?: Maybe<SortOrder>;
  invoiceNumber?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  loadingDate?: Maybe<SortOrder>;
  loadingLocationId?: Maybe<SortOrder>;
  loadingNote?: Maybe<SortOrder>;
  loadingPostcode?: Maybe<SortOrder>;
  loadingName?: Maybe<SortOrder>;
  loadingStreet?: Maybe<SortOrder>;
  loadingHouseNumber?: Maybe<SortOrder>;
  loadingCity?: Maybe<SortOrder>;
  loadingCountry?: Maybe<SortOrder>;
  unloadingName?: Maybe<SortOrder>;
  unloadingStreet?: Maybe<SortOrder>;
  unloadingHouseNumber?: Maybe<SortOrder>;
  unloadingCountry?: Maybe<SortOrder>;
  unloadingCity?: Maybe<SortOrder>;
  unloadingPostcode?: Maybe<SortOrder>;
  unloadingDate?: Maybe<SortOrder>;
  unloadingLocationId?: Maybe<SortOrder>;
  unloadingNote?: Maybe<SortOrder>;
  downloadedSsccAt?: Maybe<SortOrder>;
  driver?: Maybe<SortOrder>;
  licensePlate?: Maybe<SortOrder>;
  mass?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  orderCost?: Maybe<SortOrder>;
  orderCurrency?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  salesType?: Maybe<SortOrder>;
  noteForInvoice?: Maybe<SortOrder>;
  noteOnInvoice?: Maybe<SortOrder>;
  noteForDispatch?: Maybe<SortOrder>;
  isMain?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  _count?: Maybe<OrderCountOrderByAggregateInput>;
  _avg?: Maybe<OrderAvgOrderByAggregateInput>;
  _max?: Maybe<OrderMaxOrderByAggregateInput>;
  _min?: Maybe<OrderMinOrderByAggregateInput>;
  _sum?: Maybe<OrderSumOrderByAggregateInput>;
};

export type OrderOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
  integrationType?: Maybe<SortOrder>;
  orderType?: Maybe<SortOrder>;
  action?: Maybe<SortOrder>;
  profitCenter?: Maybe<SortOrder>;
  referenceOrderNumber?: Maybe<SortOrder>;
  externalSystemOrderNumberIngres?: Maybe<SortOrder>;
  externalSystemOrderNumberCarlo?: Maybe<SortOrder>;
  invoiceNumber?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  loadingDate?: Maybe<SortOrder>;
  loadingLocationId?: Maybe<SortOrder>;
  loadingNote?: Maybe<SortOrder>;
  loadingPostcode?: Maybe<SortOrder>;
  loadingName?: Maybe<SortOrder>;
  loadingStreet?: Maybe<SortOrder>;
  loadingHouseNumber?: Maybe<SortOrder>;
  loadingCity?: Maybe<SortOrder>;
  loadingCountry?: Maybe<SortOrder>;
  unloadingName?: Maybe<SortOrder>;
  unloadingStreet?: Maybe<SortOrder>;
  unloadingHouseNumber?: Maybe<SortOrder>;
  unloadingCountry?: Maybe<SortOrder>;
  unloadingCity?: Maybe<SortOrder>;
  unloadingPostcode?: Maybe<SortOrder>;
  unloadingDate?: Maybe<SortOrder>;
  unloadingLocationId?: Maybe<SortOrder>;
  unloadingNote?: Maybe<SortOrder>;
  downloadedSsccAt?: Maybe<SortOrder>;
  driver?: Maybe<SortOrder>;
  licensePlate?: Maybe<SortOrder>;
  mass?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  currency?: Maybe<SortOrder>;
  orderCost?: Maybe<SortOrder>;
  orderCurrency?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
  salesType?: Maybe<SortOrder>;
  noteForInvoice?: Maybe<SortOrder>;
  noteOnInvoice?: Maybe<SortOrder>;
  noteForDispatch?: Maybe<SortOrder>;
  isMain?: Maybe<SortOrder>;
  confirmedAt?: Maybe<SortOrder>;
  company?: Maybe<CompanyOrderByWithRelationInput>;
  companyId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  importedAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  deliveryNotes?: Maybe<DeliveryNoteOrderByRelationAggregateInput>;
  orderTrips?: Maybe<OrderTripOrderByRelationAggregateInput>;
  caveats?: Maybe<CaveatOrderByRelationAggregateInput>;
};

export type OrderRelationFilter = {
  is?: Maybe<OrderWhereInput>;
  isNot?: Maybe<OrderWhereInput>;
};

export enum OrderScalarFieldEnum {
  Id = "id",
  UserId = "userId",
  IntegrationType = "integrationType",
  OrderType = "orderType",
  Action = "action",
  ProfitCenter = "profitCenter",
  ReferenceOrderNumber = "referenceOrderNumber",
  ExternalSystemOrderNumberIngres = "externalSystemOrderNumberIngres",
  ExternalSystemOrderNumberCarlo = "externalSystemOrderNumberCarlo",
  InvoiceNumber = "invoiceNumber",
  OrderNumber = "orderNumber",
  LoadingDate = "loadingDate",
  LoadingLocationId = "loadingLocationId",
  LoadingNote = "loadingNote",
  LoadingPostcode = "loadingPostcode",
  LoadingName = "loadingName",
  LoadingStreet = "loadingStreet",
  LoadingHouseNumber = "loadingHouseNumber",
  LoadingCity = "loadingCity",
  LoadingCountry = "loadingCountry",
  UnloadingName = "unloadingName",
  UnloadingStreet = "unloadingStreet",
  UnloadingHouseNumber = "unloadingHouseNumber",
  UnloadingCountry = "unloadingCountry",
  UnloadingCity = "unloadingCity",
  UnloadingPostcode = "unloadingPostcode",
  UnloadingDate = "unloadingDate",
  UnloadingLocationId = "unloadingLocationId",
  UnloadingNote = "unloadingNote",
  DownloadedSsccAt = "downloadedSsccAt",
  Driver = "driver",
  LicensePlate = "licensePlate",
  Mass = "mass",
  Cost = "cost",
  Currency = "currency",
  OrderCost = "orderCost",
  OrderCurrency = "orderCurrency",
  NumberOfItems = "numberOfItems",
  SalesType = "salesType",
  NoteForInvoice = "noteForInvoice",
  NoteOnInvoice = "noteOnInvoice",
  NoteForDispatch = "noteForDispatch",
  IsMain = "isMain",
  ConfirmedAt = "confirmedAt",
  CompanyId = "companyId",
  Status = "status",
  ImportedAt = "importedAt",
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
}

export type OrderScalarWhereInput = {
  AND?: Maybe<Array<OrderScalarWhereInput>>;
  OR?: Maybe<Array<OrderScalarWhereInput>>;
  NOT?: Maybe<Array<OrderScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  userId?: Maybe<StringNullableFilter>;
  integrationType?: Maybe<EnumIntegrationTypeNullableFilter>;
  orderType?: Maybe<StringNullableFilter>;
  action?: Maybe<StringNullableFilter>;
  profitCenter?: Maybe<StringNullableFilter>;
  referenceOrderNumber?: Maybe<StringNullableFilter>;
  externalSystemOrderNumberIngres?: Maybe<StringNullableFilter>;
  externalSystemOrderNumberCarlo?: Maybe<StringNullableFilter>;
  invoiceNumber?: Maybe<StringNullableFilter>;
  orderNumber?: Maybe<StringNullableFilter>;
  loadingDate?: Maybe<DateTimeNullableFilter>;
  loadingLocationId?: Maybe<StringNullableFilter>;
  loadingNote?: Maybe<StringNullableFilter>;
  loadingPostcode?: Maybe<StringNullableFilter>;
  loadingName?: Maybe<StringNullableFilter>;
  loadingStreet?: Maybe<StringNullableFilter>;
  loadingHouseNumber?: Maybe<StringNullableFilter>;
  loadingCity?: Maybe<StringNullableFilter>;
  loadingCountry?: Maybe<StringNullableFilter>;
  unloadingName?: Maybe<StringNullableFilter>;
  unloadingStreet?: Maybe<StringNullableFilter>;
  unloadingHouseNumber?: Maybe<StringNullableFilter>;
  unloadingCountry?: Maybe<StringNullableFilter>;
  unloadingCity?: Maybe<StringNullableFilter>;
  unloadingPostcode?: Maybe<StringNullableFilter>;
  unloadingDate?: Maybe<DateTimeNullableFilter>;
  unloadingLocationId?: Maybe<StringNullableFilter>;
  unloadingNote?: Maybe<StringNullableFilter>;
  downloadedSsccAt?: Maybe<DateTimeNullableFilter>;
  driver?: Maybe<StringNullableFilter>;
  licensePlate?: Maybe<StringNullableFilter>;
  mass?: Maybe<FloatNullableFilter>;
  cost?: Maybe<FloatNullableFilter>;
  currency?: Maybe<StringNullableFilter>;
  orderCost?: Maybe<FloatNullableFilter>;
  orderCurrency?: Maybe<StringNullableFilter>;
  numberOfItems?: Maybe<FloatNullableFilter>;
  salesType?: Maybe<StringNullableFilter>;
  noteForInvoice?: Maybe<StringNullableFilter>;
  noteOnInvoice?: Maybe<StringNullableFilter>;
  noteForDispatch?: Maybe<StringNullableFilter>;
  isMain?: Maybe<BoolNullableFilter>;
  confirmedAt?: Maybe<DateTimeNullableFilter>;
  companyId?: Maybe<StringFilter>;
  status?: Maybe<EnumOrderStatusNullableFilter>;
  importedAt?: Maybe<DateTimeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type OrderScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OrderScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OrderScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OrderScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
  integrationType?: Maybe<EnumIntegrationTypeNullableWithAggregatesFilter>;
  orderType?: Maybe<StringNullableWithAggregatesFilter>;
  action?: Maybe<StringNullableWithAggregatesFilter>;
  profitCenter?: Maybe<StringNullableWithAggregatesFilter>;
  referenceOrderNumber?: Maybe<StringNullableWithAggregatesFilter>;
  externalSystemOrderNumberIngres?: Maybe<StringNullableWithAggregatesFilter>;
  externalSystemOrderNumberCarlo?: Maybe<StringNullableWithAggregatesFilter>;
  invoiceNumber?: Maybe<StringNullableWithAggregatesFilter>;
  orderNumber?: Maybe<StringNullableWithAggregatesFilter>;
  loadingDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  loadingLocationId?: Maybe<StringNullableWithAggregatesFilter>;
  loadingNote?: Maybe<StringNullableWithAggregatesFilter>;
  loadingPostcode?: Maybe<StringNullableWithAggregatesFilter>;
  loadingName?: Maybe<StringNullableWithAggregatesFilter>;
  loadingStreet?: Maybe<StringNullableWithAggregatesFilter>;
  loadingHouseNumber?: Maybe<StringNullableWithAggregatesFilter>;
  loadingCity?: Maybe<StringNullableWithAggregatesFilter>;
  loadingCountry?: Maybe<StringNullableWithAggregatesFilter>;
  unloadingName?: Maybe<StringNullableWithAggregatesFilter>;
  unloadingStreet?: Maybe<StringNullableWithAggregatesFilter>;
  unloadingHouseNumber?: Maybe<StringNullableWithAggregatesFilter>;
  unloadingCountry?: Maybe<StringNullableWithAggregatesFilter>;
  unloadingCity?: Maybe<StringNullableWithAggregatesFilter>;
  unloadingPostcode?: Maybe<StringNullableWithAggregatesFilter>;
  unloadingDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  unloadingLocationId?: Maybe<StringNullableWithAggregatesFilter>;
  unloadingNote?: Maybe<StringNullableWithAggregatesFilter>;
  downloadedSsccAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  driver?: Maybe<StringNullableWithAggregatesFilter>;
  licensePlate?: Maybe<StringNullableWithAggregatesFilter>;
  mass?: Maybe<FloatNullableWithAggregatesFilter>;
  cost?: Maybe<FloatNullableWithAggregatesFilter>;
  currency?: Maybe<StringNullableWithAggregatesFilter>;
  orderCost?: Maybe<FloatNullableWithAggregatesFilter>;
  orderCurrency?: Maybe<StringNullableWithAggregatesFilter>;
  numberOfItems?: Maybe<FloatNullableWithAggregatesFilter>;
  salesType?: Maybe<StringNullableWithAggregatesFilter>;
  noteForInvoice?: Maybe<StringNullableWithAggregatesFilter>;
  noteOnInvoice?: Maybe<StringNullableWithAggregatesFilter>;
  noteForDispatch?: Maybe<StringNullableWithAggregatesFilter>;
  isMain?: Maybe<BoolNullableWithAggregatesFilter>;
  confirmedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  companyId?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumOrderStatusNullableWithAggregatesFilter>;
  importedAt?: Maybe<DateTimeWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export enum OrderStatus {
  Opened = "OPENED",
  InProgress = "IN_PROGRESS",
  Avisation = "AVISATION",
  Confirmed = "CONFIRMED",
  Planned = "PLANNED",
  Done = "DONE",
  Blocked = "BLOCKED",
  Declined = "DECLINED",
  Invoiced = "INVOICED",
  Cancelled = "CANCELLED",
  Unknown = "UNKNOWN",
}

export type OrderSumAggregate = {
  __typename?: "OrderSumAggregate";
  mass?: Maybe<Scalars["Float"]>;
  cost?: Maybe<Scalars["Float"]>;
  orderCost?: Maybe<Scalars["Float"]>;
  numberOfItems?: Maybe<Scalars["Float"]>;
};

export type OrderSumOrderByAggregateInput = {
  mass?: Maybe<SortOrder>;
  cost?: Maybe<SortOrder>;
  orderCost?: Maybe<SortOrder>;
  numberOfItems?: Maybe<SortOrder>;
};

export type OrderTrip = {
  __typename?: "OrderTrip";
  id: Scalars["String"];
  locationId: Scalars["String"];
  date: Scalars["DateTime"];
  note?: Maybe<Scalars["String"]>;
  tripType: OrderTripType;
  orderNumber: Scalars["Int"];
  orderId: Scalars["String"];
  order: Order;
};

export type OrderTripAvgAggregate = {
  __typename?: "OrderTripAvgAggregate";
  orderNumber?: Maybe<Scalars["Float"]>;
};

export type OrderTripAvgOrderByAggregateInput = {
  orderNumber?: Maybe<SortOrder>;
};

export type OrderTripCountAggregate = {
  __typename?: "OrderTripCountAggregate";
  id: Scalars["Int"];
  locationId: Scalars["Int"];
  date: Scalars["Int"];
  note: Scalars["Int"];
  tripType: Scalars["Int"];
  orderNumber: Scalars["Int"];
  orderId: Scalars["Int"];
  _all: Scalars["Int"];
};

export type OrderTripCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  tripType?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
};

export type OrderTripCreateInput = {
  id?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  date: Scalars["DateTime"];
  note?: Maybe<Scalars["String"]>;
  tripType: OrderTripType;
  orderNumber: Scalars["Int"];
  order: OrderCreateNestedOneWithoutOrderTripsInput;
};

export type OrderTripCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  date: Scalars["DateTime"];
  note?: Maybe<Scalars["String"]>;
  tripType: OrderTripType;
  orderNumber: Scalars["Int"];
  orderId: Scalars["String"];
};

export type OrderTripCreateManyOrderInput = {
  id?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  date: Scalars["DateTime"];
  note?: Maybe<Scalars["String"]>;
  tripType: OrderTripType;
  orderNumber: Scalars["Int"];
};

export type OrderTripCreateManyOrderInputEnvelope = {
  data: Array<OrderTripCreateManyOrderInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type OrderTripCreateNestedManyWithoutOrderInput = {
  create?: Maybe<Array<OrderTripCreateWithoutOrderInput>>;
  connectOrCreate?: Maybe<Array<OrderTripCreateOrConnectWithoutOrderInput>>;
  createMany?: Maybe<OrderTripCreateManyOrderInputEnvelope>;
  connect?: Maybe<Array<OrderTripWhereUniqueInput>>;
};

export type OrderTripCreateOrConnectWithoutOrderInput = {
  where: OrderTripWhereUniqueInput;
  create: OrderTripCreateWithoutOrderInput;
};

export type OrderTripCreateWithoutOrderInput = {
  id?: Maybe<Scalars["String"]>;
  locationId: Scalars["String"];
  date: Scalars["DateTime"];
  note?: Maybe<Scalars["String"]>;
  tripType: OrderTripType;
  orderNumber: Scalars["Int"];
};

export type OrderTripGroupBy = {
  __typename?: "OrderTripGroupBy";
  id: Scalars["String"];
  locationId: Scalars["String"];
  date: Scalars["DateTime"];
  note?: Maybe<Scalars["String"]>;
  tripType: OrderTripType;
  orderNumber: Scalars["Int"];
  orderId: Scalars["String"];
  _count?: Maybe<OrderTripCountAggregate>;
  _avg?: Maybe<OrderTripAvgAggregate>;
  _sum?: Maybe<OrderTripSumAggregate>;
  _min?: Maybe<OrderTripMinAggregate>;
  _max?: Maybe<OrderTripMaxAggregate>;
};

export type OrderTripListRelationFilter = {
  every?: Maybe<OrderTripWhereInput>;
  some?: Maybe<OrderTripWhereInput>;
  none?: Maybe<OrderTripWhereInput>;
};

export type OrderTripMaxAggregate = {
  __typename?: "OrderTripMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  locationId?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["DateTime"]>;
  note?: Maybe<Scalars["String"]>;
  tripType?: Maybe<OrderTripType>;
  orderNumber?: Maybe<Scalars["Int"]>;
  orderId?: Maybe<Scalars["String"]>;
};

export type OrderTripMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  tripType?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
};

export type OrderTripMinAggregate = {
  __typename?: "OrderTripMinAggregate";
  id?: Maybe<Scalars["String"]>;
  locationId?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["DateTime"]>;
  note?: Maybe<Scalars["String"]>;
  tripType?: Maybe<OrderTripType>;
  orderNumber?: Maybe<Scalars["Int"]>;
  orderId?: Maybe<Scalars["String"]>;
};

export type OrderTripMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  tripType?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
};

export type OrderTripOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type OrderTripOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  tripType?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
  _count?: Maybe<OrderTripCountOrderByAggregateInput>;
  _avg?: Maybe<OrderTripAvgOrderByAggregateInput>;
  _max?: Maybe<OrderTripMaxOrderByAggregateInput>;
  _min?: Maybe<OrderTripMinOrderByAggregateInput>;
  _sum?: Maybe<OrderTripSumOrderByAggregateInput>;
};

export type OrderTripOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  locationId?: Maybe<SortOrder>;
  date?: Maybe<SortOrder>;
  note?: Maybe<SortOrder>;
  tripType?: Maybe<SortOrder>;
  orderNumber?: Maybe<SortOrder>;
  order?: Maybe<OrderOrderByWithRelationInput>;
  orderId?: Maybe<SortOrder>;
};

export enum OrderTripScalarFieldEnum {
  Id = "id",
  LocationId = "locationId",
  Date = "date",
  Note = "note",
  TripType = "tripType",
  OrderNumber = "orderNumber",
  OrderId = "orderId",
}

export type OrderTripScalarWhereInput = {
  AND?: Maybe<Array<OrderTripScalarWhereInput>>;
  OR?: Maybe<Array<OrderTripScalarWhereInput>>;
  NOT?: Maybe<Array<OrderTripScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  locationId?: Maybe<StringFilter>;
  date?: Maybe<DateTimeFilter>;
  note?: Maybe<StringNullableFilter>;
  tripType?: Maybe<EnumOrderTripTypeFilter>;
  orderNumber?: Maybe<IntFilter>;
  orderId?: Maybe<StringFilter>;
};

export type OrderTripScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<OrderTripScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<OrderTripScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<OrderTripScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  locationId?: Maybe<StringWithAggregatesFilter>;
  date?: Maybe<DateTimeWithAggregatesFilter>;
  note?: Maybe<StringNullableWithAggregatesFilter>;
  tripType?: Maybe<EnumOrderTripTypeWithAggregatesFilter>;
  orderNumber?: Maybe<IntWithAggregatesFilter>;
  orderId?: Maybe<StringWithAggregatesFilter>;
};

export type OrderTripSumAggregate = {
  __typename?: "OrderTripSumAggregate";
  orderNumber?: Maybe<Scalars["Int"]>;
};

export type OrderTripSumOrderByAggregateInput = {
  orderNumber?: Maybe<SortOrder>;
};

export enum OrderTripType {
  Loading = "LOADING",
  Unloading = "UNLOADING",
}

export type OrderTripUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  locationId?: Maybe<StringFieldUpdateOperationsInput>;
  date?: Maybe<DateTimeFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  tripType?: Maybe<EnumOrderTripTypeFieldUpdateOperationsInput>;
  orderNumber?: Maybe<IntFieldUpdateOperationsInput>;
  order?: Maybe<OrderUpdateOneRequiredWithoutOrderTripsNestedInput>;
};

export type OrderTripUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  locationId?: Maybe<StringFieldUpdateOperationsInput>;
  date?: Maybe<DateTimeFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  tripType?: Maybe<EnumOrderTripTypeFieldUpdateOperationsInput>;
  orderNumber?: Maybe<IntFieldUpdateOperationsInput>;
};

export type OrderTripUpdateManyWithWhereWithoutOrderInput = {
  where: OrderTripScalarWhereInput;
  data: OrderTripUpdateManyMutationInput;
};

export type OrderTripUpdateManyWithoutOrderNestedInput = {
  create?: Maybe<Array<OrderTripCreateWithoutOrderInput>>;
  connectOrCreate?: Maybe<Array<OrderTripCreateOrConnectWithoutOrderInput>>;
  upsert?: Maybe<Array<OrderTripUpsertWithWhereUniqueWithoutOrderInput>>;
  createMany?: Maybe<OrderTripCreateManyOrderInputEnvelope>;
  set?: Maybe<Array<OrderTripWhereUniqueInput>>;
  disconnect?: Maybe<Array<OrderTripWhereUniqueInput>>;
  delete?: Maybe<Array<OrderTripWhereUniqueInput>>;
  connect?: Maybe<Array<OrderTripWhereUniqueInput>>;
  update?: Maybe<Array<OrderTripUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: Maybe<Array<OrderTripUpdateManyWithWhereWithoutOrderInput>>;
  deleteMany?: Maybe<Array<OrderTripScalarWhereInput>>;
};

export type OrderTripUpdateWithWhereUniqueWithoutOrderInput = {
  where: OrderTripWhereUniqueInput;
  data: OrderTripUpdateWithoutOrderInput;
};

export type OrderTripUpdateWithoutOrderInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  locationId?: Maybe<StringFieldUpdateOperationsInput>;
  date?: Maybe<DateTimeFieldUpdateOperationsInput>;
  note?: Maybe<NullableStringFieldUpdateOperationsInput>;
  tripType?: Maybe<EnumOrderTripTypeFieldUpdateOperationsInput>;
  orderNumber?: Maybe<IntFieldUpdateOperationsInput>;
};

export type OrderTripUpsertWithWhereUniqueWithoutOrderInput = {
  where: OrderTripWhereUniqueInput;
  update: OrderTripUpdateWithoutOrderInput;
  create: OrderTripCreateWithoutOrderInput;
};

export type OrderTripWhereInput = {
  AND?: Maybe<Array<OrderTripWhereInput>>;
  OR?: Maybe<Array<OrderTripWhereInput>>;
  NOT?: Maybe<Array<OrderTripWhereInput>>;
  id?: Maybe<StringFilter>;
  locationId?: Maybe<StringFilter>;
  date?: Maybe<DateTimeFilter>;
  note?: Maybe<StringNullableFilter>;
  tripType?: Maybe<EnumOrderTripTypeFilter>;
  orderNumber?: Maybe<IntFilter>;
  order?: Maybe<OrderRelationFilter>;
  orderId?: Maybe<StringFilter>;
};

export type OrderTripWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type OrderUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  user?: Maybe<UserUpdateOneWithoutOrdersNestedInput>;
  integrationType?: Maybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  orderType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  action?: Maybe<NullableStringFieldUpdateOperationsInput>;
  profitCenter?: Maybe<NullableStringFieldUpdateOperationsInput>;
  referenceOrderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberIngres?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberCarlo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  loadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  unloadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  downloadedSsccAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  driver?: Maybe<NullableStringFieldUpdateOperationsInput>;
  licensePlate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  mass?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  cost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderCost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  orderCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  salesType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteOnInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForDispatch?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isMain?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutOrdersNestedInput>;
  status?: Maybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
  importedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryNotes?: Maybe<DeliveryNoteUpdateManyWithoutOrderNestedInput>;
  orderTrips?: Maybe<OrderTripUpdateManyWithoutOrderNestedInput>;
  caveats?: Maybe<CaveatUpdateManyWithoutOrderNestedInput>;
};

export type OrderUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  integrationType?: Maybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  orderType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  action?: Maybe<NullableStringFieldUpdateOperationsInput>;
  profitCenter?: Maybe<NullableStringFieldUpdateOperationsInput>;
  referenceOrderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberIngres?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberCarlo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  loadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  unloadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  downloadedSsccAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  driver?: Maybe<NullableStringFieldUpdateOperationsInput>;
  licensePlate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  mass?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  cost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderCost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  orderCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  salesType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteOnInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForDispatch?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isMain?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: Maybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
  importedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateManyWithWhereWithoutCompanyInput = {
  where: OrderScalarWhereInput;
  data: OrderUpdateManyMutationInput;
};

export type OrderUpdateManyWithWhereWithoutUserInput = {
  where: OrderScalarWhereInput;
  data: OrderUpdateManyMutationInput;
};

export type OrderUpdateManyWithoutCompanyNestedInput = {
  create?: Maybe<Array<OrderCreateWithoutCompanyInput>>;
  connectOrCreate?: Maybe<Array<OrderCreateOrConnectWithoutCompanyInput>>;
  upsert?: Maybe<Array<OrderUpsertWithWhereUniqueWithoutCompanyInput>>;
  createMany?: Maybe<OrderCreateManyCompanyInputEnvelope>;
  set?: Maybe<Array<OrderWhereUniqueInput>>;
  disconnect?: Maybe<Array<OrderWhereUniqueInput>>;
  delete?: Maybe<Array<OrderWhereUniqueInput>>;
  connect?: Maybe<Array<OrderWhereUniqueInput>>;
  update?: Maybe<Array<OrderUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<OrderUpdateManyWithWhereWithoutCompanyInput>>;
  deleteMany?: Maybe<Array<OrderScalarWhereInput>>;
};

export type OrderUpdateManyWithoutUserNestedInput = {
  create?: Maybe<Array<OrderCreateWithoutUserInput>>;
  connectOrCreate?: Maybe<Array<OrderCreateOrConnectWithoutUserInput>>;
  upsert?: Maybe<Array<OrderUpsertWithWhereUniqueWithoutUserInput>>;
  createMany?: Maybe<OrderCreateManyUserInputEnvelope>;
  set?: Maybe<Array<OrderWhereUniqueInput>>;
  disconnect?: Maybe<Array<OrderWhereUniqueInput>>;
  delete?: Maybe<Array<OrderWhereUniqueInput>>;
  connect?: Maybe<Array<OrderWhereUniqueInput>>;
  update?: Maybe<Array<OrderUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<OrderUpdateManyWithWhereWithoutUserInput>>;
  deleteMany?: Maybe<Array<OrderScalarWhereInput>>;
};

export type OrderUpdateOneRequiredWithoutCaveatsNestedInput = {
  create?: Maybe<OrderCreateWithoutCaveatsInput>;
  connectOrCreate?: Maybe<OrderCreateOrConnectWithoutCaveatsInput>;
  upsert?: Maybe<OrderUpsertWithoutCaveatsInput>;
  connect?: Maybe<OrderWhereUniqueInput>;
  update?: Maybe<OrderUpdateWithoutCaveatsInput>;
};

export type OrderUpdateOneRequiredWithoutDeliveryNotesNestedInput = {
  create?: Maybe<OrderCreateWithoutDeliveryNotesInput>;
  connectOrCreate?: Maybe<OrderCreateOrConnectWithoutDeliveryNotesInput>;
  upsert?: Maybe<OrderUpsertWithoutDeliveryNotesInput>;
  connect?: Maybe<OrderWhereUniqueInput>;
  update?: Maybe<OrderUpdateWithoutDeliveryNotesInput>;
};

export type OrderUpdateOneRequiredWithoutOrderTripsNestedInput = {
  create?: Maybe<OrderCreateWithoutOrderTripsInput>;
  connectOrCreate?: Maybe<OrderCreateOrConnectWithoutOrderTripsInput>;
  upsert?: Maybe<OrderUpsertWithoutOrderTripsInput>;
  connect?: Maybe<OrderWhereUniqueInput>;
  update?: Maybe<OrderUpdateWithoutOrderTripsInput>;
};

export type OrderUpdateWithWhereUniqueWithoutCompanyInput = {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutCompanyInput;
};

export type OrderUpdateWithWhereUniqueWithoutUserInput = {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutUserInput;
};

export type OrderUpdateWithoutCaveatsInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  user?: Maybe<UserUpdateOneWithoutOrdersNestedInput>;
  integrationType?: Maybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  orderType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  action?: Maybe<NullableStringFieldUpdateOperationsInput>;
  profitCenter?: Maybe<NullableStringFieldUpdateOperationsInput>;
  referenceOrderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberIngres?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberCarlo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  loadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  unloadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  downloadedSsccAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  driver?: Maybe<NullableStringFieldUpdateOperationsInput>;
  licensePlate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  mass?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  cost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderCost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  orderCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  salesType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteOnInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForDispatch?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isMain?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutOrdersNestedInput>;
  status?: Maybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
  importedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryNotes?: Maybe<DeliveryNoteUpdateManyWithoutOrderNestedInput>;
  orderTrips?: Maybe<OrderTripUpdateManyWithoutOrderNestedInput>;
};

export type OrderUpdateWithoutCompanyInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  user?: Maybe<UserUpdateOneWithoutOrdersNestedInput>;
  integrationType?: Maybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  orderType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  action?: Maybe<NullableStringFieldUpdateOperationsInput>;
  profitCenter?: Maybe<NullableStringFieldUpdateOperationsInput>;
  referenceOrderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberIngres?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberCarlo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  loadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  unloadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  downloadedSsccAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  driver?: Maybe<NullableStringFieldUpdateOperationsInput>;
  licensePlate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  mass?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  cost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderCost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  orderCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  salesType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteOnInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForDispatch?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isMain?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: Maybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
  importedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryNotes?: Maybe<DeliveryNoteUpdateManyWithoutOrderNestedInput>;
  orderTrips?: Maybe<OrderTripUpdateManyWithoutOrderNestedInput>;
  caveats?: Maybe<CaveatUpdateManyWithoutOrderNestedInput>;
};

export type OrderUpdateWithoutDeliveryNotesInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  user?: Maybe<UserUpdateOneWithoutOrdersNestedInput>;
  integrationType?: Maybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  orderType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  action?: Maybe<NullableStringFieldUpdateOperationsInput>;
  profitCenter?: Maybe<NullableStringFieldUpdateOperationsInput>;
  referenceOrderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberIngres?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberCarlo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  loadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  unloadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  downloadedSsccAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  driver?: Maybe<NullableStringFieldUpdateOperationsInput>;
  licensePlate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  mass?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  cost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderCost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  orderCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  salesType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteOnInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForDispatch?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isMain?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutOrdersNestedInput>;
  status?: Maybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
  importedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderTrips?: Maybe<OrderTripUpdateManyWithoutOrderNestedInput>;
  caveats?: Maybe<CaveatUpdateManyWithoutOrderNestedInput>;
};

export type OrderUpdateWithoutOrderTripsInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  user?: Maybe<UserUpdateOneWithoutOrdersNestedInput>;
  integrationType?: Maybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  orderType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  action?: Maybe<NullableStringFieldUpdateOperationsInput>;
  profitCenter?: Maybe<NullableStringFieldUpdateOperationsInput>;
  referenceOrderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberIngres?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberCarlo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  loadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  unloadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  downloadedSsccAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  driver?: Maybe<NullableStringFieldUpdateOperationsInput>;
  licensePlate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  mass?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  cost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderCost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  orderCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  salesType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteOnInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForDispatch?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isMain?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutOrdersNestedInput>;
  status?: Maybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
  importedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryNotes?: Maybe<DeliveryNoteUpdateManyWithoutOrderNestedInput>;
  caveats?: Maybe<CaveatUpdateManyWithoutOrderNestedInput>;
};

export type OrderUpdateWithoutUserInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  integrationType?: Maybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  orderType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  action?: Maybe<NullableStringFieldUpdateOperationsInput>;
  profitCenter?: Maybe<NullableStringFieldUpdateOperationsInput>;
  referenceOrderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberIngres?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSystemOrderNumberCarlo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  loadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  loadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingHouseNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingCity?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingPostcode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  unloadingLocationId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  unloadingNote?: Maybe<NullableStringFieldUpdateOperationsInput>;
  downloadedSsccAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  driver?: Maybe<NullableStringFieldUpdateOperationsInput>;
  licensePlate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  mass?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  cost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  orderCost?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  orderCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  numberOfItems?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  salesType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteOnInvoice?: Maybe<NullableStringFieldUpdateOperationsInput>;
  noteForDispatch?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isMain?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  confirmedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: Maybe<CompanyUpdateOneRequiredWithoutOrdersNestedInput>;
  status?: Maybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
  importedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryNotes?: Maybe<DeliveryNoteUpdateManyWithoutOrderNestedInput>;
  orderTrips?: Maybe<OrderTripUpdateManyWithoutOrderNestedInput>;
  caveats?: Maybe<CaveatUpdateManyWithoutOrderNestedInput>;
};

export type OrderUpsertWithWhereUniqueWithoutCompanyInput = {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutCompanyInput;
  create: OrderCreateWithoutCompanyInput;
};

export type OrderUpsertWithWhereUniqueWithoutUserInput = {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutUserInput;
  create: OrderCreateWithoutUserInput;
};

export type OrderUpsertWithoutCaveatsInput = {
  update: OrderUpdateWithoutCaveatsInput;
  create: OrderCreateWithoutCaveatsInput;
};

export type OrderUpsertWithoutDeliveryNotesInput = {
  update: OrderUpdateWithoutDeliveryNotesInput;
  create: OrderCreateWithoutDeliveryNotesInput;
};

export type OrderUpsertWithoutOrderTripsInput = {
  update: OrderUpdateWithoutOrderTripsInput;
  create: OrderCreateWithoutOrderTripsInput;
};

export type OrderWhereInput = {
  AND?: Maybe<Array<OrderWhereInput>>;
  OR?: Maybe<Array<OrderWhereInput>>;
  NOT?: Maybe<Array<OrderWhereInput>>;
  id?: Maybe<StringFilter>;
  user?: Maybe<UserRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
  integrationType?: Maybe<EnumIntegrationTypeNullableFilter>;
  orderType?: Maybe<StringNullableFilter>;
  action?: Maybe<StringNullableFilter>;
  profitCenter?: Maybe<StringNullableFilter>;
  referenceOrderNumber?: Maybe<StringNullableFilter>;
  externalSystemOrderNumberIngres?: Maybe<StringNullableFilter>;
  externalSystemOrderNumberCarlo?: Maybe<StringNullableFilter>;
  invoiceNumber?: Maybe<StringNullableFilter>;
  orderNumber?: Maybe<StringNullableFilter>;
  loadingDate?: Maybe<DateTimeNullableFilter>;
  loadingLocationId?: Maybe<StringNullableFilter>;
  loadingNote?: Maybe<StringNullableFilter>;
  loadingPostcode?: Maybe<StringNullableFilter>;
  loadingName?: Maybe<StringNullableFilter>;
  loadingStreet?: Maybe<StringNullableFilter>;
  loadingHouseNumber?: Maybe<StringNullableFilter>;
  loadingCity?: Maybe<StringNullableFilter>;
  loadingCountry?: Maybe<StringNullableFilter>;
  unloadingName?: Maybe<StringNullableFilter>;
  unloadingStreet?: Maybe<StringNullableFilter>;
  unloadingHouseNumber?: Maybe<StringNullableFilter>;
  unloadingCountry?: Maybe<StringNullableFilter>;
  unloadingCity?: Maybe<StringNullableFilter>;
  unloadingPostcode?: Maybe<StringNullableFilter>;
  unloadingDate?: Maybe<DateTimeNullableFilter>;
  unloadingLocationId?: Maybe<StringNullableFilter>;
  unloadingNote?: Maybe<StringNullableFilter>;
  downloadedSsccAt?: Maybe<DateTimeNullableFilter>;
  driver?: Maybe<StringNullableFilter>;
  licensePlate?: Maybe<StringNullableFilter>;
  mass?: Maybe<FloatNullableFilter>;
  cost?: Maybe<FloatNullableFilter>;
  currency?: Maybe<StringNullableFilter>;
  orderCost?: Maybe<FloatNullableFilter>;
  orderCurrency?: Maybe<StringNullableFilter>;
  numberOfItems?: Maybe<FloatNullableFilter>;
  salesType?: Maybe<StringNullableFilter>;
  noteForInvoice?: Maybe<StringNullableFilter>;
  noteOnInvoice?: Maybe<StringNullableFilter>;
  noteForDispatch?: Maybe<StringNullableFilter>;
  isMain?: Maybe<BoolNullableFilter>;
  confirmedAt?: Maybe<DateTimeNullableFilter>;
  company?: Maybe<CompanyRelationFilter>;
  companyId?: Maybe<StringFilter>;
  status?: Maybe<EnumOrderStatusNullableFilter>;
  importedAt?: Maybe<DateTimeFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  deliveryNotes?: Maybe<DeliveryNoteListRelationFilter>;
  orderTrips?: Maybe<OrderTripListRelationFilter>;
  caveats?: Maybe<CaveatListRelationFilter>;
};

export type OrderWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type ProfitCenter = {
  __typename?: "ProfitCenter";
  code: Scalars["String"];
  name: Scalars["String"];
};

export type Query = {
  __typename?: "Query";
  aggregateCaveat: AggregateCaveat;
  findFirstCaveat?: Maybe<Caveat>;
  findFirstCaveatOrThrow?: Maybe<Caveat>;
  caveats: Array<Caveat>;
  caveat?: Maybe<Caveat>;
  getCaveat?: Maybe<Caveat>;
  groupByCaveat: Array<CaveatGroupBy>;
  aggregateCompany: AggregateCompany;
  findFirstCompany?: Maybe<Company>;
  findFirstCompanyOrThrow?: Maybe<Company>;
  companies: Array<Company>;
  company?: Maybe<Company>;
  getCompany?: Maybe<Company>;
  groupByCompany: Array<CompanyGroupBy>;
  aggregateCompanyDefaultValue: AggregateCompanyDefaultValue;
  findFirstCompanyDefaultValue?: Maybe<CompanyDefaultValue>;
  findFirstCompanyDefaultValueOrThrow?: Maybe<CompanyDefaultValue>;
  companyDefaultValues: Array<CompanyDefaultValue>;
  companyDefaultValue?: Maybe<CompanyDefaultValue>;
  getCompanyDefaultValue?: Maybe<CompanyDefaultValue>;
  groupByCompanyDefaultValue: Array<CompanyDefaultValueGroupBy>;
  aggregateDeliveryNote: AggregateDeliveryNote;
  findFirstDeliveryNote?: Maybe<DeliveryNote>;
  findFirstDeliveryNoteOrThrow?: Maybe<DeliveryNote>;
  deliveryNotes: Array<DeliveryNote>;
  deliveryNote?: Maybe<DeliveryNote>;
  getDeliveryNote?: Maybe<DeliveryNote>;
  groupByDeliveryNote: Array<DeliveryNoteGroupBy>;
  aggregateDeliveryNoteDocument: AggregateDeliveryNoteDocument;
  findFirstDeliveryNoteDocument?: Maybe<DeliveryNoteDocument>;
  findFirstDeliveryNoteDocumentOrThrow?: Maybe<DeliveryNoteDocument>;
  deliveryNoteDocuments: Array<DeliveryNoteDocument>;
  deliveryNoteDocument?: Maybe<DeliveryNoteDocument>;
  getDeliveryNoteDocument?: Maybe<DeliveryNoteDocument>;
  groupByDeliveryNoteDocument: Array<DeliveryNoteDocumentGroupBy>;
  aggregateDeliveryNoteLoadingUnit: AggregateDeliveryNoteLoadingUnit;
  findFirstDeliveryNoteLoadingUnit?: Maybe<DeliveryNoteLoadingUnit>;
  findFirstDeliveryNoteLoadingUnitOrThrow?: Maybe<DeliveryNoteLoadingUnit>;
  deliveryNoteLoadingUnits: Array<DeliveryNoteLoadingUnit>;
  deliveryNoteLoadingUnit?: Maybe<DeliveryNoteLoadingUnit>;
  getDeliveryNoteLoadingUnit?: Maybe<DeliveryNoteLoadingUnit>;
  groupByDeliveryNoteLoadingUnit: Array<DeliveryNoteLoadingUnitGroupBy>;
  aggregateLoadingUnit: AggregateLoadingUnit;
  findFirstLoadingUnit?: Maybe<LoadingUnit>;
  findFirstLoadingUnitOrThrow?: Maybe<LoadingUnit>;
  loadingUnits: Array<LoadingUnit>;
  loadingUnit: LoadingUnit;
  getLoadingUnit?: Maybe<LoadingUnit>;
  groupByLoadingUnit: Array<LoadingUnitGroupBy>;
  /** Get all the locations in system. */
  aggregateLocation: AggregateLocation;
  findFirstLocation?: Maybe<Location>;
  findFirstLocationOrThrow?: Maybe<Location>;
  /** Get all the locations in system. */
  locations: Array<Location>;
  /** Get the location in system. */
  location: Location;
  getLocation?: Maybe<Location>;
  groupByLocation: Array<LocationGroupBy>;
  aggregateOrder: AggregateOrder;
  findFirstOrder?: Maybe<Order>;
  findFirstOrderOrThrow?: Maybe<Order>;
  orders: Array<Order>;
  order: Order;
  getOrder?: Maybe<Order>;
  groupByOrder: Array<OrderGroupBy>;
  aggregateOrderTrip: AggregateOrderTrip;
  findFirstOrderTrip?: Maybe<OrderTrip>;
  findFirstOrderTripOrThrow?: Maybe<OrderTrip>;
  orderTrips: Array<OrderTrip>;
  orderTrip?: Maybe<OrderTrip>;
  getOrderTrip?: Maybe<OrderTrip>;
  groupByOrderTrip: Array<OrderTripGroupBy>;
  aggregateSscc: AggregateSscc;
  findFirstSscc?: Maybe<Sscc>;
  findFirstSsccOrThrow?: Maybe<Sscc>;
  ssccs: Array<Sscc>;
  sscc?: Maybe<Sscc>;
  getSscc?: Maybe<Sscc>;
  groupBySscc: Array<SsccGroupBy>;
  aggregateUser: AggregateUser;
  findFirstUser?: Maybe<User>;
  findFirstUserOrThrow?: Maybe<User>;
  users: Array<User>;
  user?: Maybe<User>;
  getUser?: Maybe<User>;
  groupByUser: Array<UserGroupBy>;
  aggregateUserDefaultValue: AggregateUserDefaultValue;
  findFirstUserDefaultValue?: Maybe<UserDefaultValue>;
  findFirstUserDefaultValueOrThrow?: Maybe<UserDefaultValue>;
  userDefaultValues: Array<UserDefaultValue>;
  userDefaultValue?: Maybe<UserDefaultValue>;
  getUserDefaultValue?: Maybe<UserDefaultValue>;
  groupByUserDefaultValue: Array<UserDefaultValueGroupBy>;
  aggregateUserRelCompany: AggregateUserRelCompany;
  findFirstUserRelCompany?: Maybe<UserRelCompany>;
  findFirstUserRelCompanyOrThrow?: Maybe<UserRelCompany>;
  userRelCompanies: Array<UserRelCompany>;
  userRelCompany?: Maybe<UserRelCompany>;
  getUserRelCompany?: Maybe<UserRelCompany>;
  groupByUserRelCompany: Array<UserRelCompanyGroupBy>;
  testQuery: Scalars["Boolean"];
  fetchProfitCenters: Array<ProfitCenter>;
  fetchActions: Array<Action>;
  getMe: User;
};

export type QueryAggregateCaveatArgs = {
  where?: Maybe<CaveatWhereInput>;
  orderBy?: Maybe<Array<CaveatOrderByWithRelationInput>>;
  cursor?: Maybe<CaveatWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstCaveatArgs = {
  where?: Maybe<CaveatWhereInput>;
  orderBy?: Maybe<Array<CaveatOrderByWithRelationInput>>;
  cursor?: Maybe<CaveatWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CaveatScalarFieldEnum>>;
};

export type QueryFindFirstCaveatOrThrowArgs = {
  where?: Maybe<CaveatWhereInput>;
  orderBy?: Maybe<Array<CaveatOrderByWithRelationInput>>;
  cursor?: Maybe<CaveatWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CaveatScalarFieldEnum>>;
};

export type QueryCaveatsArgs = {
  where?: Maybe<CaveatWhereInput>;
  orderBy?: Maybe<Array<CaveatOrderByWithRelationInput>>;
  cursor?: Maybe<CaveatWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CaveatScalarFieldEnum>>;
};

export type QueryCaveatArgs = {
  where: CaveatWhereUniqueInput;
};

export type QueryGetCaveatArgs = {
  where: CaveatWhereUniqueInput;
};

export type QueryGroupByCaveatArgs = {
  where?: Maybe<CaveatWhereInput>;
  orderBy?: Maybe<Array<CaveatOrderByWithAggregationInput>>;
  by: Array<CaveatScalarFieldEnum>;
  having?: Maybe<CaveatScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateCompanyArgs = {
  where?: Maybe<CompanyWhereInput>;
  orderBy?: Maybe<Array<CompanyOrderByWithRelationInput>>;
  cursor?: Maybe<CompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstCompanyArgs = {
  where?: Maybe<CompanyWhereInput>;
  orderBy?: Maybe<Array<CompanyOrderByWithRelationInput>>;
  cursor?: Maybe<CompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CompanyScalarFieldEnum>>;
};

export type QueryFindFirstCompanyOrThrowArgs = {
  where?: Maybe<CompanyWhereInput>;
  orderBy?: Maybe<Array<CompanyOrderByWithRelationInput>>;
  cursor?: Maybe<CompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CompanyScalarFieldEnum>>;
};

export type QueryCompaniesArgs = {
  where?: Maybe<CompanyWhereInput>;
  orderBy?: Maybe<Array<CompanyOrderByWithRelationInput>>;
  cursor?: Maybe<CompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CompanyScalarFieldEnum>>;
};

export type QueryCompanyArgs = {
  where: CompanyWhereUniqueInput;
};

export type QueryGetCompanyArgs = {
  where: CompanyWhereUniqueInput;
};

export type QueryGroupByCompanyArgs = {
  where?: Maybe<CompanyWhereInput>;
  orderBy?: Maybe<Array<CompanyOrderByWithAggregationInput>>;
  by: Array<CompanyScalarFieldEnum>;
  having?: Maybe<CompanyScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateCompanyDefaultValueArgs = {
  where?: Maybe<CompanyDefaultValueWhereInput>;
  orderBy?: Maybe<Array<CompanyDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<CompanyDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstCompanyDefaultValueArgs = {
  where?: Maybe<CompanyDefaultValueWhereInput>;
  orderBy?: Maybe<Array<CompanyDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<CompanyDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CompanyDefaultValueScalarFieldEnum>>;
};

export type QueryFindFirstCompanyDefaultValueOrThrowArgs = {
  where?: Maybe<CompanyDefaultValueWhereInput>;
  orderBy?: Maybe<Array<CompanyDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<CompanyDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CompanyDefaultValueScalarFieldEnum>>;
};

export type QueryCompanyDefaultValuesArgs = {
  where?: Maybe<CompanyDefaultValueWhereInput>;
  orderBy?: Maybe<Array<CompanyDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<CompanyDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<CompanyDefaultValueScalarFieldEnum>>;
};

export type QueryCompanyDefaultValueArgs = {
  where: CompanyDefaultValueWhereUniqueInput;
};

export type QueryGetCompanyDefaultValueArgs = {
  where: CompanyDefaultValueWhereUniqueInput;
};

export type QueryGroupByCompanyDefaultValueArgs = {
  where?: Maybe<CompanyDefaultValueWhereInput>;
  orderBy?: Maybe<Array<CompanyDefaultValueOrderByWithAggregationInput>>;
  by: Array<CompanyDefaultValueScalarFieldEnum>;
  having?: Maybe<CompanyDefaultValueScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateDeliveryNoteArgs = {
  where?: Maybe<DeliveryNoteWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstDeliveryNoteArgs = {
  where?: Maybe<DeliveryNoteWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteScalarFieldEnum>>;
};

export type QueryFindFirstDeliveryNoteOrThrowArgs = {
  where?: Maybe<DeliveryNoteWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteScalarFieldEnum>>;
};

export type QueryDeliveryNotesArgs = {
  where?: Maybe<DeliveryNoteWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteScalarFieldEnum>>;
};

export type QueryDeliveryNoteArgs = {
  where: DeliveryNoteWhereUniqueInput;
};

export type QueryGetDeliveryNoteArgs = {
  where: DeliveryNoteWhereUniqueInput;
};

export type QueryGroupByDeliveryNoteArgs = {
  where?: Maybe<DeliveryNoteWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteOrderByWithAggregationInput>>;
  by: Array<DeliveryNoteScalarFieldEnum>;
  having?: Maybe<DeliveryNoteScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateDeliveryNoteDocumentArgs = {
  where?: Maybe<DeliveryNoteDocumentWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteDocumentOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteDocumentWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstDeliveryNoteDocumentArgs = {
  where?: Maybe<DeliveryNoteDocumentWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteDocumentOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteDocumentWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteDocumentScalarFieldEnum>>;
};

export type QueryFindFirstDeliveryNoteDocumentOrThrowArgs = {
  where?: Maybe<DeliveryNoteDocumentWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteDocumentOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteDocumentWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteDocumentScalarFieldEnum>>;
};

export type QueryDeliveryNoteDocumentsArgs = {
  where?: Maybe<DeliveryNoteDocumentWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteDocumentOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteDocumentWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteDocumentScalarFieldEnum>>;
};

export type QueryDeliveryNoteDocumentArgs = {
  where: DeliveryNoteDocumentWhereUniqueInput;
};

export type QueryGetDeliveryNoteDocumentArgs = {
  where: DeliveryNoteDocumentWhereUniqueInput;
};

export type QueryGroupByDeliveryNoteDocumentArgs = {
  where?: Maybe<DeliveryNoteDocumentWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteDocumentOrderByWithAggregationInput>>;
  by: Array<DeliveryNoteDocumentScalarFieldEnum>;
  having?: Maybe<DeliveryNoteDocumentScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateDeliveryNoteLoadingUnitArgs = {
  where?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteLoadingUnitOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteLoadingUnitWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstDeliveryNoteLoadingUnitArgs = {
  where?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteLoadingUnitOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteLoadingUnitWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteLoadingUnitScalarFieldEnum>>;
};

export type QueryFindFirstDeliveryNoteLoadingUnitOrThrowArgs = {
  where?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteLoadingUnitOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteLoadingUnitWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteLoadingUnitScalarFieldEnum>>;
};

export type QueryDeliveryNoteLoadingUnitsArgs = {
  where?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteLoadingUnitOrderByWithRelationInput>>;
  cursor?: Maybe<DeliveryNoteLoadingUnitWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<DeliveryNoteLoadingUnitScalarFieldEnum>>;
};

export type QueryDeliveryNoteLoadingUnitArgs = {
  where: DeliveryNoteLoadingUnitWhereUniqueInput;
};

export type QueryGetDeliveryNoteLoadingUnitArgs = {
  where: DeliveryNoteLoadingUnitWhereUniqueInput;
};

export type QueryGroupByDeliveryNoteLoadingUnitArgs = {
  where?: Maybe<DeliveryNoteLoadingUnitWhereInput>;
  orderBy?: Maybe<Array<DeliveryNoteLoadingUnitOrderByWithAggregationInput>>;
  by: Array<DeliveryNoteLoadingUnitScalarFieldEnum>;
  having?: Maybe<DeliveryNoteLoadingUnitScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateLoadingUnitArgs = {
  where?: Maybe<LoadingUnitWhereInput>;
  orderBy?: Maybe<Array<LoadingUnitOrderByWithRelationInput>>;
  cursor?: Maybe<LoadingUnitWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstLoadingUnitArgs = {
  where?: Maybe<LoadingUnitWhereInput>;
  orderBy?: Maybe<Array<LoadingUnitOrderByWithRelationInput>>;
  cursor?: Maybe<LoadingUnitWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<LoadingUnitScalarFieldEnum>>;
};

export type QueryFindFirstLoadingUnitOrThrowArgs = {
  where?: Maybe<LoadingUnitWhereInput>;
  orderBy?: Maybe<Array<LoadingUnitOrderByWithRelationInput>>;
  cursor?: Maybe<LoadingUnitWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<LoadingUnitScalarFieldEnum>>;
};

export type QueryLoadingUnitsArgs = {
  where?: Maybe<LoadingUnitWhereInput>;
  orderBy?: Maybe<Array<LoadingUnitOrderByWithRelationInput>>;
  cursor?: Maybe<LoadingUnitWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<LoadingUnitScalarFieldEnum>>;
};

export type QueryLoadingUnitArgs = {
  where: LoadingUnitWhereUniqueInput;
};

export type QueryGetLoadingUnitArgs = {
  where: LoadingUnitWhereUniqueInput;
};

export type QueryGroupByLoadingUnitArgs = {
  where?: Maybe<LoadingUnitWhereInput>;
  orderBy?: Maybe<Array<LoadingUnitOrderByWithAggregationInput>>;
  by: Array<LoadingUnitScalarFieldEnum>;
  having?: Maybe<LoadingUnitScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateLocationArgs = {
  where?: Maybe<LocationWhereInput>;
  orderBy?: Maybe<Array<LocationOrderByWithRelationInput>>;
  cursor?: Maybe<LocationWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstLocationArgs = {
  where?: Maybe<LocationWhereInput>;
  orderBy?: Maybe<Array<LocationOrderByWithRelationInput>>;
  cursor?: Maybe<LocationWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<LocationScalarFieldEnum>>;
};

export type QueryFindFirstLocationOrThrowArgs = {
  where?: Maybe<LocationWhereInput>;
  orderBy?: Maybe<Array<LocationOrderByWithRelationInput>>;
  cursor?: Maybe<LocationWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<LocationScalarFieldEnum>>;
};

export type QueryLocationsArgs = {
  where?: Maybe<LocationWhereInput>;
  orderBy?: Maybe<Array<LocationOrderByWithRelationInput>>;
  cursor?: Maybe<LocationWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<LocationScalarFieldEnum>>;
};

export type QueryLocationArgs = {
  where: LocationWhereUniqueInput;
};

export type QueryGetLocationArgs = {
  where: LocationWhereUniqueInput;
};

export type QueryGroupByLocationArgs = {
  where?: Maybe<LocationWhereInput>;
  orderBy?: Maybe<Array<LocationOrderByWithAggregationInput>>;
  by: Array<LocationScalarFieldEnum>;
  having?: Maybe<LocationScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateOrderArgs = {
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<Array<OrderOrderByWithRelationInput>>;
  cursor?: Maybe<OrderWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstOrderArgs = {
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<Array<OrderOrderByWithRelationInput>>;
  cursor?: Maybe<OrderWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<OrderScalarFieldEnum>>;
};

export type QueryFindFirstOrderOrThrowArgs = {
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<Array<OrderOrderByWithRelationInput>>;
  cursor?: Maybe<OrderWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<OrderScalarFieldEnum>>;
};

export type QueryOrdersArgs = {
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<Array<OrderOrderByWithRelationInput>>;
  cursor?: Maybe<OrderWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<OrderScalarFieldEnum>>;
};

export type QueryOrderArgs = {
  where: OrderWhereUniqueInput;
};

export type QueryGetOrderArgs = {
  where: OrderWhereUniqueInput;
};

export type QueryGroupByOrderArgs = {
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<Array<OrderOrderByWithAggregationInput>>;
  by: Array<OrderScalarFieldEnum>;
  having?: Maybe<OrderScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateOrderTripArgs = {
  where?: Maybe<OrderTripWhereInput>;
  orderBy?: Maybe<Array<OrderTripOrderByWithRelationInput>>;
  cursor?: Maybe<OrderTripWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstOrderTripArgs = {
  where?: Maybe<OrderTripWhereInput>;
  orderBy?: Maybe<Array<OrderTripOrderByWithRelationInput>>;
  cursor?: Maybe<OrderTripWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<OrderTripScalarFieldEnum>>;
};

export type QueryFindFirstOrderTripOrThrowArgs = {
  where?: Maybe<OrderTripWhereInput>;
  orderBy?: Maybe<Array<OrderTripOrderByWithRelationInput>>;
  cursor?: Maybe<OrderTripWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<OrderTripScalarFieldEnum>>;
};

export type QueryOrderTripsArgs = {
  where?: Maybe<OrderTripWhereInput>;
  orderBy?: Maybe<Array<OrderTripOrderByWithRelationInput>>;
  cursor?: Maybe<OrderTripWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<OrderTripScalarFieldEnum>>;
};

export type QueryOrderTripArgs = {
  where: OrderTripWhereUniqueInput;
};

export type QueryGetOrderTripArgs = {
  where: OrderTripWhereUniqueInput;
};

export type QueryGroupByOrderTripArgs = {
  where?: Maybe<OrderTripWhereInput>;
  orderBy?: Maybe<Array<OrderTripOrderByWithAggregationInput>>;
  by: Array<OrderTripScalarFieldEnum>;
  having?: Maybe<OrderTripScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateSsccArgs = {
  where?: Maybe<SsccWhereInput>;
  orderBy?: Maybe<Array<SsccOrderByWithRelationInput>>;
  cursor?: Maybe<SsccWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstSsccArgs = {
  where?: Maybe<SsccWhereInput>;
  orderBy?: Maybe<Array<SsccOrderByWithRelationInput>>;
  cursor?: Maybe<SsccWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<SsccScalarFieldEnum>>;
};

export type QueryFindFirstSsccOrThrowArgs = {
  where?: Maybe<SsccWhereInput>;
  orderBy?: Maybe<Array<SsccOrderByWithRelationInput>>;
  cursor?: Maybe<SsccWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<SsccScalarFieldEnum>>;
};

export type QuerySsccsArgs = {
  where?: Maybe<SsccWhereInput>;
  orderBy?: Maybe<Array<SsccOrderByWithRelationInput>>;
  cursor?: Maybe<SsccWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<SsccScalarFieldEnum>>;
};

export type QuerySsccArgs = {
  where: SsccWhereUniqueInput;
};

export type QueryGetSsccArgs = {
  where: SsccWhereUniqueInput;
};

export type QueryGroupBySsccArgs = {
  where?: Maybe<SsccWhereInput>;
  orderBy?: Maybe<Array<SsccOrderByWithAggregationInput>>;
  by: Array<SsccScalarFieldEnum>;
  having?: Maybe<SsccScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateUserArgs = {
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  cursor?: Maybe<UserWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstUserArgs = {
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  cursor?: Maybe<UserWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserScalarFieldEnum>>;
};

export type QueryFindFirstUserOrThrowArgs = {
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  cursor?: Maybe<UserWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserScalarFieldEnum>>;
};

export type QueryUsersArgs = {
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  cursor?: Maybe<UserWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserScalarFieldEnum>>;
};

export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};

export type QueryGetUserArgs = {
  where: UserWhereUniqueInput;
};

export type QueryGroupByUserArgs = {
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<Array<UserOrderByWithAggregationInput>>;
  by: Array<UserScalarFieldEnum>;
  having?: Maybe<UserScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateUserDefaultValueArgs = {
  where?: Maybe<UserDefaultValueWhereInput>;
  orderBy?: Maybe<Array<UserDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<UserDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstUserDefaultValueArgs = {
  where?: Maybe<UserDefaultValueWhereInput>;
  orderBy?: Maybe<Array<UserDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<UserDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserDefaultValueScalarFieldEnum>>;
};

export type QueryFindFirstUserDefaultValueOrThrowArgs = {
  where?: Maybe<UserDefaultValueWhereInput>;
  orderBy?: Maybe<Array<UserDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<UserDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserDefaultValueScalarFieldEnum>>;
};

export type QueryUserDefaultValuesArgs = {
  where?: Maybe<UserDefaultValueWhereInput>;
  orderBy?: Maybe<Array<UserDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<UserDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserDefaultValueScalarFieldEnum>>;
};

export type QueryUserDefaultValueArgs = {
  where: UserDefaultValueWhereUniqueInput;
};

export type QueryGetUserDefaultValueArgs = {
  where: UserDefaultValueWhereUniqueInput;
};

export type QueryGroupByUserDefaultValueArgs = {
  where?: Maybe<UserDefaultValueWhereInput>;
  orderBy?: Maybe<Array<UserDefaultValueOrderByWithAggregationInput>>;
  by: Array<UserDefaultValueScalarFieldEnum>;
  having?: Maybe<UserDefaultValueScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryAggregateUserRelCompanyArgs = {
  where?: Maybe<UserRelCompanyWhereInput>;
  orderBy?: Maybe<Array<UserRelCompanyOrderByWithRelationInput>>;
  cursor?: Maybe<UserRelCompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export type QueryFindFirstUserRelCompanyArgs = {
  where?: Maybe<UserRelCompanyWhereInput>;
  orderBy?: Maybe<Array<UserRelCompanyOrderByWithRelationInput>>;
  cursor?: Maybe<UserRelCompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserRelCompanyScalarFieldEnum>>;
};

export type QueryFindFirstUserRelCompanyOrThrowArgs = {
  where?: Maybe<UserRelCompanyWhereInput>;
  orderBy?: Maybe<Array<UserRelCompanyOrderByWithRelationInput>>;
  cursor?: Maybe<UserRelCompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserRelCompanyScalarFieldEnum>>;
};

export type QueryUserRelCompaniesArgs = {
  where?: Maybe<UserRelCompanyWhereInput>;
  orderBy?: Maybe<Array<UserRelCompanyOrderByWithRelationInput>>;
  cursor?: Maybe<UserRelCompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserRelCompanyScalarFieldEnum>>;
};

export type QueryUserRelCompanyArgs = {
  where: UserRelCompanyWhereUniqueInput;
};

export type QueryGetUserRelCompanyArgs = {
  where: UserRelCompanyWhereUniqueInput;
};

export type QueryGroupByUserRelCompanyArgs = {
  where?: Maybe<UserRelCompanyWhereInput>;
  orderBy?: Maybe<Array<UserRelCompanyOrderByWithAggregationInput>>;
  by: Array<UserRelCompanyScalarFieldEnum>;
  having?: Maybe<UserRelCompanyScalarWhereWithAggregatesInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
};

export enum QueryMode {
  Default = "default",
  Insensitive = "insensitive",
}

export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

export type Sscc = {
  __typename?: "Sscc";
  id: Scalars["String"];
  sscc: Scalars["String"];
  deliveryNoteId: Scalars["String"];
  deliveryNote: DeliveryNote;
};

export type SsccCountAggregate = {
  __typename?: "SsccCountAggregate";
  id: Scalars["Int"];
  sscc: Scalars["Int"];
  deliveryNoteId: Scalars["Int"];
  _all: Scalars["Int"];
};

export type SsccCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  sscc?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export type SsccCreateInput = {
  id?: Maybe<Scalars["String"]>;
  sscc: Scalars["String"];
  deliveryNote: DeliveryNoteCreateNestedOneWithoutSsccInput;
};

export type SsccCreateManyDeliveryNoteInput = {
  id?: Maybe<Scalars["String"]>;
  sscc: Scalars["String"];
};

export type SsccCreateManyDeliveryNoteInputEnvelope = {
  data: Array<SsccCreateManyDeliveryNoteInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type SsccCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  sscc: Scalars["String"];
  deliveryNoteId: Scalars["String"];
};

export type SsccCreateNestedManyWithoutDeliveryNoteInput = {
  create?: Maybe<Array<SsccCreateWithoutDeliveryNoteInput>>;
  connectOrCreate?: Maybe<Array<SsccCreateOrConnectWithoutDeliveryNoteInput>>;
  createMany?: Maybe<SsccCreateManyDeliveryNoteInputEnvelope>;
  connect?: Maybe<Array<SsccWhereUniqueInput>>;
};

export type SsccCreateOrConnectWithoutDeliveryNoteInput = {
  where: SsccWhereUniqueInput;
  create: SsccCreateWithoutDeliveryNoteInput;
};

export type SsccCreateWithoutDeliveryNoteInput = {
  id?: Maybe<Scalars["String"]>;
  sscc: Scalars["String"];
};

export type SsccGroupBy = {
  __typename?: "SsccGroupBy";
  id: Scalars["String"];
  sscc: Scalars["String"];
  deliveryNoteId: Scalars["String"];
  _count?: Maybe<SsccCountAggregate>;
  _min?: Maybe<SsccMinAggregate>;
  _max?: Maybe<SsccMaxAggregate>;
};

export type SsccListRelationFilter = {
  every?: Maybe<SsccWhereInput>;
  some?: Maybe<SsccWhereInput>;
  none?: Maybe<SsccWhereInput>;
};

export type SsccMaxAggregate = {
  __typename?: "SsccMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  sscc?: Maybe<Scalars["String"]>;
  deliveryNoteId?: Maybe<Scalars["String"]>;
};

export type SsccMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  sscc?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export type SsccMinAggregate = {
  __typename?: "SsccMinAggregate";
  id?: Maybe<Scalars["String"]>;
  sscc?: Maybe<Scalars["String"]>;
  deliveryNoteId?: Maybe<Scalars["String"]>;
};

export type SsccMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  sscc?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export type SsccOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SsccOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  sscc?: Maybe<SortOrder>;
  deliveryNoteId?: Maybe<SortOrder>;
  _count?: Maybe<SsccCountOrderByAggregateInput>;
  _max?: Maybe<SsccMaxOrderByAggregateInput>;
  _min?: Maybe<SsccMinOrderByAggregateInput>;
};

export type SsccOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  sscc?: Maybe<SortOrder>;
  deliveryNote?: Maybe<DeliveryNoteOrderByWithRelationInput>;
  deliveryNoteId?: Maybe<SortOrder>;
};

export enum SsccScalarFieldEnum {
  Id = "id",
  Sscc = "sscc",
  DeliveryNoteId = "deliveryNoteId",
}

export type SsccScalarWhereInput = {
  AND?: Maybe<Array<SsccScalarWhereInput>>;
  OR?: Maybe<Array<SsccScalarWhereInput>>;
  NOT?: Maybe<Array<SsccScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  sscc?: Maybe<StringFilter>;
  deliveryNoteId?: Maybe<StringFilter>;
};

export type SsccScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SsccScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SsccScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SsccScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  sscc?: Maybe<StringWithAggregatesFilter>;
  deliveryNoteId?: Maybe<StringWithAggregatesFilter>;
};

export type SsccUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  sscc?: Maybe<StringFieldUpdateOperationsInput>;
  deliveryNote?: Maybe<DeliveryNoteUpdateOneRequiredWithoutSsccNestedInput>;
};

export type SsccUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  sscc?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SsccUpdateManyWithWhereWithoutDeliveryNoteInput = {
  where: SsccScalarWhereInput;
  data: SsccUpdateManyMutationInput;
};

export type SsccUpdateManyWithoutDeliveryNoteNestedInput = {
  create?: Maybe<Array<SsccCreateWithoutDeliveryNoteInput>>;
  connectOrCreate?: Maybe<Array<SsccCreateOrConnectWithoutDeliveryNoteInput>>;
  upsert?: Maybe<Array<SsccUpsertWithWhereUniqueWithoutDeliveryNoteInput>>;
  createMany?: Maybe<SsccCreateManyDeliveryNoteInputEnvelope>;
  set?: Maybe<Array<SsccWhereUniqueInput>>;
  disconnect?: Maybe<Array<SsccWhereUniqueInput>>;
  delete?: Maybe<Array<SsccWhereUniqueInput>>;
  connect?: Maybe<Array<SsccWhereUniqueInput>>;
  update?: Maybe<Array<SsccUpdateWithWhereUniqueWithoutDeliveryNoteInput>>;
  updateMany?: Maybe<Array<SsccUpdateManyWithWhereWithoutDeliveryNoteInput>>;
  deleteMany?: Maybe<Array<SsccScalarWhereInput>>;
};

export type SsccUpdateWithWhereUniqueWithoutDeliveryNoteInput = {
  where: SsccWhereUniqueInput;
  data: SsccUpdateWithoutDeliveryNoteInput;
};

export type SsccUpdateWithoutDeliveryNoteInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  sscc?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SsccUpsertWithWhereUniqueWithoutDeliveryNoteInput = {
  where: SsccWhereUniqueInput;
  update: SsccUpdateWithoutDeliveryNoteInput;
  create: SsccCreateWithoutDeliveryNoteInput;
};

export type SsccWhereInput = {
  AND?: Maybe<Array<SsccWhereInput>>;
  OR?: Maybe<Array<SsccWhereInput>>;
  NOT?: Maybe<Array<SsccWhereInput>>;
  id?: Maybe<StringFilter>;
  sscc?: Maybe<StringFilter>;
  deliveryNote?: Maybe<DeliveryNoteRelationFilter>;
  deliveryNoteId?: Maybe<StringFilter>;
};

export type SsccWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type StringFieldUpdateOperationsInput = {
  set?: Maybe<Scalars["String"]>;
};

export type StringFilter = {
  equals?: Maybe<Scalars["String"]>;
  in?: Maybe<Array<Scalars["String"]>>;
  notIn?: Maybe<Array<Scalars["String"]>>;
  lt?: Maybe<Scalars["String"]>;
  lte?: Maybe<Scalars["String"]>;
  gt?: Maybe<Scalars["String"]>;
  gte?: Maybe<Scalars["String"]>;
  contains?: Maybe<Scalars["String"]>;
  startsWith?: Maybe<Scalars["String"]>;
  endsWith?: Maybe<Scalars["String"]>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringFilter>;
};

export type StringNullableFilter = {
  equals?: Maybe<Scalars["String"]>;
  in?: Maybe<Array<Scalars["String"]>>;
  notIn?: Maybe<Array<Scalars["String"]>>;
  lt?: Maybe<Scalars["String"]>;
  lte?: Maybe<Scalars["String"]>;
  gt?: Maybe<Scalars["String"]>;
  gte?: Maybe<Scalars["String"]>;
  contains?: Maybe<Scalars["String"]>;
  startsWith?: Maybe<Scalars["String"]>;
  endsWith?: Maybe<Scalars["String"]>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringNullableFilter>;
};

export type StringNullableWithAggregatesFilter = {
  equals?: Maybe<Scalars["String"]>;
  in?: Maybe<Array<Scalars["String"]>>;
  notIn?: Maybe<Array<Scalars["String"]>>;
  lt?: Maybe<Scalars["String"]>;
  lte?: Maybe<Scalars["String"]>;
  gt?: Maybe<Scalars["String"]>;
  gte?: Maybe<Scalars["String"]>;
  contains?: Maybe<Scalars["String"]>;
  startsWith?: Maybe<Scalars["String"]>;
  endsWith?: Maybe<Scalars["String"]>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringNullableWithAggregatesFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedStringNullableFilter>;
  _max?: Maybe<NestedStringNullableFilter>;
};

export type StringWithAggregatesFilter = {
  equals?: Maybe<Scalars["String"]>;
  in?: Maybe<Array<Scalars["String"]>>;
  notIn?: Maybe<Array<Scalars["String"]>>;
  lt?: Maybe<Scalars["String"]>;
  lte?: Maybe<Scalars["String"]>;
  gt?: Maybe<Scalars["String"]>;
  gte?: Maybe<Scalars["String"]>;
  contains?: Maybe<Scalars["String"]>;
  startsWith?: Maybe<Scalars["String"]>;
  endsWith?: Maybe<Scalars["String"]>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  _count?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedStringFilter>;
  _max?: Maybe<NestedStringFilter>;
};

export type User = {
  __typename?: "User";
  id: Scalars["String"];
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  createdAt: Scalars["DateTime"];
  isAd: Scalars["Boolean"];
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  selectedCompanyId?: Maybe<Scalars["String"]>;
  isAdmin: Scalars["Boolean"];
  _count?: Maybe<UserCount>;
  selectedCompany?: Maybe<Company>;
  orders: Array<Order>;
  companies: Array<UserRelCompany>;
  userDefaultValues: Array<UserDefaultValue>;
};

export type UserOrdersArgs = {
  where?: Maybe<OrderWhereInput>;
  orderBy?: Maybe<Array<OrderOrderByWithRelationInput>>;
  cursor?: Maybe<OrderWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<OrderScalarFieldEnum>>;
};

export type UserCompaniesArgs = {
  where?: Maybe<UserRelCompanyWhereInput>;
  orderBy?: Maybe<Array<UserRelCompanyOrderByWithRelationInput>>;
  cursor?: Maybe<UserRelCompanyWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserRelCompanyScalarFieldEnum>>;
};

export type UserUserDefaultValuesArgs = {
  where?: Maybe<UserDefaultValueWhereInput>;
  orderBy?: Maybe<Array<UserDefaultValueOrderByWithRelationInput>>;
  cursor?: Maybe<UserDefaultValueWhereUniqueInput>;
  take?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  distinct?: Maybe<Array<UserDefaultValueScalarFieldEnum>>;
};

export type UserCount = {
  __typename?: "UserCount";
  orders: Scalars["Int"];
  companies: Scalars["Int"];
  userDefaultValues: Scalars["Int"];
};

export type UserCountAggregate = {
  __typename?: "UserCountAggregate";
  id: Scalars["Int"];
  password: Scalars["Int"];
  tokenSalt: Scalars["Int"];
  firstName: Scalars["Int"];
  lastName: Scalars["Int"];
  email: Scalars["Int"];
  createdAt: Scalars["Int"];
  isAd: Scalars["Int"];
  deliveryNotesVisitor: Scalars["Int"];
  presetPassword: Scalars["Int"];
  deletedAt: Scalars["Int"];
  carloUsername: Scalars["Int"];
  ingresUsername: Scalars["Int"];
  selectedCompanyId: Scalars["Int"];
  isAdmin: Scalars["Int"];
  _all: Scalars["Int"];
};

export type UserCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  tokenSalt?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  isAd?: Maybe<SortOrder>;
  deliveryNotesVisitor?: Maybe<SortOrder>;
  presetPassword?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  carloUsername?: Maybe<SortOrder>;
  ingresUsername?: Maybe<SortOrder>;
  selectedCompanyId?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
};

export type UserCreateInput = {
  id?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tokenSalt?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  isAd: Scalars["Boolean"];
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  selectedCompany?: Maybe<CompanyCreateNestedOneWithoutSelectedCompaniesInput>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
  orders?: Maybe<OrderCreateNestedManyWithoutUserInput>;
  companies?: Maybe<UserRelCompanyCreateNestedManyWithoutUserInput>;
  userDefaultValues?: Maybe<UserDefaultValueCreateNestedManyWithoutUserInput>;
};

export type UserCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tokenSalt?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  isAd: Scalars["Boolean"];
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  selectedCompanyId?: Maybe<Scalars["String"]>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
};

export type UserCreateManySelectedCompanyInput = {
  id?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tokenSalt?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  isAd: Scalars["Boolean"];
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
};

export type UserCreateManySelectedCompanyInputEnvelope = {
  data: Array<UserCreateManySelectedCompanyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type UserCreateNestedManyWithoutSelectedCompanyInput = {
  create?: Maybe<Array<UserCreateWithoutSelectedCompanyInput>>;
  connectOrCreate?: Maybe<
    Array<UserCreateOrConnectWithoutSelectedCompanyInput>
  >;
  createMany?: Maybe<UserCreateManySelectedCompanyInputEnvelope>;
  connect?: Maybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateNestedOneWithoutCompaniesInput = {
  create?: Maybe<UserCreateWithoutCompaniesInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCompaniesInput>;
  connect?: Maybe<UserWhereUniqueInput>;
};

export type UserCreateNestedOneWithoutOrdersInput = {
  create?: Maybe<UserCreateWithoutOrdersInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutOrdersInput>;
  connect?: Maybe<UserWhereUniqueInput>;
};

export type UserCreateNestedOneWithoutUserDefaultValuesInput = {
  create?: Maybe<UserCreateWithoutUserDefaultValuesInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserDefaultValuesInput>;
  connect?: Maybe<UserWhereUniqueInput>;
};

export type UserCreateOrConnectWithoutCompaniesInput = {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutCompaniesInput;
};

export type UserCreateOrConnectWithoutOrdersInput = {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutOrdersInput;
};

export type UserCreateOrConnectWithoutSelectedCompanyInput = {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutSelectedCompanyInput;
};

export type UserCreateOrConnectWithoutUserDefaultValuesInput = {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutUserDefaultValuesInput;
};

export type UserCreateWithoutCompaniesInput = {
  id?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tokenSalt?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  isAd: Scalars["Boolean"];
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  selectedCompany?: Maybe<CompanyCreateNestedOneWithoutSelectedCompaniesInput>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
  orders?: Maybe<OrderCreateNestedManyWithoutUserInput>;
  userDefaultValues?: Maybe<UserDefaultValueCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutOrdersInput = {
  id?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tokenSalt?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  isAd: Scalars["Boolean"];
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  selectedCompany?: Maybe<CompanyCreateNestedOneWithoutSelectedCompaniesInput>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
  companies?: Maybe<UserRelCompanyCreateNestedManyWithoutUserInput>;
  userDefaultValues?: Maybe<UserDefaultValueCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutSelectedCompanyInput = {
  id?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tokenSalt?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  isAd: Scalars["Boolean"];
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
  orders?: Maybe<OrderCreateNestedManyWithoutUserInput>;
  companies?: Maybe<UserRelCompanyCreateNestedManyWithoutUserInput>;
  userDefaultValues?: Maybe<UserDefaultValueCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserDefaultValuesInput = {
  id?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tokenSalt?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  isAd: Scalars["Boolean"];
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  selectedCompany?: Maybe<CompanyCreateNestedOneWithoutSelectedCompaniesInput>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
  orders?: Maybe<OrderCreateNestedManyWithoutUserInput>;
  companies?: Maybe<UserRelCompanyCreateNestedManyWithoutUserInput>;
};

export type UserDefaultValue = {
  __typename?: "UserDefaultValue";
  id: Scalars["String"];
  property: Scalars["String"];
  value: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
};

export type UserDefaultValueCountAggregate = {
  __typename?: "UserDefaultValueCountAggregate";
  id: Scalars["Int"];
  property: Scalars["Int"];
  value: Scalars["Int"];
  userId: Scalars["Int"];
  _all: Scalars["Int"];
};

export type UserDefaultValueCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserDefaultValueCreateInput = {
  id?: Maybe<Scalars["String"]>;
  property: Scalars["String"];
  value: Scalars["String"];
  user?: Maybe<UserCreateNestedOneWithoutUserDefaultValuesInput>;
};

export type UserDefaultValueCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  property: Scalars["String"];
  value: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
};

export type UserDefaultValueCreateManyUserInput = {
  id?: Maybe<Scalars["String"]>;
  property: Scalars["String"];
  value: Scalars["String"];
};

export type UserDefaultValueCreateManyUserInputEnvelope = {
  data: Array<UserDefaultValueCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type UserDefaultValueCreateNestedManyWithoutUserInput = {
  create?: Maybe<Array<UserDefaultValueCreateWithoutUserInput>>;
  connectOrCreate?: Maybe<
    Array<UserDefaultValueCreateOrConnectWithoutUserInput>
  >;
  createMany?: Maybe<UserDefaultValueCreateManyUserInputEnvelope>;
  connect?: Maybe<Array<UserDefaultValueWhereUniqueInput>>;
};

export type UserDefaultValueCreateOrConnectWithoutUserInput = {
  where: UserDefaultValueWhereUniqueInput;
  create: UserDefaultValueCreateWithoutUserInput;
};

export type UserDefaultValueCreateWithoutUserInput = {
  id?: Maybe<Scalars["String"]>;
  property: Scalars["String"];
  value: Scalars["String"];
};

export type UserDefaultValueGroupBy = {
  __typename?: "UserDefaultValueGroupBy";
  id: Scalars["String"];
  property: Scalars["String"];
  value: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
  _count?: Maybe<UserDefaultValueCountAggregate>;
  _min?: Maybe<UserDefaultValueMinAggregate>;
  _max?: Maybe<UserDefaultValueMaxAggregate>;
};

export type UserDefaultValueListRelationFilter = {
  every?: Maybe<UserDefaultValueWhereInput>;
  some?: Maybe<UserDefaultValueWhereInput>;
  none?: Maybe<UserDefaultValueWhereInput>;
};

export type UserDefaultValueMaxAggregate = {
  __typename?: "UserDefaultValueMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  property?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
};

export type UserDefaultValueMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserDefaultValueMinAggregate = {
  __typename?: "UserDefaultValueMinAggregate";
  id?: Maybe<Scalars["String"]>;
  property?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
};

export type UserDefaultValueMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UserDefaultValueOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserDefaultValueOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  _count?: Maybe<UserDefaultValueCountOrderByAggregateInput>;
  _max?: Maybe<UserDefaultValueMaxOrderByAggregateInput>;
  _min?: Maybe<UserDefaultValueMinOrderByAggregateInput>;
};

export type UserDefaultValueOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  property?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
};

export enum UserDefaultValueScalarFieldEnum {
  Id = "id",
  Property = "property",
  Value = "value",
  UserId = "userId",
}

export type UserDefaultValueScalarWhereInput = {
  AND?: Maybe<Array<UserDefaultValueScalarWhereInput>>;
  OR?: Maybe<Array<UserDefaultValueScalarWhereInput>>;
  NOT?: Maybe<Array<UserDefaultValueScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  property?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type UserDefaultValueScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserDefaultValueScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserDefaultValueScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserDefaultValueScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  property?: Maybe<StringWithAggregatesFilter>;
  value?: Maybe<StringWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type UserDefaultValueUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  property?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
  user?: Maybe<UserUpdateOneWithoutUserDefaultValuesNestedInput>;
};

export type UserDefaultValueUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  property?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type UserDefaultValueUpdateManyWithWhereWithoutUserInput = {
  where: UserDefaultValueScalarWhereInput;
  data: UserDefaultValueUpdateManyMutationInput;
};

export type UserDefaultValueUpdateManyWithoutUserNestedInput = {
  create?: Maybe<Array<UserDefaultValueCreateWithoutUserInput>>;
  connectOrCreate?: Maybe<
    Array<UserDefaultValueCreateOrConnectWithoutUserInput>
  >;
  upsert?: Maybe<Array<UserDefaultValueUpsertWithWhereUniqueWithoutUserInput>>;
  createMany?: Maybe<UserDefaultValueCreateManyUserInputEnvelope>;
  set?: Maybe<Array<UserDefaultValueWhereUniqueInput>>;
  disconnect?: Maybe<Array<UserDefaultValueWhereUniqueInput>>;
  delete?: Maybe<Array<UserDefaultValueWhereUniqueInput>>;
  connect?: Maybe<Array<UserDefaultValueWhereUniqueInput>>;
  update?: Maybe<Array<UserDefaultValueUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<
    Array<UserDefaultValueUpdateManyWithWhereWithoutUserInput>
  >;
  deleteMany?: Maybe<Array<UserDefaultValueScalarWhereInput>>;
};

export type UserDefaultValueUpdateWithWhereUniqueWithoutUserInput = {
  where: UserDefaultValueWhereUniqueInput;
  data: UserDefaultValueUpdateWithoutUserInput;
};

export type UserDefaultValueUpdateWithoutUserInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  property?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type UserDefaultValueUpsertWithWhereUniqueWithoutUserInput = {
  where: UserDefaultValueWhereUniqueInput;
  update: UserDefaultValueUpdateWithoutUserInput;
  create: UserDefaultValueCreateWithoutUserInput;
};

export type UserDefaultValueWhereInput = {
  AND?: Maybe<Array<UserDefaultValueWhereInput>>;
  OR?: Maybe<Array<UserDefaultValueWhereInput>>;
  NOT?: Maybe<Array<UserDefaultValueWhereInput>>;
  id?: Maybe<StringFilter>;
  property?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
  user?: Maybe<UserRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
};

export type UserDefaultValueWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type UserGroupBy = {
  __typename?: "UserGroupBy";
  id: Scalars["String"];
  password?: Maybe<Scalars["String"]>;
  tokenSalt: Scalars["String"];
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  createdAt: Scalars["DateTime"];
  isAd: Scalars["Boolean"];
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  selectedCompanyId?: Maybe<Scalars["String"]>;
  isAdmin: Scalars["Boolean"];
  _count?: Maybe<UserCountAggregate>;
  _min?: Maybe<UserMinAggregate>;
  _max?: Maybe<UserMaxAggregate>;
};

export type UserListRelationFilter = {
  every?: Maybe<UserWhereInput>;
  some?: Maybe<UserWhereInput>;
  none?: Maybe<UserWhereInput>;
};

export type UserMaxAggregate = {
  __typename?: "UserMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tokenSalt?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  isAd?: Maybe<Scalars["Boolean"]>;
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  selectedCompanyId?: Maybe<Scalars["String"]>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
};

export type UserMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  tokenSalt?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  isAd?: Maybe<SortOrder>;
  deliveryNotesVisitor?: Maybe<SortOrder>;
  presetPassword?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  carloUsername?: Maybe<SortOrder>;
  ingresUsername?: Maybe<SortOrder>;
  selectedCompanyId?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
};

export type UserMinAggregate = {
  __typename?: "UserMinAggregate";
  id?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tokenSalt?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  isAd?: Maybe<Scalars["Boolean"]>;
  deliveryNotesVisitor?: Maybe<Scalars["Boolean"]>;
  presetPassword?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  carloUsername?: Maybe<Scalars["String"]>;
  ingresUsername?: Maybe<Scalars["String"]>;
  selectedCompanyId?: Maybe<Scalars["String"]>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
};

export type UserMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  tokenSalt?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  isAd?: Maybe<SortOrder>;
  deliveryNotesVisitor?: Maybe<SortOrder>;
  presetPassword?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  carloUsername?: Maybe<SortOrder>;
  ingresUsername?: Maybe<SortOrder>;
  selectedCompanyId?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  tokenSalt?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  isAd?: Maybe<SortOrder>;
  deliveryNotesVisitor?: Maybe<SortOrder>;
  presetPassword?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  carloUsername?: Maybe<SortOrder>;
  ingresUsername?: Maybe<SortOrder>;
  selectedCompanyId?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
  _count?: Maybe<UserCountOrderByAggregateInput>;
  _max?: Maybe<UserMaxOrderByAggregateInput>;
  _min?: Maybe<UserMinOrderByAggregateInput>;
};

export type UserOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  password?: Maybe<SortOrder>;
  tokenSalt?: Maybe<SortOrder>;
  firstName?: Maybe<SortOrder>;
  lastName?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  isAd?: Maybe<SortOrder>;
  deliveryNotesVisitor?: Maybe<SortOrder>;
  presetPassword?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  carloUsername?: Maybe<SortOrder>;
  ingresUsername?: Maybe<SortOrder>;
  selectedCompany?: Maybe<CompanyOrderByWithRelationInput>;
  selectedCompanyId?: Maybe<SortOrder>;
  isAdmin?: Maybe<SortOrder>;
  orders?: Maybe<OrderOrderByRelationAggregateInput>;
  companies?: Maybe<UserRelCompanyOrderByRelationAggregateInput>;
  userDefaultValues?: Maybe<UserDefaultValueOrderByRelationAggregateInput>;
};

export type UserRelCompany = {
  __typename?: "UserRelCompany";
  id: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
  company?: Maybe<Company>;
};

export type UserRelCompanyCountAggregate = {
  __typename?: "UserRelCompanyCountAggregate";
  id: Scalars["Int"];
  userId: Scalars["Int"];
  companyId: Scalars["Int"];
  _all: Scalars["Int"];
};

export type UserRelCompanyCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
};

export type UserRelCompanyCreateInput = {
  id?: Maybe<Scalars["String"]>;
  user?: Maybe<UserCreateNestedOneWithoutCompaniesInput>;
  company?: Maybe<CompanyCreateNestedOneWithoutUsersInput>;
};

export type UserRelCompanyCreateManyCompanyInput = {
  id?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
};

export type UserRelCompanyCreateManyCompanyInputEnvelope = {
  data: Array<UserRelCompanyCreateManyCompanyInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type UserRelCompanyCreateManyInput = {
  id?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["String"]>;
};

export type UserRelCompanyCreateManyUserInput = {
  id?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["String"]>;
};

export type UserRelCompanyCreateManyUserInputEnvelope = {
  data: Array<UserRelCompanyCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars["Boolean"]>;
};

export type UserRelCompanyCreateNestedManyWithoutCompanyInput = {
  create?: Maybe<Array<UserRelCompanyCreateWithoutCompanyInput>>;
  connectOrCreate?: Maybe<
    Array<UserRelCompanyCreateOrConnectWithoutCompanyInput>
  >;
  createMany?: Maybe<UserRelCompanyCreateManyCompanyInputEnvelope>;
  connect?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
};

export type UserRelCompanyCreateNestedManyWithoutUserInput = {
  create?: Maybe<Array<UserRelCompanyCreateWithoutUserInput>>;
  connectOrCreate?: Maybe<Array<UserRelCompanyCreateOrConnectWithoutUserInput>>;
  createMany?: Maybe<UserRelCompanyCreateManyUserInputEnvelope>;
  connect?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
};

export type UserRelCompanyCreateOrConnectWithoutCompanyInput = {
  where: UserRelCompanyWhereUniqueInput;
  create: UserRelCompanyCreateWithoutCompanyInput;
};

export type UserRelCompanyCreateOrConnectWithoutUserInput = {
  where: UserRelCompanyWhereUniqueInput;
  create: UserRelCompanyCreateWithoutUserInput;
};

export type UserRelCompanyCreateWithoutCompanyInput = {
  id?: Maybe<Scalars["String"]>;
  user?: Maybe<UserCreateNestedOneWithoutCompaniesInput>;
};

export type UserRelCompanyCreateWithoutUserInput = {
  id?: Maybe<Scalars["String"]>;
  company?: Maybe<CompanyCreateNestedOneWithoutUsersInput>;
};

export type UserRelCompanyGroupBy = {
  __typename?: "UserRelCompanyGroupBy";
  id: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["String"]>;
  _count?: Maybe<UserRelCompanyCountAggregate>;
  _min?: Maybe<UserRelCompanyMinAggregate>;
  _max?: Maybe<UserRelCompanyMaxAggregate>;
};

export type UserRelCompanyListRelationFilter = {
  every?: Maybe<UserRelCompanyWhereInput>;
  some?: Maybe<UserRelCompanyWhereInput>;
  none?: Maybe<UserRelCompanyWhereInput>;
};

export type UserRelCompanyMaxAggregate = {
  __typename?: "UserRelCompanyMaxAggregate";
  id?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["String"]>;
};

export type UserRelCompanyMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
};

export type UserRelCompanyMinAggregate = {
  __typename?: "UserRelCompanyMinAggregate";
  id?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["String"]>;
};

export type UserRelCompanyMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
};

export type UserRelCompanyOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserRelCompanyOrderByWithAggregationInput = {
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  companyId?: Maybe<SortOrder>;
  _count?: Maybe<UserRelCompanyCountOrderByAggregateInput>;
  _max?: Maybe<UserRelCompanyMaxOrderByAggregateInput>;
  _min?: Maybe<UserRelCompanyMinOrderByAggregateInput>;
};

export type UserRelCompanyOrderByWithRelationInput = {
  id?: Maybe<SortOrder>;
  user?: Maybe<UserOrderByWithRelationInput>;
  userId?: Maybe<SortOrder>;
  company?: Maybe<CompanyOrderByWithRelationInput>;
  companyId?: Maybe<SortOrder>;
};

export enum UserRelCompanyScalarFieldEnum {
  Id = "id",
  UserId = "userId",
  CompanyId = "companyId",
}

export type UserRelCompanyScalarWhereInput = {
  AND?: Maybe<Array<UserRelCompanyScalarWhereInput>>;
  OR?: Maybe<Array<UserRelCompanyScalarWhereInput>>;
  NOT?: Maybe<Array<UserRelCompanyScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  userId?: Maybe<StringNullableFilter>;
  companyId?: Maybe<StringNullableFilter>;
};

export type UserRelCompanyScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserRelCompanyScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserRelCompanyScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserRelCompanyScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  userId?: Maybe<StringNullableWithAggregatesFilter>;
  companyId?: Maybe<StringNullableWithAggregatesFilter>;
};

export type UserRelCompanyUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  user?: Maybe<UserUpdateOneWithoutCompaniesNestedInput>;
  company?: Maybe<CompanyUpdateOneWithoutUsersNestedInput>;
};

export type UserRelCompanyUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
};

export type UserRelCompanyUpdateManyWithWhereWithoutCompanyInput = {
  where: UserRelCompanyScalarWhereInput;
  data: UserRelCompanyUpdateManyMutationInput;
};

export type UserRelCompanyUpdateManyWithWhereWithoutUserInput = {
  where: UserRelCompanyScalarWhereInput;
  data: UserRelCompanyUpdateManyMutationInput;
};

export type UserRelCompanyUpdateManyWithoutCompanyNestedInput = {
  create?: Maybe<Array<UserRelCompanyCreateWithoutCompanyInput>>;
  connectOrCreate?: Maybe<
    Array<UserRelCompanyCreateOrConnectWithoutCompanyInput>
  >;
  upsert?: Maybe<Array<UserRelCompanyUpsertWithWhereUniqueWithoutCompanyInput>>;
  createMany?: Maybe<UserRelCompanyCreateManyCompanyInputEnvelope>;
  set?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
  disconnect?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
  delete?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
  connect?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
  update?: Maybe<Array<UserRelCompanyUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<
    Array<UserRelCompanyUpdateManyWithWhereWithoutCompanyInput>
  >;
  deleteMany?: Maybe<Array<UserRelCompanyScalarWhereInput>>;
};

export type UserRelCompanyUpdateManyWithoutUserNestedInput = {
  create?: Maybe<Array<UserRelCompanyCreateWithoutUserInput>>;
  connectOrCreate?: Maybe<Array<UserRelCompanyCreateOrConnectWithoutUserInput>>;
  upsert?: Maybe<Array<UserRelCompanyUpsertWithWhereUniqueWithoutUserInput>>;
  createMany?: Maybe<UserRelCompanyCreateManyUserInputEnvelope>;
  set?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
  disconnect?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
  delete?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
  connect?: Maybe<Array<UserRelCompanyWhereUniqueInput>>;
  update?: Maybe<Array<UserRelCompanyUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserRelCompanyUpdateManyWithWhereWithoutUserInput>>;
  deleteMany?: Maybe<Array<UserRelCompanyScalarWhereInput>>;
};

export type UserRelCompanyUpdateWithWhereUniqueWithoutCompanyInput = {
  where: UserRelCompanyWhereUniqueInput;
  data: UserRelCompanyUpdateWithoutCompanyInput;
};

export type UserRelCompanyUpdateWithWhereUniqueWithoutUserInput = {
  where: UserRelCompanyWhereUniqueInput;
  data: UserRelCompanyUpdateWithoutUserInput;
};

export type UserRelCompanyUpdateWithoutCompanyInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  user?: Maybe<UserUpdateOneWithoutCompaniesNestedInput>;
};

export type UserRelCompanyUpdateWithoutUserInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  company?: Maybe<CompanyUpdateOneWithoutUsersNestedInput>;
};

export type UserRelCompanyUpsertWithWhereUniqueWithoutCompanyInput = {
  where: UserRelCompanyWhereUniqueInput;
  update: UserRelCompanyUpdateWithoutCompanyInput;
  create: UserRelCompanyCreateWithoutCompanyInput;
};

export type UserRelCompanyUpsertWithWhereUniqueWithoutUserInput = {
  where: UserRelCompanyWhereUniqueInput;
  update: UserRelCompanyUpdateWithoutUserInput;
  create: UserRelCompanyCreateWithoutUserInput;
};

export type UserRelCompanyWhereInput = {
  AND?: Maybe<Array<UserRelCompanyWhereInput>>;
  OR?: Maybe<Array<UserRelCompanyWhereInput>>;
  NOT?: Maybe<Array<UserRelCompanyWhereInput>>;
  id?: Maybe<StringFilter>;
  user?: Maybe<UserRelationFilter>;
  userId?: Maybe<StringNullableFilter>;
  company?: Maybe<CompanyRelationFilter>;
  companyId?: Maybe<StringNullableFilter>;
};

export type UserRelCompanyWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};

export type UserRelationFilter = {
  is?: Maybe<UserWhereInput>;
  isNot?: Maybe<UserWhereInput>;
};

export enum UserScalarFieldEnum {
  Id = "id",
  Password = "password",
  TokenSalt = "tokenSalt",
  FirstName = "firstName",
  LastName = "lastName",
  Email = "email",
  CreatedAt = "createdAt",
  IsAd = "isAd",
  DeliveryNotesVisitor = "deliveryNotesVisitor",
  PresetPassword = "presetPassword",
  DeletedAt = "deletedAt",
  CarloUsername = "carloUsername",
  IngresUsername = "ingresUsername",
  SelectedCompanyId = "selectedCompanyId",
  IsAdmin = "isAdmin",
}

export type UserScalarWhereInput = {
  AND?: Maybe<Array<UserScalarWhereInput>>;
  OR?: Maybe<Array<UserScalarWhereInput>>;
  NOT?: Maybe<Array<UserScalarWhereInput>>;
  id?: Maybe<StringFilter>;
  password?: Maybe<StringNullableFilter>;
  tokenSalt?: Maybe<StringFilter>;
  firstName?: Maybe<StringNullableFilter>;
  lastName?: Maybe<StringNullableFilter>;
  email?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  isAd?: Maybe<BoolFilter>;
  deliveryNotesVisitor?: Maybe<BoolNullableFilter>;
  presetPassword?: Maybe<BoolNullableFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  carloUsername?: Maybe<StringNullableFilter>;
  ingresUsername?: Maybe<StringNullableFilter>;
  selectedCompanyId?: Maybe<StringNullableFilter>;
  isAdmin?: Maybe<BoolFilter>;
};

export type UserScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UserScalarWhereWithAggregatesInput>>;
  id?: Maybe<StringWithAggregatesFilter>;
  password?: Maybe<StringNullableWithAggregatesFilter>;
  tokenSalt?: Maybe<StringWithAggregatesFilter>;
  firstName?: Maybe<StringNullableWithAggregatesFilter>;
  lastName?: Maybe<StringNullableWithAggregatesFilter>;
  email?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  isAd?: Maybe<BoolWithAggregatesFilter>;
  deliveryNotesVisitor?: Maybe<BoolNullableWithAggregatesFilter>;
  presetPassword?: Maybe<BoolNullableWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  carloUsername?: Maybe<StringNullableWithAggregatesFilter>;
  ingresUsername?: Maybe<StringNullableWithAggregatesFilter>;
  selectedCompanyId?: Maybe<StringNullableWithAggregatesFilter>;
  isAdmin?: Maybe<BoolWithAggregatesFilter>;
};

export type UserUpdateInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  password?: Maybe<NullableStringFieldUpdateOperationsInput>;
  tokenSalt?: Maybe<StringFieldUpdateOperationsInput>;
  firstName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isAd?: Maybe<BoolFieldUpdateOperationsInput>;
  deliveryNotesVisitor?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  presetPassword?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  carloUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  selectedCompany?: Maybe<CompanyUpdateOneWithoutSelectedCompaniesNestedInput>;
  isAdmin?: Maybe<BoolFieldUpdateOperationsInput>;
  orders?: Maybe<OrderUpdateManyWithoutUserNestedInput>;
  companies?: Maybe<UserRelCompanyUpdateManyWithoutUserNestedInput>;
  userDefaultValues?: Maybe<UserDefaultValueUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateManyMutationInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  password?: Maybe<NullableStringFieldUpdateOperationsInput>;
  tokenSalt?: Maybe<StringFieldUpdateOperationsInput>;
  firstName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isAd?: Maybe<BoolFieldUpdateOperationsInput>;
  deliveryNotesVisitor?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  presetPassword?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  carloUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isAdmin?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithWhereWithoutSelectedCompanyInput = {
  where: UserScalarWhereInput;
  data: UserUpdateManyMutationInput;
};

export type UserUpdateManyWithoutSelectedCompanyNestedInput = {
  create?: Maybe<Array<UserCreateWithoutSelectedCompanyInput>>;
  connectOrCreate?: Maybe<
    Array<UserCreateOrConnectWithoutSelectedCompanyInput>
  >;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutSelectedCompanyInput>>;
  createMany?: Maybe<UserCreateManySelectedCompanyInputEnvelope>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutSelectedCompanyInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutSelectedCompanyInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
};

export type UserUpdateOneWithoutCompaniesNestedInput = {
  create?: Maybe<UserCreateWithoutCompaniesInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCompaniesInput>;
  upsert?: Maybe<UserUpsertWithoutCompaniesInput>;
  disconnect?: Maybe<Scalars["Boolean"]>;
  delete?: Maybe<Scalars["Boolean"]>;
  connect?: Maybe<UserWhereUniqueInput>;
  update?: Maybe<UserUpdateWithoutCompaniesInput>;
};

export type UserUpdateOneWithoutOrdersNestedInput = {
  create?: Maybe<UserCreateWithoutOrdersInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutOrdersInput>;
  upsert?: Maybe<UserUpsertWithoutOrdersInput>;
  disconnect?: Maybe<Scalars["Boolean"]>;
  delete?: Maybe<Scalars["Boolean"]>;
  connect?: Maybe<UserWhereUniqueInput>;
  update?: Maybe<UserUpdateWithoutOrdersInput>;
};

export type UserUpdateOneWithoutUserDefaultValuesNestedInput = {
  create?: Maybe<UserCreateWithoutUserDefaultValuesInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserDefaultValuesInput>;
  upsert?: Maybe<UserUpsertWithoutUserDefaultValuesInput>;
  disconnect?: Maybe<Scalars["Boolean"]>;
  delete?: Maybe<Scalars["Boolean"]>;
  connect?: Maybe<UserWhereUniqueInput>;
  update?: Maybe<UserUpdateWithoutUserDefaultValuesInput>;
};

export type UserUpdateWithWhereUniqueWithoutSelectedCompanyInput = {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutSelectedCompanyInput;
};

export type UserUpdateWithoutCompaniesInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  password?: Maybe<NullableStringFieldUpdateOperationsInput>;
  tokenSalt?: Maybe<StringFieldUpdateOperationsInput>;
  firstName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isAd?: Maybe<BoolFieldUpdateOperationsInput>;
  deliveryNotesVisitor?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  presetPassword?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  carloUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  selectedCompany?: Maybe<CompanyUpdateOneWithoutSelectedCompaniesNestedInput>;
  isAdmin?: Maybe<BoolFieldUpdateOperationsInput>;
  orders?: Maybe<OrderUpdateManyWithoutUserNestedInput>;
  userDefaultValues?: Maybe<UserDefaultValueUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutOrdersInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  password?: Maybe<NullableStringFieldUpdateOperationsInput>;
  tokenSalt?: Maybe<StringFieldUpdateOperationsInput>;
  firstName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isAd?: Maybe<BoolFieldUpdateOperationsInput>;
  deliveryNotesVisitor?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  presetPassword?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  carloUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  selectedCompany?: Maybe<CompanyUpdateOneWithoutSelectedCompaniesNestedInput>;
  isAdmin?: Maybe<BoolFieldUpdateOperationsInput>;
  companies?: Maybe<UserRelCompanyUpdateManyWithoutUserNestedInput>;
  userDefaultValues?: Maybe<UserDefaultValueUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutSelectedCompanyInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  password?: Maybe<NullableStringFieldUpdateOperationsInput>;
  tokenSalt?: Maybe<StringFieldUpdateOperationsInput>;
  firstName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isAd?: Maybe<BoolFieldUpdateOperationsInput>;
  deliveryNotesVisitor?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  presetPassword?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  carloUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isAdmin?: Maybe<BoolFieldUpdateOperationsInput>;
  orders?: Maybe<OrderUpdateManyWithoutUserNestedInput>;
  companies?: Maybe<UserRelCompanyUpdateManyWithoutUserNestedInput>;
  userDefaultValues?: Maybe<UserDefaultValueUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserDefaultValuesInput = {
  id?: Maybe<StringFieldUpdateOperationsInput>;
  password?: Maybe<NullableStringFieldUpdateOperationsInput>;
  tokenSalt?: Maybe<StringFieldUpdateOperationsInput>;
  firstName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isAd?: Maybe<BoolFieldUpdateOperationsInput>;
  deliveryNotesVisitor?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  presetPassword?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  carloUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ingresUsername?: Maybe<NullableStringFieldUpdateOperationsInput>;
  selectedCompany?: Maybe<CompanyUpdateOneWithoutSelectedCompaniesNestedInput>;
  isAdmin?: Maybe<BoolFieldUpdateOperationsInput>;
  orders?: Maybe<OrderUpdateManyWithoutUserNestedInput>;
  companies?: Maybe<UserRelCompanyUpdateManyWithoutUserNestedInput>;
};

export type UserUpsertWithWhereUniqueWithoutSelectedCompanyInput = {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutSelectedCompanyInput;
  create: UserCreateWithoutSelectedCompanyInput;
};

export type UserUpsertWithoutCompaniesInput = {
  update: UserUpdateWithoutCompaniesInput;
  create: UserCreateWithoutCompaniesInput;
};

export type UserUpsertWithoutOrdersInput = {
  update: UserUpdateWithoutOrdersInput;
  create: UserCreateWithoutOrdersInput;
};

export type UserUpsertWithoutUserDefaultValuesInput = {
  update: UserUpdateWithoutUserDefaultValuesInput;
  create: UserCreateWithoutUserDefaultValuesInput;
};

export type UserWhereInput = {
  AND?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  NOT?: Maybe<Array<UserWhereInput>>;
  id?: Maybe<StringFilter>;
  password?: Maybe<StringNullableFilter>;
  tokenSalt?: Maybe<StringFilter>;
  firstName?: Maybe<StringNullableFilter>;
  lastName?: Maybe<StringNullableFilter>;
  email?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  isAd?: Maybe<BoolFilter>;
  deliveryNotesVisitor?: Maybe<BoolNullableFilter>;
  presetPassword?: Maybe<BoolNullableFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  carloUsername?: Maybe<StringNullableFilter>;
  ingresUsername?: Maybe<StringNullableFilter>;
  selectedCompany?: Maybe<CompanyRelationFilter>;
  selectedCompanyId?: Maybe<StringNullableFilter>;
  isAdmin?: Maybe<BoolFilter>;
  orders?: Maybe<OrderListRelationFilter>;
  companies?: Maybe<UserRelCompanyListRelationFilter>;
  userDefaultValues?: Maybe<UserDefaultValueListRelationFilter>;
};

export type UserWhereUniqueInput = {
  id?: Maybe<Scalars["String"]>;
};
